import { IsoCountryCode } from 'utils/form/constants';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  DateTime: any;
}



/** A First Data or Adyen account (payment method) will have either credit or prepaid but not both */
export interface IAccount {
  readonly __typename?: 'Account';
  /** Unique identifier for the account type object */
  readonly id: Scalars['ID'];
  /**
   * Common PSP payment method identifier and Adyen account identifier.
   * @deprecated no longer used
   */
  readonly accountIdentifier: Scalars['String'];
  /**
   * Orbital account stored payment method id
   * @deprecated no longer used
   */
  readonly orbitalIdentifier?: Maybe<Scalars['String']>;
  /**
   * First Data account ID
   * @deprecated no longer used
   */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Used for making cc direct payments with chase (TH) */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  readonly credit?: Maybe<ICreditCard>;
  readonly isExpired?: Maybe<Scalars['Boolean']>;
  readonly prepaid?: Maybe<IGiftCard>;
  /** @deprecated paypal is not supported */
  readonly paypal?: Maybe<Scalars['Boolean']>;
  /** @deprecated paypal is not supported */
  readonly paypalIdentifier?: Maybe<Scalars['String']>;
}

export interface IAccountDeleteInput {
  readonly id: Scalars['ID'];
}

export interface IAccountDeletePayload {
  readonly __typename?: 'AccountDeletePayload';
  /** The updated user entity after account deletion */
  readonly user: IUser;
}

export interface IAccountListResponse {
  readonly __typename?: 'AccountListResponse';
  readonly count: Scalars['Int'];
  readonly accounts?: Maybe<ReadonlyArray<Maybe<IAccount>>>;
  readonly defaultAccount?: Maybe<IAccount>;
  readonly paymentProcessor?: Maybe<PaymentProcessor>;
}

/** Add a First Data account (payment method) for the current user */
export interface IAddAccountInput {
  /** billingAddress associated to card */
  readonly billingAddress?: Maybe<IBillingAddressInput>;
  /** Access token which was used to request nonce */
  readonly fdAccessToken: Scalars['String'];
  /** Nonce provided by FD linking to the new payment method */
  readonly fdNonce: Scalars['String'];
  /** First 6 digits of credit card */
  readonly ccBin: Scalars['String'];
  /** Name On Card */
  readonly fullName?: Maybe<Scalars['String']>;
  /** cc token from tokenex required for chase direct pay enrollment */
  readonly ccToken?: Maybe<Scalars['String']>;
  /** chase id from TH endpoint to add to DynamoDB */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  /** cc security code */
  readonly cvv?: Maybe<Scalars['String']>;
  /**
   * Session ID as set by the FE. This should be derived from mParticle.
   *  @deprecated(reason: "mParticle deprecated and transitioning to AEP")
   */
  readonly sessionId?: Maybe<Scalars['String']>;
  /** Make this new account the user's default account */
  readonly makeDefault?: Maybe<Scalars['Boolean']>;
  /** threeDSOptions to resume account creation */
  readonly threeDSOptions?: Maybe<IThreeDsOptions>;
}

/** Add Adyen (payment method) for the current user */
export interface IAddAdyenAccountInput {
  /** Encrypted Payment Payload */
  readonly encryptedPayload: IAdyenEncryptedInfo;
}

/** Add payment method for the current user */
export interface IAddCreditAccountInput {
  readonly adyenInput?: Maybe<IAddAdyenAccountInput>;
  /** billingAddress associated to card */
  readonly billingAddress: IBillingAddressInput;
  readonly firstDataInput?: Maybe<IAddAccountInput>;
  readonly orbitalInput?: Maybe<IAddOrbitalAccountInput>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  readonly worldpayInput?: Maybe<IAddWorldpayAccountInput>;
}

export interface IAddGiftAccountInput {
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /**
   * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
   */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Details from Apple Pay for funding. */
  readonly applePayDetails?: Maybe<IApplePay>;
  /** Details from Goole Pay for funding. */
  readonly googlePayDetails?: Maybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: Maybe<Scalars['String']>;
  /**
   * Session ID as set by the FE.
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: Maybe<Scalars['String']>;
}

/** Add Orbital (payment method) for the current user */
export interface IAddOrbitalAccountInput {
  readonly encryptedCardNum: Scalars['String'];
  readonly encryptedCvv: Scalars['String'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly pieFormat: Scalars['String'];
  readonly pieMode: Scalars['String'];
  readonly piePhaseId: Scalars['String'];
  readonly pieIntegrityCheck: Scalars['String'];
  readonly pieSubscriberId: Scalars['String'];
  readonly pieKeyID: Scalars['String'];
  readonly cardBrand: Scalars['String'];
  readonly bin: Scalars['String'];
}

/** Add Worldpay (payment method) for the current user */
export interface IAddWorldpayAccountInput {
  readonly lowValueToken: Scalars['String'];
  readonly bin: Scalars['String'];
  readonly last4: Scalars['String'];
  readonly cardBrand: Scalars['String'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
}

export interface IAdyenEncryptedInfo {
  /** Encrypted credit card number */
  readonly encryptedCN: Scalars['String'];
  /** Encrypted credit card expiry month */
  readonly encryptedEM: Scalars['String'];
  /** Encrypted credit card expiry year */
  readonly encryptedEY: Scalars['String'];
  /** Encrypted credit card security code */
  readonly encryptedSC: Scalars['String'];
}

export interface IAdyenPayment {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
   */
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  /** Encrypted Payment Payload. If accountIdentifier is not passed this will be used. */
  readonly encryptedPayload?: Maybe<IAdyenEncryptedInfo>;
  /** Denotes the payment type */
  readonly paymentType?: Maybe<AdyenPaymentType>;
  /** When true, payment details will be saved as a recurring payment method in Adyen */
  readonly savePaymentMethod?: Maybe<Scalars['Boolean']>;
}

export enum AdyenPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  TOKENIZED_CREDIT_CARD = 'TOKENIZED_CREDIT_CARD'
}

export interface IApiMetadata {
  readonly __typename?: 'ApiMetadata';
  /** Pong! Simple health check. */
  readonly ping: Scalars['String'];
}

/** Details from Apple Pay used for Apple Pay funding. */
export interface IApplePay {
  /** Signature as passed through from Apple Pay */
  readonly signature: Scalars['String'];
  /** Application data as passed through from Apple Pay */
  readonly applicationData: Scalars['String'];
  /** part of the billing address from apple pay */
  readonly country: CountryCode;
  readonly data: Scalars['String'];
  readonly decryptAlias: Scalars['String'];
  readonly ephemeralPublicKey: Scalars['String'];
  readonly formatted: Scalars['String'];
  readonly primary: Scalars['Boolean'];
  readonly publicKeyHash: Scalars['String'];
  readonly transactionId: Scalars['String'];
  /** type of the billing address set in apple pay e.g. work, home, etc */
  readonly type: Scalars['String'];
  readonly version: Scalars['String'];
  readonly billingAddress: IBillingAddressInput;
  /** bundle all apple pay details into an encrypted token. */
  readonly paymentData?: Maybe<Scalars['String']>;
  /** Data of the payment method used for Apple Pay. */
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>;
}

/** Apple Pay details from the payments subgraph. */
export interface IApplePayDetails {
  readonly billingContact?: Maybe<Scalars['String']>;
  readonly paymentData?: Maybe<Scalars['String']>;
  readonly paymentMethod?: Maybe<IPaymentMethodInput>;
}

export interface IAppliedOffer {
  readonly id?: Maybe<Scalars['ID']>;
  readonly cartId?: Maybe<Scalars['ID']>;
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly swap?: Maybe<ISwapInput>;
  readonly type?: Maybe<OfferType>;
}

export interface IAppliedReward {
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

/** The minimum app version required of our guests */
export interface IAppMinimumVersion {
  readonly __typename?: 'AppMinimumVersion';
  /** The semantic version of the minimum app version. */
  readonly version: Scalars['String'];
  /** The message to be displayed to the user. */
  readonly userMessage?: Maybe<Scalars['String']>;
  /** The URL to the Play Store listing of the app. */
  readonly playStoreUrl: Scalars['String'];
  /** The URL to the App Store listing of the app. */
  readonly appStoreUrl: Scalars['String'];
}

export interface IAppMinimumVersionInput {
  readonly language?: Maybe<Scalars['String']>;
}

/** Additional details about the availability decision */
export interface IAvailabilityDetails {
  readonly __typename?: 'AvailabilityDetails';
  /** ID of the protection rule that affected the decision (if any) */
  readonly protectionRuleId?: Maybe<Scalars['String']>;
  /** ID of the override that affected the decision (if any) */
  readonly overrideId?: Maybe<Scalars['String']>;
  /** ID of the time card that affected the decision (if any) */
  readonly timeCardId?: Maybe<Scalars['String']>;
  /** Additional context for debugging */
  readonly note?: Maybe<Scalars['String']>;
}

/**
 * Reason codes for product availability status.
 * Based on 5-layer precedence hierarchy:
 * 1. DENYLIST - Protection rule denies the SKU
 * 2. OVERRIDE_UNAVAILABLE - Explicit override makes SKU unavailable
 * 3. ALLOWLIST - Protection rule allows the SKU
 * 4. TIME_CARD - Time card indicates SKU is available
 * 5. DEFAULT_UNAVAILABLE - No time card found, defaults to unavailable
 */
export enum AvailabilityReason {
  /** Layer 1: Protection rule denies this SKU */
  DENYLIST = 'DENYLIST',
  /** Layer 2: Explicit override makes this SKU unavailable */
  OVERRIDE_UNAVAILABLE = 'OVERRIDE_UNAVAILABLE',
  /** Layer 3: Protection rule allows this SKU */
  ALLOWLIST = 'ALLOWLIST',
  /** Layer 4: Time card indicates this SKU is available */
  TIME_CARD = 'TIME_CARD',
  /** Layer 5: No time card found, defaults to unavailable */
  DEFAULT_UNAVAILABLE = 'DEFAULT_UNAVAILABLE'
}

/** A Prepaid balance response (payment method) */
export interface IBalance {
  readonly __typename?: 'Balance';
  /** gift card last 4 digits */
  readonly alias: Scalars['String'];
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in cents */
  readonly currentBalance: Scalars['Int'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
}

export interface IBarcode {
  readonly __typename?: 'Barcode';
  /** Either a Loyalty base barcode, or the S&P barcode */
  readonly value: Scalars['String'];
  /**
   * ISO 8601 timestamp representing the expiration time of the S&P barcode.
   * This is only returned for S&P barcodes, and is null for the Loyalty base barcode
   */
  readonly expiresAt?: Maybe<Scalars['String']>;
}

export interface IBillingAddress {
  readonly __typename?: 'BillingAddress';
  /** City */
  readonly locality: Scalars['String'];
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region: Scalars['String'];
  /** Street Address */
  readonly streetAddress: Scalars['String'];
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<Scalars['String']>;
  /** Country */
  readonly country?: Maybe<Scalars['String']>;
}

export interface IBillingAddressInput {
  /** City */
  readonly locality?: Maybe<Scalars['String']>;
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region?: Maybe<Scalars['String']>;
  /** Street Address */
  readonly streetAddress?: Maybe<Scalars['String']>;
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<Scalars['String']>;
  /** Country */
  readonly country?: Maybe<Scalars['String']>;
}

export enum Brand {
  BK = 'BK',
  LTW = 'LTW',
  PLK = 'PLK',
  TH = 'TH',
  FHS = 'FHS'
}

export enum CacheControlScope {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export interface ICalories {
  readonly __typename?: 'Calories';
  readonly default?: Maybe<Scalars['Int']>;
  readonly max?: Maybe<Scalars['Int']>;
  readonly min?: Maybe<Scalars['Int']>;
}

export interface ICardAmount {
  readonly __typename?: 'CardAmount';
  readonly key?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
}

export interface ICardAmountMap {
  readonly __typename?: 'CardAmountMap';
  readonly cardAmount?: Maybe<ReadonlyArray<Maybe<ICardAmount>>>;
}

export enum CardBrand {
  VISA = 'VISA',
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  DINERS_CLUB = 'DINERS_CLUB',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD'
}

export interface ICart {
  readonly __typename?: 'Cart';
  readonly brand: Brand;
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  /**
   * Cart entries for reordering.
   * This is usually the same as cartEntries except for when there are swaps.
   */
  readonly reorderCartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  readonly cartVersion?: Maybe<Scalars['Int']>;
  readonly customerLocale?: Maybe<Scalars['String']>;
  readonly customerName: Scalars['String'];
  readonly deviceOS?: Maybe<Scalars['String']>;
  readonly discounts?: Maybe<ReadonlyArray<Maybe<IDiscount>>>;
  readonly donations?: Maybe<ReadonlyArray<Maybe<IDonation>>>;
  readonly fees?: Maybe<ReadonlyArray<Maybe<IFees>>>;
  /** All evaluated offers in the cart, or all the offers supplied against the cart. */
  readonly offersFeedback?: Maybe<ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>>;
  readonly payment?: Maybe<IPayment>;
  readonly platform?: Maybe<Platform>;
  readonly posVendor: PosVendor;
  /**
   * ISO Timestamp from POS in local timezone e.g 2019-07-08T23:02:17.203Z
   * @deprecated Only for internal use
   */
  readonly processedAt?: Maybe<Scalars['String']>;
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<ICartAppliedOffer>>>;
  readonly requestedAmountCents: Scalars['Int'];
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<ICartAppliedReward>>>;
  readonly serviceMode: ServiceMode;
  readonly storeAddress: IStoreAddress;
  readonly storeDetails?: Maybe<IStoreDetails>;
  readonly storeId: Scalars['String'];
  readonly storePosId?: Maybe<Scalars['String']>;
  /** @deprecated Not needed anymore since it is included in AppliedOffer */
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ICartSwap>>>;
  readonly subTotalCents?: Maybe<Scalars['Int']>;
  readonly taxCents?: Maybe<Scalars['Int']>;
  readonly ticketNumber?: Maybe<Scalars['String']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
  readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<IUnavailableCartEntry>>>;
  readonly userId?: Maybe<Scalars['String']>;
  readonly wasLoyaltyEarned?: Maybe<Scalars['Boolean']>;
  readonly vatNumber?: Maybe<Scalars['String']>;
}

export interface ICartAppliedOffer {
  readonly __typename?: 'CartAppliedOffer';
  readonly id: Scalars['ID'];
  readonly cartId?: Maybe<Scalars['ID']>;
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly swap?: Maybe<ICartSwap>;
  readonly type: OfferType;
}

/** AppliedReward is duplicated here to avoid breaking changes as above definition serves as an input. */
export interface ICartAppliedReward {
  readonly __typename?: 'CartAppliedReward';
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ICartEntries {
  readonly __typename?: 'CartEntries';
  readonly children?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly image?: Maybe<Scalars['String']>;
  readonly lineId: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly offerVendorConfigs?: Maybe<IVendorConfigs>;
  readonly pickerSelections?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<IPlu>;
  readonly price?: Maybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly redeemable?: Maybe<Scalars['Boolean']>;
  readonly isExtra?: Maybe<Scalars['Boolean']>;
  readonly isInMenu?: Maybe<Scalars['Boolean']>;
  readonly isDonation?: Maybe<Scalars['Boolean']>;
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly url?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface ICartEntryInput {
  readonly children?: Maybe<ReadonlyArray<ICartEntryInput>>;
  readonly image?: Maybe<Scalars['String']>;
  readonly lineId: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly pickerSelections?: Maybe<Scalars['String']>;
  readonly price?: Maybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly isExtra?: Maybe<Scalars['Boolean']>;
  readonly isDonation?: Maybe<Scalars['Boolean']>;
  readonly url?: Maybe<Scalars['String']>;
  readonly offerVendorConfigs?: Maybe<IVendorConfigsInput>;
  readonly plu?: Maybe<IPluInput>;
  readonly vendorConfigs?: Maybe<IVendorConfigsInput>;
  readonly productHierarchy?: Maybe<IProductHierarchyInput>;
  readonly markerItemPlu?: Maybe<Scalars['String']>;
}

export enum CartEntryType {
  COMBO = 'Combo',
  COMBOSLOT = 'ComboSlot',
  ITEM = 'Item',
  ITEMOPTION = 'ItemOption',
  ITEMOPTIONMODIFIER = 'ItemOptionModifier',
  OFFERCOMBO = 'OfferCombo',
  OFFERDISCOUNT = 'OfferDiscount',
  OFFERITEM = 'OfferItem'
}

export interface ICartFee {
  readonly __typename?: 'CartFee';
  readonly type: CartFeeType;
  readonly quantity: Scalars['Int'];
  readonly total: IMoney;
}

export enum CartFeeType {
  SINGLE_USE_CUP_FEE = 'SINGLE_USE_CUP_FEE',
  DEPOSIT = 'DEPOSIT',
  RECYCLING = 'RECYCLING'
}

export enum CartOfferState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  INACTIVE = 'INACTIVE'
}

export enum CartPaymentCardType {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERS = 'DINERS',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
  GIFT_CARD = 'GIFT_CARD',
  PAYPAL = 'PAYPAL'
}

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT'
}

export interface ICartSwap {
  readonly __typename?: 'CartSwap';
  readonly from: Scalars['String'];
  readonly to: Scalars['String'];
  readonly cartId: Scalars['String'];
  readonly swapType: Scalars['String'];
}

export interface ICatalogue {
  readonly __typename?: 'Catalogue';
  /** A simple message */
  readonly message?: Maybe<Scalars['String']>;
}

export interface ICatering {
  readonly __typename?: 'Catering';
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  readonly includeUtensils: Scalars['Boolean'];
  readonly maskedPhoneNumber?: Maybe<Scalars['String']>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly numberOfGuests: Scalars['Int'];
  readonly organizerName: Scalars['String'];
  readonly pickupEmail: Scalars['String'];
  readonly pickupPhoneNumber: Scalars['String'];
  readonly pickupTime: Scalars['String'];
}

export enum CateringDecision {
  ACCEPT = 'Accept',
  DECLINE = 'Decline'
}

export enum CateringDeclineReasons {
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVENTORY = 'INVENTORY',
  STAFFING = 'STAFFING',
  TIMING = 'TIMING'
}

export interface ICateringInfoInput {
  /**
   * Pickup Time - in ISO format.
   * Only ISO-formatted datetime values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly pickupTime: Scalars['String'];
}

export enum Channel {
  APP = 'app',
  WHITELABEL = 'whitelabel',
  GFO = 'gfo',
  CATERING = 'catering',
  WAITR = 'waitr',
  SKIP = 'skip',
  UBER = 'uber',
  BITENINJA = 'biteninja',
  DOORDASH = 'doordash',
  GRUBHUB = 'grubhub'
}

export interface ICognitoCredentials {
  readonly __typename?: 'CognitoCredentials';
  readonly sessionId: Scalars['String'];
  readonly challengeCode: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
}

export interface ICommitDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>;
  /** boolean flag to mark notification setting */
  readonly pushNotification?: Maybe<Scalars['Boolean']>;
  readonly tipCents?: Maybe<Scalars['Int']>;
  /**
   * drop off location for delivery (user's address)
   * this can be marked as required when launch darkly
   * flag is no longer in use
   *
   * @deprecated(reason: "needs to be named dropoff")
   */
  readonly dropOff?: Maybe<IDeliveryWaypointInput>;
  readonly dropoff?: Maybe<IDeliveryWaypointInput>;
}

export interface ICommitOrderInput {
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   * @deprecated(reason: "Use payment object")
   */
  readonly billingAddress?: Maybe<IBillingAddressInput>;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: Maybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry month
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry year
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryYear?: Maybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: Maybe<Scalars['String']>;
  /**
   * chase id from TH endpoint to trigger direct payment
   * @deprecated(reason: "Use payment object")
   */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  /**
   * The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX)
   * @deprecated(reason: "Use payment object")
   */
  readonly creditType?: Maybe<CartPaymentCardType>;
  /** Store email address */
  readonly storeEmail?: Maybe<Scalars['String']>;
  /**
   * Valid access token for accessing First Data API
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccessToken?: Maybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdNonce?: Maybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: Maybe<Scalars['Int']>;
  /**
   * Customer full name
   * @deprecated(reason: "Use payment object")
   */
  readonly fullName?: Maybe<Scalars['String']>;
  /** Contains information to submit payment for this order */
  readonly payment?: Maybe<IPaymentInput>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * @deprecated(reason: "Use payment object")
   */
  readonly kountSessionId?: Maybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * @deprecated(reason: "Use kountSessionId on payment object")
   */
  readonly sessionId?: Maybe<Scalars['String']>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /**
   * Details from Apple Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly applePayDetails?: Maybe<IApplePay>;
  /**
   * Details from Google Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly googlePayDetails?: Maybe<IGooglePay>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: Maybe<IResumeThreeDSaleTransaction>;
  /** Service mode to override the order's current service mode */
  readonly serviceMode?: Maybe<ServiceMode>;
}

/**
 * Preferred language for outbound communications to the user (marketing emails,
 * transactional emails, SMS, push, and one-time-passcode messages).
 */
export enum CommunicationLanguage {
  EN = 'EN',
  FR = 'FR'
}

export interface ICommunicationPreference {
  readonly __typename?: 'CommunicationPreference';
  /** Database id of the preference (i.e. language) */
  readonly id?: Maybe<Scalars['String']>;
  /** Value the preference is set to */
  readonly value?: Maybe<Scalars['String']>;
}

/**
 * The user's marketing-communication opt-ins and preferred language.
 *
 * Notifications managed by other domains — order status, loyalty, and the
 * legacy `promotionalEmails` flag — are intentionally not modelled here.
 */
export interface ICommunicationPreferences {
  readonly __typename?: 'CommunicationPreferences';
  /**
   * Whether the user has opted in to marketing and rewards emails. The two
   * categories are always toggled together.
   */
  readonly emailOptIn?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the user has opted in to marketing and rewards push notifications.
   * The two categories are always toggled together.
   */
  readonly pushOptIn?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the user has opted in to sharing personal data with third
   * parties for personalised advertising — the "Ads Personalization" toggle
   * in Account Settings. Independent of `emailOptIn` and `pushOptIn`.
   * Returns `false` when no value has been recorded for the user yet.
   */
  readonly thirdPartyDataSharingOptIn?: Maybe<Scalars['Boolean']>;
  /**
   * Preferred language for marketing emails, transactional emails, SMS, push,
   * and one-time-passcode messages. Defaults to `EN` when no value has been
   * recorded for the user yet.
   */
  readonly language: CommunicationLanguage;
}

/**
 * Update the authenticated user's communication preferences.
 *
 * All fields are optional — only the values you send are changed; the rest
 * are preserved. Sending no fields is a no-op success.
 */
export interface ICommunicationPreferencesUpdateInput {
  readonly emailOptIn?: Maybe<Scalars['Boolean']>;
  readonly pushOptIn?: Maybe<Scalars['Boolean']>;
  readonly thirdPartyDataSharingOptIn?: Maybe<Scalars['Boolean']>;
  readonly language?: Maybe<CommunicationLanguage>;
}

export interface ICommunicationPreferencesUpdatePayload {
  readonly __typename?: 'CommunicationPreferencesUpdatePayload';
  readonly user?: Maybe<IUser>;
  readonly userErrors: ReadonlyArray<IUserError>;
}

/** Payload of `completeLinking`. */
export interface ICompleteLinkingResponse {
  readonly __typename?: 'CompleteLinkingResponse';
  /**
   * True once the LINKED row has been persisted and CT has confirmed
   * the link-id registration.
   */
  readonly success: Scalars['Boolean'];
}

export interface IConfirmCateringOrderInput {
  /** Catering JWT containing catering order info */
  readonly cateringJwt: Scalars['String'];
  /** Accept or Decline Order */
  readonly decision: CateringDecision;
  /** Decline Reason */
  readonly declineReason?: Maybe<CateringDeclineReasons>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 *
 * A connection as defined by the GraphQL Cursor Connections Specifications
 *
 * Provides totalCount if there is an efficient way to determine the total
 * pre-paginated results.
 *
 * Provides an array of nodes for consumers that do not need each node's cursor.
 */
export interface IConnection {
  readonly edges: ReadonlyArray<IEdge>;
  readonly nodes: ReadonlyArray<INode>;
  readonly pageInfo: IPageInfo;
  readonly totalCount?: Maybe<Scalars['Int']>;
}

export interface IConsumerBundlePricing {
  readonly __typename?: 'ConsumerBundlePricing';
  readonly basePriceCents: Scalars['Int'];
  readonly baseQuantity: Scalars['Int'];
  readonly steps: ReadonlyArray<IConsumerBundleStep>;
}

export interface IConsumerBundleStep {
  readonly __typename?: 'ConsumerBundleStep';
  readonly quantity: Scalars['Int'];
  readonly priceCents: Scalars['Int'];
}

/** Calorie range information for a menu item. */
export interface IConsumerCalorieRange {
  readonly __typename?: 'ConsumerCalorieRange';
  /** Default calorie count. */
  readonly default: Scalars['Int'];
  /** Minimum calories across variants. Null when not available. */
  readonly min?: Maybe<Scalars['Int']>;
  /** Maximum calories across variants. Null when not available. */
  readonly max?: Maybe<Scalars['Int']>;
}

/**
 * A daypart definition on the consumer menu.
 * Represents a time-of-day window during which a subset of menu items is available.
 * The mobile app uses this to render daypart tabs (e.g., "Breakfast", "Lunch").
 */
export interface IConsumerDaypart {
  readonly __typename?: 'ConsumerDaypart';
  /** Synthetic key derived from the time range (e.g., "dp-0-660"). */
  readonly key: Scalars['String'];
  /** Start time in "HH:MM" format (e.g., "06:00"). */
  readonly startTime: Scalars['String'];
  /** End time in "HH:MM" format (e.g., "11:00"). */
  readonly endTime: Scalars['String'];
  /** Which days of the week this daypart is active. */
  readonly weekDays: IConsumerDaypartWeekDays;
  /**
   * Localized display name (e.g., "Breakfast"). Null until display metadata
   * is migrated from Sanity CMS to ordering-rds.
   */
  readonly displayName?: Maybe<Scalars['String']>;
  /**
   * URL of the daypart icon image. Null until display metadata
   * is migrated from Sanity CMS to ordering-rds.
   */
  readonly iconUrl?: Maybe<Scalars['String']>;
}

/** Days of the week when a daypart is active. */
export interface IConsumerDaypartWeekDays {
  readonly __typename?: 'ConsumerDaypartWeekDays';
  readonly monday: Scalars['Boolean'];
  readonly tuesday: Scalars['Boolean'];
  readonly wednesday: Scalars['Boolean'];
  readonly thursday: Scalars['Boolean'];
  readonly friday: Scalars['Boolean'];
  readonly saturday: Scalars['Boolean'];
  readonly sunday: Scalars['Boolean'];
}

export interface IConsumerMenuInput {
  readonly restaurantId: Scalars['Int'];
  readonly serviceMode: ServiceMode;
  /** ISO 8601 timestamp. Drives time-card evaluation and effective pricing. */
  readonly timestamp: Scalars['DateTime'];
}

export interface IConsumerMenuItem {
  readonly __typename?: 'ConsumerMenuItem';
  readonly sku: Scalars['String'];
  readonly name: Scalars['String'];
  readonly state: ConsumerMenuItemState;
  /** Null when state is SOLD_OUT. */
  readonly price?: Maybe<IConsumerResolvedPrice>;
  /** Null when state is SOLD_OUT. */
  readonly modifiers?: Maybe<ReadonlyArray<IConsumerResolvedModifier>>;
  /** Present only for bundle products. */
  readonly bundlePricing?: Maybe<IConsumerBundlePricing>;
  /** Why this item is in its current state. Useful for debugging. */
  readonly stateReason?: Maybe<Scalars['String']>;
  /** Calorie information for this item. Null when nutrition data is unavailable. */
  readonly calories?: Maybe<IConsumerCalorieRange>;
}

export enum ConsumerMenuItemState {
  /** Available and priced — guest can add to cart. */
  ORDERABLE = 'ORDERABLE',
  /** Unavailable but priced — show as sold out. */
  SOLD_OUT = 'SOLD_OUT'
}

export interface IConsumerMenuMetadata {
  readonly __typename?: 'ConsumerMenuMetadata';
  readonly totalItems: Scalars['Int'];
  readonly orderableCount: Scalars['Int'];
  readonly soldOutCount: Scalars['Int'];
  /** True if availability or pricing degraded gracefully. */
  readonly degraded: Scalars['Boolean'];
  readonly degradedReason?: Maybe<Scalars['String']>;
}

export interface IConsumerMenuResponse {
  readonly __typename?: 'ConsumerMenuResponse';
  readonly restaurantId: Scalars['Int'];
  readonly menuId: Scalars['Int'];
  readonly serviceMode: ServiceMode;
  readonly queriedAt: Scalars['DateTime'];
  readonly items: ReadonlyArray<IConsumerMenuItem>;
  /**
   * Distinct daypart windows for this menu, extracted from time-card rules.
   * Each entry represents a time-of-day window (e.g., breakfast, lunch)
   * during which certain items are available. Empty when no time cards
   * have daypart restrictions.
   */
  readonly dayParts: ReadonlyArray<IConsumerDaypart>;
  readonly metadata: IConsumerMenuMetadata;
}

export enum ConsumerModifierDefaultState {
  INCLUDED = 'INCLUDED',
  EXCLUDED = 'EXCLUDED',
  NOT_CONFIGURED = 'NOT_CONFIGURED'
}

export enum ConsumerPriceSource {
  REGIONAL = 'REGIONAL',
  OVERRIDE = 'OVERRIDE',
  BUNDLE = 'BUNDLE'
}

export interface IConsumerResolvedModifier {
  readonly __typename?: 'ConsumerResolvedModifier';
  readonly sku: Scalars['String'];
  readonly name: Scalars['String'];
  readonly available: Scalars['Boolean'];
  readonly defaultState: ConsumerModifierDefaultState;
  readonly priceCents: Scalars['Int'];
}

/**
 * Resolved price for a single SKU. Each variant of a multi-variant product is a
 * separate ConsumerMenuItem with its own price. The mobile app computes
 * presentation-level aggregations (e.g. "From \$X") client-side.
 */
export interface IConsumerResolvedPrice {
  readonly __typename?: 'ConsumerResolvedPrice';
  readonly basePriceCents: Scalars['Int'];
  /** Applied when serviceMode has an upcharge configured. */
  readonly upchargeCents: Scalars['Int'];
  readonly finalPriceCents: Scalars['Int'];
  /** Source of base price. */
  readonly priceSource: ConsumerPriceSource;
}

/**
 * Coordinates is used by restaurants search to filter
 * by a radius and the current user's coordinates
 */
export interface ICoordinates {
  readonly userLat?: Maybe<Scalars['Float']>;
  readonly userLng?: Maybe<Scalars['Float']>;
  readonly searchRadius?: Maybe<Scalars['Float']>;
}

export enum Country {
  CA = 'CA',
  US = 'US'
}

/** ***** Start of Legacy Typings ***** */
export enum CountryCode {
  CA = 'CA',
  CH = 'CH',
  GB = 'GB',
  US = 'US',
  ZA = 'ZA'
}

export interface ICoupon {
  readonly __typename?: 'Coupon';
  /** The coupon identity. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon expires.
   * If the value is null, then the coupon never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon was redeemed.
   * If the value is null, then the coupon has not yet been redeemed.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /**
   * The current revision number of the coupon row.
   * This value is incremented every time the row is updated.
   * If this value is zero, then the row has never been revised.
   */
  readonly revision: Scalars['Int'];
  /** The sort key, which contains the version. */
  readonly sk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon row was updated.
   * If this value matches the createdAt value, the row has never been updated.
   */
  readonly updatedAt: Scalars['String'];
  /** The identity of the user. */
  readonly userId: Scalars['ID'];
  /** An alternate sort value, allowing for ordering coupons by expiration. */
  readonly userSortKey: Scalars['String'];
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ICouponEvaluationFeedback {
  readonly __typename?: 'CouponEvaluationFeedback';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The result of evaluating one rule in a Coupon Rule Set. */
  readonly condition: Scalars['Boolean'];
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The number of seconds the coupon can be redeemed for, if applicable. */
  readonly redeemableForSeconds?: Maybe<Scalars['Int']>;
  /** The number of seconds before the coupon can be redeemed, if applicable. */
  readonly redeemableInSeconds?: Maybe<Scalars['Int']>;
  /** The ordinal index number of the rule set entry associated with this feedback, if provided. */
  readonly ruleSetIndex?: Maybe<Scalars['Int']>;
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
  /** The Sanity ID of this rule product or product category. */
  readonly sanityId?: Maybe<Scalars['String']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ICouponRedemptionEligibility {
  readonly __typename?: 'CouponRedemptionEligibility';
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** Any feedback provided during evaluation, further describing the condition. */
  readonly evaluationFeedback: ReadonlyArray<Maybe<ICouponEvaluationFeedback>>;
  /**
   * The overall redemption eligibility condition.
   * Only a Coupon Rule Set which can be parsed and is valid will potentially be redeemable.
   * If the offer is a Loyalty offer which is not active, then it will also not be redeemable.
   */
  readonly isRedeemable: Scalars['Boolean'];
  /**
   * Whether the Coupon Rule Set structure and data is valid for evaluation.
   * A Coupon Rule Set which is not valid is not redeemable.
   */
  readonly isValid: Scalars['Boolean'];
  /** The redemption eligibility includes the specified moment of redemption. */
  readonly redeemedOn: Scalars['String'];
  /** Any errors which were encountered during Coupon Rule Set validation. */
  readonly validationErrors: ReadonlyArray<Maybe<ICouponValidationError>>;
}

export interface ICouponToken {
  readonly __typename?: 'CouponToken';
  /** Brief description on the situation that caused coupon to be issued */
  readonly comments?: Maybe<Scalars['String']>;
  /** The coupon identity associated with the coupon token. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon token expires.
   * If the value is null, then the coupon token never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** Reason for issuing the coupon */
  readonly reason?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId?: Maybe<Scalars['String']>;
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail?: Maybe<Scalars['String']>;
  /** The identity of the coupon token. */
  readonly tokenId: Scalars['ID'];
  /** The identity of the user owning the coupon token. */
  readonly userId: Scalars['ID'];
}

export interface ICouponTokenListResponse {
  readonly __typename?: 'CouponTokenListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupon tokens.
   */
  readonly count: Scalars['Int'];
  /**
   * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
   */
  readonly resumeAfter?: Maybe<Scalars['String']>;
  /**
   * The set of coupon tokens retrieved.
   * If this array is empty, there were no matching coupon tokens.
   */
  readonly tokens: ReadonlyArray<Maybe<ICouponToken>>;
}

export interface ICouponUserOffersFeedback {
  readonly __typename?: 'CouponUserOffersFeedback';
  /** All the feedback collected. */
  readonly offersFeedback: ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ICouponUserOffersFeedbackEntry {
  readonly __typename?: 'CouponUserOffersFeedbackEntry';
  /**
   * If the offers evaluated are sourced from the cart, this is the cart entry offer.
   * Otherwise, this field is null.
   */
  readonly cartEntry?: Maybe<ICartEntries>;
  /**
   * The identity of the coupon.
   * This may be an empty string in the event there is no couponId.
   */
  readonly couponId: Scalars['String'];
  /** If truthy, then this offer was included by Loyalty. */
  readonly isLoyalty?: Maybe<Scalars['Boolean']>;
  /** The stringified sanity offer data. */
  readonly offerDetails?: Maybe<Scalars['String']>;
  /** The current state of the offer, if applicable. */
  readonly offerState?: Maybe<CartOfferState>;
  /** Templated variables for loyalty offer. */
  readonly offerVariables?: Maybe<ReadonlyArray<Maybe<IOfferVariable>>>;
  /**
   * A weight for the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this value may
   * be used to set priority status for the offer.
   */
  readonly rank?: Maybe<Scalars['Int']>;
  /** The eligibility of redemption for the coupon. */
  readonly redemptionEligibility: ICouponRedemptionEligibility;
  /**
   * The token identifier associated with the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this identifier can be used to activate an
   * offer which is not currently active.
   */
  readonly tokenId?: Maybe<Scalars['String']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ICouponValidationError {
  readonly __typename?: 'CouponValidationError';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
}

export interface ICreateOtp {
  readonly __typename?: 'CreateOTP';
  /**
   * The maximum validation attempts allowed for the created OTP
   * @deprecated Use maxValidateAttempts
   */
  readonly maxLoginAttempts: Scalars['Int'];
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'];
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'];
  /** Whether the login has been performed in US and requires redirection */
  readonly redirectToUS?: Maybe<Scalars['Boolean']>;
}

export interface ICreateOtpInput {
  /**
   * The email of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - only email is implemented at this time
   */
  readonly email?: Maybe<Scalars['String']>;
  /**
   * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
   */
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
  /**
   * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
   */
  readonly sessionId: Scalars['ID'];
}

export interface ICreateSmsOtp {
  readonly __typename?: 'CreateSmsOtp';
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'];
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'];
}

export interface ICreateSmsOtpInput {
  /**
   * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
   */
  readonly phoneNumber: Scalars['String'];
  /** Requestor's platform */
  readonly platform: Platform;
  /**
   * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
   */
  readonly sessionId: Scalars['ID'];
}

export interface ICreditCard {
  readonly __typename?: 'CreditCard';
  /** Credit card last 4 digits */
  readonly alias: Scalars['String'];
  /** @deprecated not used */
  readonly billingAddress?: Maybe<IBillingAddress>;
  /** Card Provider */
  readonly cardType: Scalars['String'];
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'];
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'];
  /** @deprecated not used */
  readonly fullName: Scalars['String'];
  /**
   * First Data credit card token.
   * Should be a numeric string, whose last 4 digits match the credit card alias.
   * @deprecated not used
   */
  readonly panToken?: Maybe<Scalars['String']>;
}

export interface ICreditCardMetadataInput {
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: Maybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: Maybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: Maybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: Maybe<CartPaymentCardType>;
}

export enum Currency {
  CAD = 'CAD',
  USD = 'USD'
}

/**  USD/840 CAD/124 */
export interface ICurrencyCode {
  readonly __typename?: 'CurrencyCode';
  readonly code: Scalars['String'];
  readonly number: Scalars['Int'];
}


export interface IDay {
  readonly __typename?: 'Day';
  readonly close?: Maybe<Scalars['String']>;
  readonly open?: Maybe<Scalars['String']>;
}

/** Display-ready hours for a single day. */
export interface IDayHours {
  readonly __typename?: 'DayHours';
  readonly day: DayOfWeek;
  /** Pre-formatted hours string: "6:00 AM - 10:00 PM", "Open 24 Hours", "Closed" */
  readonly hours: Scalars['String'];
}

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export interface IDayPart {
  readonly __typename?: 'DayPart';
  readonly key?: Maybe<Scalars['String']>;
  readonly displayName?: Maybe<Scalars['String']>;
  readonly hours?: Maybe<IOperatingHours>;
}

export interface IDeleteAccountInput {
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  readonly fdAccountId?: Maybe<Scalars['String']>;
}

/** Delete an account (payment method) from the current user */
export interface IDeletePaymentMethodInput {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * Use this field instead.
   */
  readonly storedPaymentMethodId: Scalars['String'];
}

export interface IDeletePaymentMethodPayload {
  readonly __typename?: 'DeletePaymentMethodPayload';
  readonly success: Scalars['Boolean'];
}

/** Payload of `delinkPartner`. */
export interface IDelinkResponse {
  readonly __typename?: 'DelinkResponse';
  /**
   * True once the DELINKED row has been persisted locally, even if the
   * partner notification was queued for async retry.
   */
  readonly success: Scalars['Boolean'];
  /**
   * ISO-8601 timestamp of the DELINKED row. Omitted when the call is a
   * no-op (user was already delinked).
   */
  readonly delinkedAt?: Maybe<Scalars['String']>;
}

export interface IDelivery {
  readonly __typename?: 'Delivery';
  readonly assignedFleetName?: Maybe<Scalars['String']>;
  readonly baseDeliveryFeeCents?: Maybe<Scalars['Int']>;
  readonly cancellation?: Maybe<IDeliveryCancellation>;
  readonly customerId?: Maybe<Scalars['String']>;
  readonly driver?: Maybe<IDeliveryDriver>;
  readonly dropoff: IDeliveryWaypoint;
  readonly estimateId?: Maybe<Scalars['String']>;
  readonly expiration?: Maybe<Scalars['String']>;
  readonly feeCents: Scalars['Int'];
  readonly feeDiscountCents?: Maybe<Scalars['Int']>;
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  readonly fleetId?: Maybe<Scalars['String']>;
  readonly geographicalFeeCents?: Maybe<Scalars['Int']>;
  readonly instructions?: Maybe<Scalars['String']>;
  readonly pickup: IDeliveryWaypoint;
  readonly quoteId?: Maybe<Scalars['String']>;
  readonly quotedFeeCents?: Maybe<Scalars['Int']>;
  readonly serviceFeeCents?: Maybe<Scalars['Int']>;
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly smallCartFeeCents?: Maybe<Scalars['Int']>;
  readonly status: DeliveryStatus;
  readonly task?: Maybe<IDeliveryTaskDetails>;
  readonly tipCents?: Maybe<Scalars['Int']>;
  readonly userId?: Maybe<Scalars['String']>;
}

export interface IDeliveryAddress {
  readonly __typename?: 'DeliveryAddress';
  /** Address Line limited to 150 chars */
  readonly addressLine1: Scalars['String'];
  /** Address Line 2 limited to 150 chars */
  readonly addressLine2?: Maybe<Scalars['String']>;
  /** city name limited to 150 chars */
  readonly city: Scalars['String'];
  /** Alias to identify an address e.g home, office etc */
  readonly alias?: Maybe<Scalars['String']>;
  /** isoCountryCode */
  readonly country?: Maybe<IsoCountryCode>;
  /** 10 digit phone number spaces don't matter */
  readonly phoneNumber: Scalars['String'];
  /** state abbreviation FL, GA, etc */
  readonly state?: Maybe<Scalars['String']>;
  /** zipCode 5-10 digits no spaces */
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly route?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
  readonly instructions?: Maybe<Scalars['String']>;
}

export interface IDeliveryAddressResponse {
  readonly __typename?: 'DeliveryAddressResponse';
  readonly deliveryAddresses?: Maybe<ReadonlyArray<IDeliveryAddress>>;
}

export interface IDeliveryCancellation {
  readonly __typename?: 'DeliveryCancellation';
  readonly description?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['Int']>;
  readonly text?: Maybe<Scalars['String']>;
}

export interface IDeliveryDriver {
  readonly __typename?: 'DeliveryDriver';
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly profileImageUrl?: Maybe<Scalars['String']>;
}

export interface IDeliveryDriverV2 {
  readonly __typename?: 'DeliveryDriverV2';
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
}

export interface IDeliveryDropoffV2 {
  readonly __typename?: 'DeliveryDropoffV2';
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly trackingUrl?: Maybe<Scalars['String']>;
  readonly instructions?: Maybe<Scalars['String']>;
}

export interface IDeliveryFees {
  readonly __typename?: 'DeliveryFees';
  readonly belowMinimumDeliverySubtotal: Scalars['Boolean'];
  readonly baseFee?: Maybe<IMoney>;
  readonly serviceFee?: Maybe<IMoney>;
  readonly smallCartFee?: Maybe<IMoney>;
  readonly tip?: Maybe<IMoney>;
}

export enum DeliveryMethod {
  CONTACTLESS = 'CONTACTLESS'
}

export interface IDeliveryPickupV2 {
  readonly __typename?: 'DeliveryPickupV2';
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly trackingUrl?: Maybe<Scalars['String']>;
  readonly route?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
}

export interface IDeliveryRestaurant {
  readonly __typename?: 'DeliveryRestaurant';
  /** Extended restaurant data containing all fields from Sanity + Dynamo */
  readonly restaurant?: Maybe<IRestaurantNode>;
  /** Status of delivery store */
  readonly storeStatus: DeliveryStoreStatus;
  /** Status of delivery order */
  readonly quote?: Maybe<DeliveryStatus>;
  /** Next available delivery time for store */
  readonly nextEarliestOpen?: Maybe<Scalars['String']>;
  /** Restaurant delivery surcharge fee cents. */
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  /** the quoteId related to the current delivery restaurant */
  readonly quoteId?: Maybe<Scalars['String']>;
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStatusV2 {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStoreStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  NO_DELIVERY = 'NO_DELIVERY'
}

export interface IDeliveryTaskDetails {
  readonly __typename?: 'DeliveryTaskDetails';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly uuid?: Maybe<Scalars['String']>;
}

export interface IDeliveryV2 {
  readonly __typename?: 'DeliveryV2';
  readonly status?: Maybe<DeliveryStatusV2>;
  readonly eta?: Maybe<Scalars['String']>;
  readonly pickup?: Maybe<IDeliveryPickupV2>;
  readonly dropoff?: Maybe<IDeliveryDropoffV2>;
  readonly driver?: Maybe<IDeliveryDriverV2>;
  readonly instructions?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypoint {
  readonly __typename?: 'DeliveryWaypoint';
  readonly afterTime?: Maybe<Scalars['String']>;
  readonly arrivalTime?: Maybe<Scalars['String']>;
  readonly beforeTime?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: Maybe<Scalars['String']>;
  readonly deliveryMethod?: Maybe<DeliveryMethod>;
  readonly phoneNumber: Scalars['String'];
  readonly state?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly trackingUrl?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypointInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: Maybe<Scalars['String']>;
  readonly deliveryMethod?: Maybe<DeliveryMethod>;
  readonly phoneNumber: Scalars['String'];
  readonly route?: Maybe<Scalars['String']>;
  /** flag to determine wether or not the waypoint should be saved */
  readonly shouldSave?: Maybe<Scalars['Boolean']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
}

export interface IDeliveryWaypointInputV2 {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly route?: Maybe<Scalars['String']>;
  readonly shouldSaveAddress?: Maybe<Scalars['Boolean']>;
  readonly state: Scalars['String'];
  readonly streetNumber?: Maybe<Scalars['String']>;
  readonly zip: Scalars['String'];
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly instructions?: Maybe<Scalars['String']>;
}

export interface IDiscount {
  readonly __typename?: 'Discount';
  readonly name?: Maybe<DiscountTypes>;
  /** values are represented as positive integers in cents */
  readonly value?: Maybe<Scalars['Int']>;
}

export enum DiscountTypes {
  ALL_DISCOUNTS = 'ALL_DISCOUNTS',
  COMBO_AND_OFFER_DISCOUNTS = 'COMBO_AND_OFFER_DISCOUNTS',
  REWARDS_DISCOUNTS = 'REWARDS_DISCOUNTS'
}

export interface IDonation {
  readonly __typename?: 'Donation';
  readonly id?: Maybe<Scalars['String']>;
  /** Name of donation */
  readonly name?: Maybe<Scalars['String']>;
  /** Total are represented as positive integers in cents */
  readonly totalCents?: Maybe<Scalars['Int']>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 *
 * An edge provides an association between a node and it's associated cursor.
 */
export interface IEdge {
  readonly node: INode;
  readonly cursor: Scalars['String'];
}

/** All details necessary to encrypt CC information for First Data */
export interface IEncryptionDetails {
  readonly __typename?: 'EncryptionDetails';
  /** Public key for performing RSA encryption on specific First Data requests */
  readonly fdPublicKey: Scalars['String'];
  /** Access token for accessing First Data API. Limited TTL. */
  readonly fdAccessToken: Scalars['String'];
  /** Time until public key expires (milliseconds?) */
  readonly fdPublicKeyExpiresInSeconds: Scalars['Int'];
  /** ISO datetime for when public key was issued */
  readonly fdPublicKeyIssuesOn: Scalars['String'];
  /** RBI specific API key for accessing First Data */
  readonly fdApiKey: Scalars['String'];
  /**
   * Encryption algorithm.
   *
   * You should be able to ignore this value, as we only support 'RSA/NONE/PKCS1Padding'
   */
  readonly algorithm?: Maybe<Scalars['String']>;
  /** First data customer ID. Derived from provided authentication header. */
  readonly fdCustomerId?: Maybe<Scalars['String']>;
  /** Tokenization URL. */
  readonly tokenizationUrl?: Maybe<Scalars['String']>;
}

export interface IEntity {
  readonly __typename?: 'Entity';
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly calories?: Maybe<ICalories>;
  readonly price?: Maybe<IPrice>;
  readonly options?: Maybe<ReadonlyArray<IOption>>;
}

export interface IExchangeOtpCodeForCredentialsInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /**
   * The email of the user requesting a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided
   * @todo - only email is implemented at this time
   */
  readonly email?: Maybe<Scalars['String']>;
  /**
   * The phone number of the user logging in with a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided.
   * @todo - not implemented
   */
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
}

export interface IFavorite {
  readonly __typename?: 'Favorite';
  readonly entries?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly favoriteId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly ref?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export interface IFavoriteInput {
  readonly ref?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly serviceMode?: Maybe<ServiceMode>;
  readonly entries?: Maybe<ReadonlyArray<Maybe<ICartEntryInput>>>;
}

export interface IFavoriteList {
  readonly __typename?: 'FavoriteList';
  readonly count?: Maybe<Scalars['Int']>;
  readonly favorites?: Maybe<ReadonlyArray<Maybe<IFavorite>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface IFavoriteOffer {
  readonly __typename?: 'FavoriteOffer';
  /** Favorite Offer ID */
  readonly id?: Maybe<Scalars['String']>;
}

export interface IFavoriteStore {
  readonly __typename?: 'FavoriteStore';
  /** Favorite Store ID */
  readonly storeId?: Maybe<Scalars['String']>;
  /** Favorite Store Number */
  readonly storeNumber?: Maybe<Scalars['String']>;
}

export interface IFavoriteStoreInput {
  readonly storeId?: Maybe<Scalars['String']>;
  readonly storeNumber: Scalars['String'];
}

export interface IFees {
  readonly __typename?: 'Fees';
  readonly name?: Maybe<Scalars['String']>;
  readonly priceCents?: Maybe<Scalars['Int']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
}

export enum FilterRestaurantType {
  NEARBY = 'NEARBY',
  RECENT = 'RECENT',
  FAVORITE = 'FAVORITE'
}

export interface IFirstDataPayment {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or fdNonce
   * and fdAccessToken should be passed.
   */
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: Maybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce. If accountIdentifier is not passed this must
   * be passed.
   */
  readonly fdNonce?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>;
}

export interface IFirstpayPayment {
  /** Represents the PSP id for the payment */
  readonly pspReference?: Maybe<Scalars['String']>;
  /** Stored payment method identifier */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Merchant Account */
  readonly merchantAccount?: Maybe<Scalars['String']>;
}

export interface IFulfillmentDetails {
  readonly __typename?: 'FulfillmentDetails';
  readonly pickupType?: Maybe<FulfillmentPickupType>;
  readonly pickupReady?: Maybe<Scalars['Boolean']>;
  readonly pickupPin?: Maybe<Scalars['String']>;
}

export enum FulfillmentPickupType {
  BEEPER = 'BEEPER',
  LOCKER = 'LOCKER'
}

export interface IFutureServiceHours {
  readonly __typename?: 'FutureServiceHours';
  readonly serviceMode?: Maybe<ServiceMode>;
  readonly timeSlots?: Maybe<ReadonlyArray<Maybe<IRestaurantTimeSlot>>>;
}

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export interface IGetSmileCookieEnrolledRestaurantsResult {
  readonly __typename?: 'GetSmileCookieEnrolledRestaurantsResult';
  readonly restaurants: ReadonlyArray<ISmileCookieEnrolledRestaurant>;
  readonly campaignStartDate?: Maybe<Scalars['String']>;
  readonly campaignEndDate?: Maybe<Scalars['String']>;
}

/** A First Data gift card account (prepaid payment method) */
export interface IGiftAccount {
  readonly __typename?: 'GiftAccount';
  /** First Data account ID */
  readonly fdAccountId: Scalars['String'];
  readonly prepaid: IGiftCard;
}

/** First Data prepaid account */
export interface IGiftCard {
  readonly __typename?: 'GiftCard';
  /** last 4 digits of prepaid gift card number */
  readonly alias: Scalars['String'];
  /** amount card was loaded with (cents) upon creation */
  readonly currentBalance?: Maybe<Scalars['Int']>;
  readonly cardNumber: Scalars['String'];
  /**
   * Two digit expiry month
   * @deprecated not used
   */
  readonly expiryMonth: Scalars['String'];
  /**
   * Two digit expiry year
   * @deprecated not used
   */
  readonly expiryYear: Scalars['String'];
  /** @deprecated not used */
  readonly feFormattedCurrentBalance?: Maybe<Scalars['Int']>;
  /**
   * Use to generate barcode
   * @deprecated not used
   */
  readonly shuffledCardNumber: Scalars['String'];
}

export interface IGiftCardCart {
  readonly __typename?: 'GiftCardCart';
  readonly id?: Maybe<Scalars['String']>;
}

export interface IGiftCardCatalogEntry {
  readonly __typename?: 'GiftCardCatalogEntry';
  readonly imageUrl?: Maybe<Scalars['String']>;
  readonly feeValue?: Maybe<Scalars['String']>;
  readonly cardAmountMap?: Maybe<ICardAmountMap>;
  readonly image?: Maybe<Scalars['String']>;
  readonly feeLabel?: Maybe<Scalars['String']>;
  readonly otherAmount?: Maybe<Scalars['Boolean']>;
  readonly category?: Maybe<Scalars['String']>;
  readonly minValue?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly otherAmountIncremental?: Maybe<Scalars['String']>;
  readonly maxValue?: Maybe<Scalars['String']>;
}

export interface IGiftCardLoadInput {
  readonly paymentAccountId?: Maybe<Scalars['String']>;
  readonly applePayDetails?: Maybe<IApplePayDetails>;
  readonly googlePayDetails?: Maybe<IGooglePayDetails>;
  readonly giftCardLoadAmount: Scalars['Int'];
}

export interface IGiftCardLoadPayload {
  readonly __typename?: 'GiftCardLoadPayload';
  readonly user: IUser;
}

/** Namespace type to wrap sub-types of giftcard service */
export interface IGiftCardQueries {
  readonly __typename?: 'GiftCardQueries';
  readonly storeCatalog?: Maybe<IGiftCardStoreCatalog>;
  readonly cart?: Maybe<IGiftCardCart>;
}

export interface IGiftCardStoreCatalog {
  readonly __typename?: 'GiftCardStoreCatalog';
  /** Catalog of gift cards from store */
  readonly status?: Maybe<Scalars['String']>;
  readonly catalog?: Maybe<ReadonlyArray<Maybe<IGiftCardCatalogEntry>>>;
}

export interface IGiftOffer {
  readonly __typename?: 'GiftOffer';
  /** The offer identity. */
  readonly offerId: Scalars['ID'];
  /** The title as a string */
  readonly title: Scalars['String'];
  /** The title formatted with points required, e.g. "Free Coffee (50 Points)" */
  readonly titleFormatted: Scalars['String'];
  /** Can the Gift Offer be redeemed. */
  readonly isRedeemable: Scalars['Boolean'];
  /** The cost in points to redeem */
  readonly costInPoints: Scalars['Int'];
}

export interface IGiftOfferInput {
  /** The Id of the offer to gift */
  readonly offerId: Scalars['String'];
  /** The email address to send the offer to */
  readonly toEmail: Scalars['String'];
  /** The name the offer will come from */
  readonly fromName: Scalars['String'];
  /** The message to include in the email */
  readonly message: Scalars['String'];
}

export interface IGiftOfferListResponse {
  readonly __typename?: 'GiftOfferListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupons.
   */
  readonly count: Scalars['Int'];
  /**
   * The set of offers retrieved.
   * If this array is empty, there were no matching coupons.
   */
  readonly offers: ReadonlyArray<Maybe<IGiftOffer>>;
}

/** Details from Google Pay used for Google Pay funding. */
export interface IGooglePay {
  /** Signature as passed through from Google Pay */
  readonly signature: Scalars['String'];
  /** Country Code from user account */
  readonly country: CountryCode;
  /** Signature message passed through from Google Pay */
  readonly data: Scalars['String'];
  /** Formatted billing address from Google Pay */
  readonly formatted: Scalars['String'];
  readonly primary: Scalars['Boolean'];
  readonly version: Scalars['String'];
  readonly type: Scalars['String'];
  /** Billing address from Google Pay */
  readonly billingAddress: IBillingAddressInput;
  /** Encrypted token including signature and signature message as passed through from Google Pay. */
  readonly paymentData?: Maybe<Scalars['String']>;
  /** Data of the payment method used for Google Pay. */
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>;
}

export interface IGooglePayAssuranceDetails {
  readonly cardHolderAuthenticated?: Maybe<Scalars['Boolean']>;
  readonly accountVerified?: Maybe<Scalars['Boolean']>;
}

export interface IGooglePayBillingAddress {
  readonly sortingCode?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly locality?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly countryCode?: Maybe<Scalars['String']>;
  readonly administrativeArea?: Maybe<Scalars['String']>;
  readonly address3?: Maybe<Scalars['String']>;
  readonly address1?: Maybe<Scalars['String']>;
}

/** Google Pay details from the payments subgraph. */
export interface IGooglePayDetails {
  readonly tokenizationData?: Maybe<IGooglePayTokenizationData>;
  readonly type?: Maybe<Scalars['String']>;
  readonly info?: Maybe<IGooglePayInfo>;
  readonly description?: Maybe<Scalars['String']>;
}

export interface IGooglePayInfo {
  readonly cardNetwork?: Maybe<Scalars['String']>;
  readonly cardDetails?: Maybe<Scalars['String']>;
  readonly cardFundingSource?: Maybe<Scalars['String']>;
  readonly billingAddress?: Maybe<IGooglePayBillingAddress>;
  readonly assuranceDetails?: Maybe<IGooglePayAssuranceDetails>;
}

export interface IGooglePayTokenizationData {
  readonly type?: Maybe<Scalars['String']>;
  readonly token?: Maybe<Scalars['String']>;
}

export interface IGroup {
  readonly __typename?: 'Group';
  /** id */
  readonly id?: Maybe<Scalars['String']>;
  /** expiryTime */
  readonly expiryTime?: Maybe<Scalars['Float']>;
  /** confirmedGroupOrders */
  readonly confirmedGroupOrders?: Maybe<ReadonlyArray<Maybe<IGroupOrder>>>;
  /** adminUserId */
  readonly adminUserId?: Maybe<Scalars['String']>;
}

export interface IGroupOrder {
  readonly __typename?: 'GroupOrder';
  /** userId */
  readonly userId?: Maybe<Scalars['String']>;
  /** orderId */
  readonly orderId?: Maybe<Scalars['String']>;
}

export interface IHoliday {
  readonly name?: Maybe<Scalars['String']>;
  readonly date?: Maybe<Scalars['String']>;
  readonly dateEnd?: Maybe<Scalars['String']>;
  readonly diningRoomHours?: Maybe<Scalars['String']>;
  readonly driveThruHours?: Maybe<Scalars['String']>;
  readonly deliveryHours?: Maybe<Scalars['String']>;
}

/** Image with URL and optional alt text */
export interface IImage {
  readonly __typename?: 'Image';
  /** The image URL, optionally transformed with width/height */
  readonly url: Scalars['String'];
  /** Alternative text for accessibility */
  readonly altText?: Maybe<Scalars['String']>;
}


/** Image with URL and optional alt text */
export interface IImageUrlArgs {
  transform: Maybe<IImageTransformInput>;
}

/** Input for transforming image URLs (e.g., Sanity image transforms) */
export interface IImageTransformInput {
  /** Desired width of the image in pixels */
  readonly width?: Maybe<Scalars['Int']>;
  /** Desired height of the image in pixels */
  readonly height?: Maybe<Scalars['Int']>;
}

/**
 * Payload of `initiateLinking`. The `oidcAuthUrl` is a base authorize
 * URL missing only PKCE params — the RP Site appends `code_challenge`,
 * `code_challenge_method=S256`, and OAuth `state` before redirecting.
 */
export interface IInitiateLinkingResponse {
  readonly __typename?: 'InitiateLinkingResponse';
  /**
   * Base CT OIDC authorize URL (no PKCE appended). Shape:
   * `https://<ct-authorize-endpoint>?response_type=code&client_id=<th-client-id>&redirect_uri=<rp-site-callback>&scope=openid`
   */
  readonly oidcAuthUrl: Scalars['String'];
}

export { IsoCountryCode };


/**
 * Public link-state values surfaced to polling clients (TH App, RP Site).
 * `INITIATED` rows in the data model are collapsed to `NOT_LINKED` here
 * so transient states aren't exposed to callers.
 */
export enum LinkStatus {
  /** The user has an active link to the partner (latest row = LINKED). */
  LINKED = 'LINKED',
  /** The user was previously linked but has since been delinked. */
  DELINKED = 'DELINKED',
  /**
   * The user has never linked to this partner, or the only rows are
   * unsuccessful (INITIATED) ones that have expired / will expire.
   */
  NOT_LINKED = 'NOT_LINKED'
}

export enum Locale {
  EN = 'en',
  FR = 'fr',
  IT = 'it',
  DE = 'de'
}

export interface ILoyaltyCard {
  readonly __typename?: 'LoyaltyCard';
  readonly barcode: Scalars['String'];
  readonly cardFormat: UserCardCardFormat;
  /**
   * 12 digit card number, eg '1G96025DZ9ZG'.
   *
   * This is the number printed on the back of a physical card
   */
  readonly cardId: Scalars['String'];
  readonly cardType: UserCardCardType;
  readonly name: Scalars['String'];
  readonly points?: Maybe<Scalars['String']>;
  readonly status: UserCardCardStatus;
  readonly scanAndPayExpiry?: Maybe<Scalars['String']>;
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCardApplePass {
  readonly __typename?: 'LoyaltyCardApplePass';
  readonly encodedPass: Scalars['String'];
}

export interface ILoyaltyCardDetails {
  readonly __typename?: 'LoyaltyCardDetails';
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'];
  /** The value of the loyalty card barcode. */
  readonly barcode?: Maybe<Scalars['String']>;
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: Scalars['Boolean'];
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: Scalars['Boolean'];
  /** The type of loyalty card. */
  readonly cardType: UserCardCardType;
  /** (e.g. 0001-01-01T00:00:00.000Z) */
  readonly discountActiveUntil?: Maybe<Scalars['String']>;
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'];
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'];
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'];
  /** The total number of offers attached to a loyalty card. */
  readonly offers: ReadonlyArray<Maybe<ILoyaltyOffer>>;
  /** (e.g. 9899-12-31T23:59:59.999Z) */
  readonly periodEndTimestamp: Scalars['String'];
  /** (e.g. 1999-01-01T00:00:00.000Z) */
  readonly periodStartTimestamp: Scalars['String'];
  /** The user's point expiry data. */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>;
  /**
   * The user's available loyalty points.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly points?: Maybe<Scalars['Int']>;
  /**
   * The user's selected reward tier.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly rewardsTier?: Maybe<Scalars['String']>;
  /** The donation status for a loyalty user card */
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
  /** The scan and pay status for a loyalty user card */
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
  /** A timestamp representing when the scan and pay token provided in the barcode will expire if it exists */
  readonly scanAndPayExpiry?: Maybe<Scalars['String']>;
}

export interface ILoyaltyCardDetailsKiosk {
  readonly __typename?: 'LoyaltyCardDetailsKiosk';
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'];
  /** ??? */
  readonly currentPoints: Scalars['Int'];
  /** The total number of visits issues to this loyalty card in an unknown period of time. */
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'];
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'];
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'];
}

export interface ILoyaltyCardGooglePass {
  readonly __typename?: 'LoyaltyCardGooglePass';
  readonly jwt: Scalars['String'];
}

export interface ILoyaltyCardsResp {
  readonly __typename?: 'LoyaltyCardsResp';
  readonly cards: ReadonlyArray<ILoyaltyCard>;
  readonly count: Scalars['Int'];
}

export interface ILoyaltyCardsWithDetailsResp {
  readonly __typename?: 'LoyaltyCardsWithDetailsResp';
  readonly cards: ReadonlyArray<ILoyaltyCardWithDetails>;
  readonly count: Scalars['Int'];
}

export interface ILoyaltyCardTransaction {
  readonly __typename?: 'LoyaltyCardTransaction';
  /** The taxes of the basket. */
  readonly basketTaxes?: Maybe<Scalars['Int']>;
  /** Bonus points earned */
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  /** The total of the basket including taxes. */
  readonly basketTotal?: Maybe<Scalars['Int']>;
  /** City of store where loyalty was redeemed */
  readonly city?: Maybe<Scalars['String']>;
  /** The total amount discounted */
  readonly discountAmount?: Maybe<Scalars['Int']>;
  readonly expiredPoints?: Maybe<ILoyaltyExpiredPoints>;
  /** True if this visit was given from customer support. False otherwise. */
  readonly isCustomerServiceVisit?: Maybe<Scalars['Boolean']>;
  /** True if the transaction counted as a visit. */
  readonly isVisit?: Maybe<Scalars['Boolean']>;
  /** Offer that was associated with the transaction */
  readonly offerId?: Maybe<Scalars['Int']>;
  /** Loyalty points earned from transaction */
  readonly pointsEarned?: Maybe<Scalars['Int']>;
  /** Loyalty points used from transaction */
  readonly pointsUsed?: Maybe<Scalars['Int']>;
  /** True if this transaction earned a rewards */
  readonly rewardEarned?: Maybe<Scalars['Boolean']>;
  /** Reward redeemed upon transaction */
  readonly rewardRedeemed?: Maybe<Scalars['Boolean']>;
  /** State or Province of store where loyalty was redeemed */
  readonly stateOrProvince?: Maybe<Scalars['String']>;
  /** Store ID where loyalty was redeemed */
  readonly storeId?: Maybe<Scalars['String']>;
  /**
   * Tag string indicating the source of the rewards earned
   * e.g. FREQUENCY_CHALLENGE_COMPLETE, HOCKEY_1
   */
  readonly tag?: Maybe<Scalars['String']>;
  /** The time of the transaction in UTC. */
  readonly timestamp?: Maybe<Scalars['String']>;
  /** A unique identifier for transaction */
  readonly transactionId?: Maybe<Scalars['String']>;
  /**
   * A tag for the type of visit. This will be null for normal transactions.
   * When a visit or reward is issued through the IssueVisit/IssueReward endpoints
   * a VisitType may be specified that will surface in this field
   */
  readonly visitType?: Maybe<Scalars['String']>;
  /**
   * True if the discount was active or available for this transaction.
   * False if no discount was applied.
   */
  readonly wasDiscountActive?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCardTransactions {
  readonly __typename?: 'LoyaltyCardTransactions';
  readonly count: Scalars['Int'];
  readonly transactions: ReadonlyArray<Maybe<ILoyaltyCardTransaction>>;
}

export interface ILoyaltyCardWithDetails {
  readonly __typename?: 'LoyaltyCardWithDetails';
  /** String representing the QR code data for the loyalty card */
  readonly barcode: Scalars['String'];
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: Scalars['Boolean'];
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: Scalars['Boolean'];
  readonly cardFormat: UserCardCardFormat;
  /**
   * 12 digit card number, eg '1G96025DZ9ZG'.
   *
   * This is the number printed on the back of a physical card
   */
  readonly cardId: Scalars['String'];
  /** The donation status for a loyalty user card */
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  /** The total number of offers attached to a loyalty card. */
  readonly offers: ReadonlyArray<ILoyaltyOffer>;
  /** The user's point expiry data. */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>;
  /**
   * The user's available loyalty points.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly points?: Maybe<Scalars['Int']>;
  /**
   * The user's selected reward tier.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly rewardsTier?: Maybe<Scalars['String']>;
  /** The scan and pay status for a loyalty user card */
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
  /** A timestamp representing when the scan and pay token provided in the barcode will expire if it exists */
  readonly scanAndPayExpiry?: Maybe<Scalars['String']>;
  readonly status: UserCardCardStatus;
}

export interface ILoyaltyDetails {
  readonly __typename?: 'LoyaltyDetails';
  /** String representing the QR code data for the loyalty card */
  readonly barcode: Scalars['String'];
  /**
   * 12 digit card number, eg '1G96025DZ9ZG'.
   *
   * This is the number printed on the back of a physical card
   */
  readonly cardId: Scalars['String'];
  /** The country code for the loyalty card */
  readonly country: Scalars['String'];
  /** The donation status for a loyalty user card */
  readonly donationUpcharge: Scalars['Boolean'];
  /** The scan and pay status for a loyalty user card */
  readonly scanAndPay: Scalars['Boolean'];
  /** A timestamp representing when the scan and pay token provided in the barcode will expire if it exists */
  readonly scanAndPayExpiry?: Maybe<Scalars['String']>;
  /** The user's selected reward tier. */
  readonly rewardsTier: Scalars['String'];
  /** Details about the user's rewards and points */
  readonly rewardDetails?: Maybe<ILoyaltyReward>;
  /** The list of offers attached to the loyalty card */
  readonly offers?: Maybe<ReadonlyArray<ILoyaltyOffer>>;
}

export interface ILoyaltyDonationUpcharge {
  readonly __typename?: 'LoyaltyDonationUpcharge';
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyExpiredPoints {
  readonly __typename?: 'LoyaltyExpiredPoints';
  /** Loyalty card barcode */
  readonly barcode?: Maybe<Scalars['String']>;
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly points?: Maybe<Scalars['Int']>;
  readonly ttl?: Maybe<Scalars['String']>;
}

export interface ILoyaltyOffer {
  readonly __typename?: 'LoyaltyOffer';
  readonly activated: Scalars['Boolean'];
  readonly challengeStatus?: Maybe<ReadonlyArray<ILoyaltyOfferChallengeStatus>>;
  readonly challengeType?: Maybe<Scalars['String']>;
  readonly challengeReward?: Maybe<ILoyaltyOfferRewardType>;
  readonly expiryDate: Scalars['String'];
  readonly key?: Maybe<Scalars['String']>;
  readonly offerId: Scalars['String'];
  readonly startDate: Scalars['String'];
}

export interface ILoyaltyOfferChallengeStatus {
  readonly __typename?: 'LoyaltyOfferChallengeStatus';
  readonly goals?: Maybe<ILoyaltyOfferGoalType>;
  readonly goalId: Scalars['String'];
  readonly reward?: Maybe<ILoyaltyOfferRewardType>;
  readonly status: Scalars['String'];
}

export interface ILoyaltyOfferGoalType {
  readonly __typename?: 'LoyaltyOfferGoalType';
  readonly category?: Maybe<Scalars['String']>;
  readonly daypart?: Maybe<Scalars['String']>;
  readonly foodType?: Maybe<Scalars['String']>;
  readonly minSpend?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyOfferRewardType {
  readonly __typename?: 'LoyaltyOfferRewardType';
  readonly points?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyPointExpiry {
  readonly __typename?: 'LoyaltyPointExpiry';
  readonly points: Scalars['Int'];
  readonly expirationDate: Scalars['String'];
}

export interface ILoyaltyRedemption {
  readonly __typename?: 'LoyaltyRedemption';
  readonly isEnabled: Scalars['Boolean'];
  readonly level: ILoyaltyRedemptionLevel;
}

export interface ILoyaltyRedemptionLevel {
  readonly __typename?: 'LoyaltyRedemptionLevel';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly requiredPoints: Scalars['Int'];
  /** @deprecated Use `image` instead */
  readonly imageUrl?: Maybe<Scalars['String']>;
  readonly image?: Maybe<IImage>;
}

export interface ILoyaltyReward {
  readonly __typename?: 'LoyaltyReward';
  /** Whether rewards redemption is enabled for the loyalty card */
  readonly redemptionEnabled: Scalars['Boolean'];
  /** Total points available for redemption */
  readonly totalPoints: Scalars['Int'];
  /** Array of point expiry information */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>;
}

export interface ILoyaltyRewardsInfo {
  readonly __typename?: 'LoyaltyRewardsInfo';
  readonly loyaltyCardId: Scalars['String'];
  readonly pointBalance: Scalars['Int'];
  readonly redemption: ILoyaltyRedemption;
  /**
   * The total number of rewards earned by the user based on their current tier
   * Calculated as: floor(pointBalance / currentTierRequiredPoints)
   */
  readonly numberOfRewardsEarned?: Maybe<Scalars['Int']>;
  /**
   * The number of points earned towards next reward (starts at 0 after each earned reward)
   * Calculated as: pointBalance % currentTierRequiredPoints
   */
  readonly pointsEarnedToNextReward?: Maybe<Scalars['Int']>;
  /**
   * The number of points remaining to earn the next reward
   * Calculated as: currentTierRequiredPoints - (pointBalance % currentTierRequiredPoints)
   */
  readonly pointsRemainingToNextReward?: Maybe<Scalars['Int']>;
  /**
   * Progress based on point balance relative to current tier
   * Calculated as: pointsEarnedToNextReward / currentTierRequiredPoints;
   */
  readonly progressToNextReward?: Maybe<Scalars['Float']>;
  /**
   * Dynamic contextual message based on user's reward progress state
   * Examples: "So close! Only 50 points to go", "Congrats, you've earned a drink!"
   */
  readonly progressMessage?: Maybe<Scalars['String']>;
  /**
   * Message displayed on the rewards toggle when banking is enabled.
   * Returns the banking message when redemption is disabled, undefined otherwise.
   */
  readonly toggleMessage?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRewardsRedemptionCategories {
  readonly __typename?: 'LoyaltyRewardsRedemptionCategories';
  /** This will be the name of the redemption category such as "Beverages" */
  readonly name: Scalars['String'];
  /** The list of redemption levels for this category */
  readonly levels: ReadonlyArray<ILoyaltyRedemptionLevel>;
}

export interface ILoyaltyRewardsTier {
  readonly __typename?: 'LoyaltyRewardsTier';
  readonly rewardsTier?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimEventRollPrize {
  readonly __typename?: 'LoyaltyRollUpTheRimEventRollPrize';
  readonly id: Scalars['String'];
  readonly type: Scalars['String'];
  readonly code?: Maybe<Scalars['String']>;
  readonly revealedAt?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimPrizesStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizesStats';
  /** Cumulative sum of all prizes for contest period (not including unlimited prizes) */
  readonly total?: Maybe<Scalars['Int']>;
  /** Cumulative sum of all prizes awarded to guests for contest period. */
  readonly awarded?: Maybe<Scalars['Int']>;
  /** Prizes */
  readonly details?: Maybe<ReadonlyArray<Maybe<ILoyaltyRollUpTheRimPrizeStats>>>;
}

export interface ILoyaltyRollUpTheRimPrizeStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizeStats';
  /** Prize identifier */
  readonly prizeId?: Maybe<Scalars['String']>;
  /** Total number of prizes allocated for contest period. For prizes with no cap, total will be undefined. */
  readonly total?: Maybe<Scalars['Int']>;
  /** Total number of prizes awarded to guests for contest period. */
  readonly awarded?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry';
  /** This is the barcode used for scanning the timeline event entry. */
  readonly barcode: Scalars['String'];
  /**
   * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
   */
  readonly createdAt: Scalars['String'];
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'];
  /** The reference identifier for the timeline event entry. */
  readonly referenceId: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList';
  /** The count of rolls which were accepted. */
  readonly count: Scalars['Int'];
  /** The list of rolls which were accepted. */
  readonly rolls: ReadonlyArray<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry>;
}

export interface ILoyaltyRollUpTheRimTimelineEventDetails {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventDetails';
  /** The optional redemption code for the timeline event entry. */
  readonly redemptionCode?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventEntry';
  /**
   * If present, this is the barcode used for scanning the timeline event entry.
   * Otherwise, this value is null.
   */
  readonly barcode?: Maybe<Scalars['String']>;
  /**
   * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
   */
  readonly createdAt: Scalars['String'];
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'];
  /**
   * If this timeline event entry is for a prize, this is the prize identifier.
   * Otherwise, this value is null.
   */
  readonly prizeId?: Maybe<Scalars['String']>;
  /**
   * The reference identifier for the timeline event entry.
   * Specify this value for revealing a roll.
   * Multiple events may occur for a given reference identity.
   * Only the most recent event for any reference identity is returned.
   */
  readonly referenceId: Scalars['String'];
  /** The unique identifier for the timeline event entry. */
  readonly timelineId: Scalars['String'];
  /** The type of timeline event entry. */
  readonly type: Scalars['String'];
  /** The associated offer for the timeline event entry. */
  readonly offerStatus?: Maybe<ILoyaltyRollUpTheRimTimelineEventOfferStatus>;
  /** The optional redemption code for the timeline event entry. */
  readonly redemptionCode?: Maybe<Scalars['String']>;
  /** The details object containing optional fields for timeline events. */
  readonly details?: Maybe<ILoyaltyRollUpTheRimTimelineEventDetails>;
}

export interface ILoyaltyRollUpTheRimTimelineEventList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventList';
  readonly count: Scalars['Int'];
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventEntry>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventListV2 {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventListV2';
  readonly rollsCount: Scalars['Int'];
  readonly prizesCount: Scalars['Int'];
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventEntry>>;
  readonly exclusiveStartKey?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventOfferStatus {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventOfferStatus';
  /** The associated offer identifier for the timeline event entry. */
  readonly offerId?: Maybe<Scalars['String']>;
  /** The activation status of the associated offer */
  readonly activated?: Maybe<Scalars['Boolean']>;
  /** The status of the associated offer */
  readonly used?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventRollResult';
  /** The list of prizes revealed by the roll. */
  readonly prizes: ReadonlyArray<ILoyaltyRollUpTheRimEventRollPrize>;
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry';
  /** The count of shared rolls represented by the token. */
  readonly count: Scalars['Int'];
  /**
   * The token representing the number of shared rolls.
   * This can be used to accept the rolls by another user.
   */
  readonly token: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenList';
  /** The count of tokens in the list. */
  readonly count: Scalars['Int'];
  /** The tokens representing shared rolls from the user's timeline events. */
  readonly tokens: ReadonlyArray<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry>;
}

export interface ILoyaltyRollUpTheRimTimelineEventShareRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventShareRollResult';
  /** The generated token which can be used to accept the shared rolls. */
  readonly token: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryEntry';
  readonly count: Scalars['Int'];
  readonly eventId: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryList';
  readonly count: Scalars['Int'];
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryEntry>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface ILoyaltyScanAndPay {
  readonly __typename?: 'LoyaltyScanAndPay';
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyTransaction {
  readonly __typename?: 'LoyaltyTransaction';
  readonly id: Scalars['String'];
  /** Points earned. */
  readonly pointsEarned: Scalars['Int'];
  /** Bonus points earned. */
  readonly bonusPointsEarned: Scalars['Int'];
  /** Points used. */
  readonly pointsUsed: Scalars['Int'];
  /** Points balance after this transaction. */
  readonly pointsBalance: Scalars['Int'];
  /** Number of rewards used. */
  readonly rewardsUsed: Scalars['Int'];
}

export interface IMeInput {
  /**
   * @deprecated(reason: "This argument has no effect. Use
   * uniquePurchasedItemsInput on the federated uniquePurchasedItems field instead")
   */
  readonly shouldUniqueByModifiers?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "This argument has no effect. Use
   * uniquePurchasedItemsInput on the federated uniquePurchasedItems field instead")
   */
  readonly shouldIncludeExtras?: Maybe<Scalars['Boolean']>;
}

/** Input for querying menu-wide availability (consumer pattern) */
export interface IMenuAvailabilityQueryInput {
  /** The menu ID to query availability for */
  readonly menuId: Scalars['Int'];
  /** The restaurant ID to check availability for */
  readonly restaurantId: Scalars['Int'];
  /**
   * Optional timestamp for availability check (defaults to current time)
   * ISO 8601 format: YYYY-MM-DDTHH:mm:ss.sssZ
   */
  readonly queryTime?: Maybe<Scalars['String']>;
}

/** Result for menu-wide availability query */
export interface IMenuAvailabilityResult {
  readonly __typename?: 'MenuAvailabilityResult';
  /** The menu ID that was queried */
  readonly menuId: Scalars['Int'];
  /** The restaurant ID that was queried */
  readonly restaurantId: Scalars['Int'];
  /** The timestamp used for the availability check (ISO 8601) */
  readonly queryTime: Scalars['String'];
  /** List of available SKUs (only includes available items) */
  readonly availableSkus: ReadonlyArray<ISkuAvailability>;
  /** Total count of SKUs checked */
  readonly totalSkusChecked: Scalars['Int'];
}

export interface IMenuContext {
  readonly restaurantId: Scalars['ID'];
  readonly channel: Channel;
  readonly serviceMode: ServiceMode;
}

/**
 * MenuEntityWithHours represents the store menu items with availability hours from the Connector menu.
 * Availability is propagated from items to top level structures (pickers, sections, etc) algorithmically.
 */
export interface IMenuEntityWithHours {
  readonly __typename?: 'MenuEntityWithHours';
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly calories?: Maybe<ICalories>;
  readonly price?: Maybe<IPrice>;
  readonly options?: Maybe<ReadonlyArray<IOption>>;
  readonly hours: ReadonlyArray<IMenuItemHours>;
}

/**
 * Vendor-neutral image reference for restaurant assets. Shape is compatible with
 * the upstream CMS image pipeline so frontend image builders keep working.
 */
export interface IMenuImage {
  readonly __typename?: 'MenuImage';
  readonly asset?: Maybe<IMenuImageAsset>;
  readonly crop?: Maybe<IMenuImageCrop>;
  readonly hotspot?: Maybe<IMenuImageHotspot>;
}

export interface IMenuImageAsset {
  readonly __typename?: 'MenuImageAsset';
  readonly _id?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<IMenuImageMetaData>;
}

export interface IMenuImageCrop {
  readonly __typename?: 'MenuImageCrop';
  readonly top?: Maybe<Scalars['Float']>;
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
}

export interface IMenuImageHotspot {
  readonly __typename?: 'MenuImageHotspot';
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

export interface IMenuImageMetaData {
  readonly __typename?: 'MenuImageMetaData';
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<IMenuImagePalette>;
}

export interface IMenuImagePalette {
  readonly __typename?: 'MenuImagePalette';
  readonly dominant?: Maybe<IMenuImagePaletteSwatch>;
}

export interface IMenuImagePaletteSwatch {
  readonly __typename?: 'MenuImagePaletteSwatch';
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
}

/**
 * MenuItemHours represents the consolidated times windows during which the item is
 * available for orders, expressed in restaurant local time.
 */
export interface IMenuItemHours {
  readonly __typename?: 'MenuItemHours';
  /** Start time of the available hours in ISO8601 time format - Thh:mm. */
  readonly start: Scalars['String'];
  /** End time of the available hours in ISO8601 time format - Thh:mm. */
  readonly end: Scalars['String'];
}

/** Result for menu-wide pricing query */
export interface IMenuPricingResult {
  readonly __typename?: 'MenuPricingResult';
  /** The restaurant ID that was queried */
  readonly restaurantId: Scalars['Int'];
  /** The menu ID that was queried */
  readonly menuId: Scalars['Int'];
  /** The service mode used for the pricing query */
  readonly serviceMode: Scalars['String'];
  /** Timestamp of the pricing query (ISO 8601) */
  readonly queryTime: Scalars['DateTime'];
  /** Pricing information for each SKU on the menu */
  readonly items: ReadonlyArray<ISkuPricing>;
  /** Service-mode upcharge multiplier applied (if any) */
  readonly upchargeApplied?: Maybe<Scalars['Float']>;
}

/** A Prepaid Merge two gift cards response */
export interface IMerge {
  readonly __typename?: 'Merge';
  /** dollar amount destination gift card begins with */
  readonly beginBalance: Scalars['Int'];
  /** destination card currency code */
  readonly currencyCode: Scalars['String'];
  /** new balance of destination gift card after merge in dollars */
  readonly currentBalance: Scalars['Int'];
  /** card number of destination gift card */
  readonly destinationCardNumber?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  /** card number of source gift card that was deleted */
  readonly sourceCardNumber?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
  readonly fdAccountId?: Maybe<Scalars['String']>;
}

export interface IMissingItem {
  /** Line Id of item */
  readonly lineId: Scalars['String'];
  /** Quantity of items requested for refund */
  readonly refundQuantity: Scalars['Int'];
  /** Total quantity of items in a Combo or OfferCombo */
  readonly totalQuantity?: Maybe<Scalars['Int']>;
}

export interface IMissingOrderRefundDetails {
  readonly __typename?: 'MissingOrderRefundDetails';
  /** Amount refunded in cents */
  readonly approvedAmount: Scalars['Int'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IMissingOrderResolution {
  readonly __typename?: 'MissingOrderResolution';
  /** Refund details */
  readonly refund?: Maybe<IMissingOrderRefundDetails>;
  /** Knowledge Force or Zendesk support ticket */
  readonly ticket?: Maybe<Scalars['String']>;
}

export interface IModifier {
  readonly __typename?: 'Modifier';
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly price?: Maybe<Scalars['Int']>;
}

/** A group of modifiers for a product variant. For example, a "Flavor Shots" group that contains "Vanilla Syrup". */
export interface IModifierGroup {
  readonly __typename?: 'ModifierGroup';
  readonly id: Scalars['ID'];
  /** The label for the modifier group. For example, "Flavor Shots". */
  readonly label: Scalars['String'];
  /** The options for the modifier group. For example, ["Vanilla Syrup", "Caramel Syrup"]. */
  readonly modifiers: ReadonlyArray<IProductModifier>;
  /** Whether multiple modifiers in this group can be selected. */
  readonly allowsMultipleSelections: Scalars['Boolean'];
}

export enum ModifierGroupType {
  LIST = 'LIST',
  QUANTIFIABLE = 'QUANTIFIABLE'
}

/** An option for a modifier. For example, "1", or "Extra". */
export interface IModifierOption {
  readonly __typename?: 'ModifierOption';
  readonly id: Scalars['ID'];
  /** The label for the modifier option. For example, '1', or 'Extra'. */
  readonly label: Scalars['String'];
  /** The price delta to add to the product variant price when this modifier option is selected. Can be positive or negative. */
  readonly priceDelta?: Maybe<IMoney>;
  /**
   * Vendor configs for the modifier option allowing it to be identified by the POS
   * @deprecated Do not use. This field exposes internal vendor configuration and will be removed in a future release.
   */
  readonly vendorConfigsDoNotInspect: Scalars['JSON'];
}

/** An alias for a specific set of modifiers; e.g. 'Double Double' is an alias for 2x cream and 2x sugar */
export interface IModifierPreset {
  readonly __typename?: 'ModifierPreset';
  /** Friendly name for the modifier preset, e.g. 'Double Double' */
  readonly name: Scalars['String'];
  /** A set of modifiers accompanied by specific values; e.g. 'Double Double' sets 'cream = 2' and 'sugar = 2' */
  readonly selections: ReadonlyArray<ISelectedModifierOption>;
}

export interface IMoney {
  readonly __typename?: 'Money';
  readonly cents: Scalars['Int'];
  readonly currency: Currency;
}

export interface IMoneyInput {
  readonly cents: Scalars['Int'];
  readonly currency: Currency;
}

export interface IMutation {
  readonly __typename?: 'Mutation';
  /** Redeem one coupon for the authenticated user id. */
  readonly redeemCoupon: ICoupon;
  readonly communicationPreferencesUpdate?: Maybe<ICommunicationPreferencesUpdatePayload>;
  /** Create a favorite */
  readonly createFavorite: IFavorite;
  /** Update a favorite */
  readonly updateFavorite: IFavorite;
  /** Delete a favorite */
  readonly deleteFavorite: IFavorite;
  /**
   * Collect payments and commit the order to the PoS.
   *
   * If the service mode in the previously priced order was DRIVE_THRU or DELIVERY,
   * then the PoS will immediately start cooking the order. Else the PoS
   * will not cook the order until the customer arrives.
   *
   * (Please note that despite the name this is not a "transactional" flow)
   */
  readonly commitOrder: IOrder;
  /** commitOrder V2 */
  readonly orderCommit: IOrderCommitPayload;
  /**
   * Trigger the order to be prepared immediately and send it to the store's POS.
   * This mutation must be called after committing the order.
   */
  readonly orderUpdate: IOrderUpdatePayload;
  /**
   * Price an order using the store's PoS.
   *
   * This endpoint _must_ be called previous to finalizing the order.
   */
  readonly priceOrder: IOrder;
  readonly orderPrice: IOrderPricePayload;
  readonly orderPriceMock: IOrderPricePayload;
  /**
   * Update an order using the store's PoS.
   *
   * This endpoint _must_ be called after committing the order.
   */
  readonly updateOrder: IOrder;
  /** createGroup */
  readonly createGroup: IGroup;
  /** addOrderToGroup */
  readonly addOrderToGroup: IGroup;
  /** Add a restaurant to user's favorites */
  readonly addFavoriteRestaurant?: Maybe<Scalars['Boolean']>;
  /** Remove a restaurant from user's favorites */
  readonly removeFavoriteRestaurant?: Maybe<Scalars['Boolean']>;
  /** Vault a new credit card account with Chase for the user */
  readonly vaultCreditAccount: IVaultCreditAccountPayload;
  /**
   * Legacy Add Credit Account to user
   * This is currently used but is being deprecated in favour of vaultCreditAccount
   */
  readonly addCreditAccount: IAccount;
  /** Delete a payment account and return updated user data */
  readonly accountDelete: IAccountDeletePayload;
  /** Transfer balance of prepaid gift card into one and delete it */
  readonly prepaidsMerge: IMerge;
  /**
   * Reload a prepaid gift card account
   * This is currently used but is being deprecated in favour of giftCardLoad
   * @deprecated Use giftCardLoad instead
   */
  readonly prepaidsReload: IReload;
  /**
   * Delete user account payment method. This is currently used but is being deprecated in favour of accountDelete
   * @deprecated Use accountDelete instead
   */
  readonly deleteAccount: Scalars['Boolean'];
  /** Get balance for prepaid account */
  readonly prepaidsBalance: IBalance;
  /** Fetch FirstData public key & access token for encrypting CC values. This is part of the FirstData vaulting flow */
  readonly encryptionDetails: IEncryptionDetails;
  /**
   * Add a gift account (gift card) for a customer using a vaulted fd account.
   * Can throw MaxGiftCardsExistError.
   * This is currently used but is being deprecated in favour of giftCardLoad
   * @deprecated Use giftCardLoad instead
   */
  readonly addGiftAccount: IGiftAccount;
  /** Set Scan and Pay Payment Method */
  readonly setScanAndPayAccount: ISetScanAndPayAccountPayload;
  /** Set Scan and Pay enabled status */
  readonly setScanAndPayEnabled: ISetScanAndPayEnabledPayload;
  readonly giftCardLoad: IGiftCardLoadPayload;
  /** Set the default gift card reload account */
  readonly setGiftCardReloadAccount: ISetGiftCardReloadAccountPayload;
  /** Set the ordering account */
  readonly setOrderingAccount: ISetOrderingAccountPayload;
  /** Sends relevant emails with info from smile cookie volunteer form */
  readonly saveSmileCookieVolunteer?: Maybe<ISaveSmileCookieVolunteerResult>;
  /**
   * Accepts the rolls represented by the shared rolls token specified.
   * The authenticated user is the user which accepts the shared rolls.
   */
  readonly acceptLoyaltyRollUpTheRimTimelineEventSharedRolls?: Maybe<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList>;
  /** Activates a loyalty offer for a user. */
  readonly activateLoyaltyOffer?: Maybe<Scalars['Boolean']>;
  /** Activates a loyalty offer for a user. */
  readonly addVoucher?: Maybe<Scalars['Boolean']>;
  /** Claim a prize in Roll Up the Rim. */
  readonly claimLoyaltyRollUpTheRimPrize?: Maybe<Scalars['Boolean']>;
  /**
   * Merges the existing loyalty card for a user into a new
   * loyalty card created at run time. This deletes the existing
   * loyalty card.
   */
  readonly deleteLoyaltyCard?: Maybe<ILoyaltyCard>;
  /**
   * Merges the physical cardId (existingCardId) into existingCardId for a user
   * This deletes the existing loyalty card.
   */
  readonly mergeLoyaltyCards?: Maybe<ILoyaltyCard>;
  /** Reveals the result of a timeline event roll. */
  readonly revealLoyaltyRollUpTheRimTimelineEventRoll?: Maybe<ILoyaltyRollUpTheRimTimelineEventRollResult>;
  /** Set donation up charge for a loyalty user card */
  readonly setLoyaltyDonationUpcharge?: Maybe<ILoyaltyDonationUpcharge>;
  /** Set reward tier for a loyalty user card */
  readonly setLoyaltyRewardsTier?: Maybe<ILoyaltyRewardsTier>;
  /** Sets whether the rewards redemption is enabled for a loyalty user card */
  readonly setRewardsRedemptionEnabled?: Maybe<ISetRewardsRedemptionEnabledPayload>;
  /** Sets reward redemption level for a loyalty user card */
  readonly setRewardsRedemptionLevel?: Maybe<ISetRewardsRedemptionLevelPayload>;
  /** Set scan and pay for a loyalty user card */
  readonly setLoyaltyScanAndPay?: Maybe<ILoyaltyScanAndPay>;
  /** Share quantity of Roll Up the Rim timeline event rolls. */
  readonly shareLoyaltyRollUpTheRimTimelineEventRolls?: Maybe<ILoyaltyRollUpTheRimTimelineEventShareRollResult>;
  /** Set user's showThLoyaltyOnboarding property */
  readonly setShowThLoyaltyOnboarding?: Maybe<Scalars['Boolean']>;
  /** Gift an offer */
  readonly addGiftOfferByEmail: Scalars['Boolean'];
  /** Validate a gift token */
  readonly addOfferByToken: Scalars['Boolean'];
  /**
   * Begin a partnership account-linking flow. Performs the rate-limit check
   * ("2 successful LINKED events per 24h"), returns the existing link status
   * idempotently if the user is already LINKED to this partner, otherwise
   * writes an INITIATED row with 45-day TTL and returns the CT OIDC
   * authorize URL to hand to the RP Site.
   *
   * See [RFC §Linking Flow](https://github.com/tim-hortons-ventures/th-documentation/blob/main/rfc/2026_02_05_CT_Partnership_Linking_Flow.md#linking-flow).
   */
  readonly initiateLinking: IInitiateLinkingResponse;
  /**
   * Complete a partnership account-linking flow after the RP Site's OIDC
   * callback. TH Loyalty exchanges `authCode` (with `codeVerifier` for
   * PKCE) for a CT user access token via CT's `/op/token`, then calls
   * CT's `/op/linkPartnerCard` to register the TH link id and retrieve
   * the masked Triangle card suffix. On success, writes the final LINKED
   * row and emits AEP / confirmation-email side effects.
   *
   * Not retry-safe: the OIDC `authCode` is single-use per RFC 6749
   * §4.1.2. Re-calling `completeLinking` with the same `authCode` will
   * fail at CT's `/op/token` and surface as `INVALID_OIDC_CODE`. The RP
   * Site must call `initiateLinking` to obtain a fresh `authCode` before
   * retrying.
   */
  readonly completeLinking: ICompleteLinkingResponse;
  /**
   * Unlink the authenticated user from the given partner. Writes a
   * DELINKED row, notifies the partner (or queues a retry if they're
   * unavailable), and emits the delink AEP events. Idempotent: if the
   * latest row is already DELINKED, returns it unchanged.
   */
  readonly delinkPartner: IDelinkResponse;
  /** Request a jwt to auth for a given vendor */
  readonly createLoginForVendor?: Maybe<Scalars['String']>;
  /**
   * Create a user one time password
   * @deprecated Use createLoginOTP
   */
  readonly createOTP: ICreateOtp;
  /** Request a one-time password for the given user */
  readonly createLoginOTP: ICreateOtp;
  /**
   * Create a user sms one time password
   * @deprecated SMS no longer used
   */
  readonly createSmsOtp: ICreateOtp;
  /**
   * Validates a previously-created OTP code and then exchanges the
   * valid code for Cognito credentials
   */
  readonly exchangeOTPCodeForCognitoCredentials: ICognitoCredentials;
  /** Re-sends the current OTP code for the given user email/phone number */
  readonly resendCurrentLoginOTP: ICreateOtp;
  /** Re-sends the verification email to the current user */
  readonly resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  /** Kicks off part one of Login Flow */
  readonly signInJWT?: Maybe<Scalars['Boolean']>;
  /** Validate & Sign up Sms Otp */
  readonly signUpSmsOtp: Scalars['String'];
  /** Validate the RBI generated JWT and exchange for cognito credentials */
  readonly validateAuthJwt: ICognitoCredentials;
  /** Sign up user with cognito returns a JWT */
  readonly signUp?: Maybe<Scalars['String']>;
  /** Re-sends the verification email to the current user */
  readonly sendPhoneVerification?: Maybe<Scalars['Boolean']>;
  /** Verifies the phone number for the given user */
  readonly verifyPhoneNumber?: Maybe<Scalars['Boolean']>;
  /**
   * Delete current user
   * @deprecated Use OneTrust to delete the user instead
   */
  readonly deleteMe?: Maybe<Scalars['Boolean']>;
  /** Kicks off email with all data we have on the user */
  readonly requestMyInfo?: Maybe<Scalars['Boolean']>;
  /** Create a support case */
  readonly createSupportCase?: Maybe<ISupportCase>;
  /** Save a delivery address */
  readonly saveDeliveryAddress: IDeliveryAddressResponse;
  /** Remove a delivery address */
  readonly removeDeliveryAddress: IDeliveryAddressResponse;
}


export interface IMutationRedeemCouponArgs {
  couponId: Scalars['ID'];
}


export interface IMutationCommunicationPreferencesUpdateArgs {
  input: ICommunicationPreferencesUpdateInput;
}


export interface IMutationCreateFavoriteArgs {
  input: IFavoriteInput;
}


export interface IMutationUpdateFavoriteArgs {
  favoriteId: Scalars['String'];
  input: IFavoriteInput;
}


export interface IMutationDeleteFavoriteArgs {
  favoriteId: Scalars['String'];
}


export interface IMutationCommitOrderArgs {
  input: ICommitOrderInput;
  delivery: Maybe<ICommitDeliveryInput>;
  skipCoolingPeriod: Maybe<Scalars['Boolean']>;
}


export interface IMutationOrderCommitArgs {
  input: IOrderCommitInput;
}


export interface IMutationOrderUpdateArgs {
  input: IOrderUpdateInput;
}


export interface IMutationPriceOrderArgs {
  input: IPriceOrderInput;
  delivery: Maybe<IPriceDeliveryInput>;
  catering: Maybe<IPriceCateringInput>;
}


export interface IMutationOrderPriceArgs {
  input: IOrderPriceInput;
}


export interface IMutationOrderPriceMockArgs {
  input: IOrderPriceInput;
}


export interface IMutationUpdateOrderArgs {
  input: IUpdateOrderInput;
}


export interface IMutationCreateGroupArgs {
  adminUserId: Maybe<Scalars['String']>;
  expiryTime: Maybe<Scalars['Float']>;
}


export interface IMutationAddOrderToGroupArgs {
  orderId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
}


export interface IMutationAddFavoriteRestaurantArgs {
  storeId: Scalars['String'];
}


export interface IMutationRemoveFavoriteRestaurantArgs {
  storeId: Scalars['String'];
}


export interface IMutationVaultCreditAccountArgs {
  input: IVaultCreditAccountInput;
}


export interface IMutationAddCreditAccountArgs {
  input: IAddCreditAccountInput;
}


export interface IMutationAccountDeleteArgs {
  input: IAccountDeleteInput;
}


export interface IMutationPrepaidsMergeArgs {
  input: IPrepaidsMergeInput;
}


export interface IMutationPrepaidsReloadArgs {
  input: IPrepaidsReloadInput;
}


export interface IMutationDeleteAccountArgs {
  input: IDeleteAccountInput;
}


export interface IMutationPrepaidsBalanceArgs {
  cardNumber: Scalars['String'];
  feCountryCode: Maybe<IsoCountryCode>;
  pin: Maybe<Scalars['String']>;
}


export interface IMutationAddGiftAccountArgs {
  input: IAddGiftAccountInput;
}


export interface IMutationSetScanAndPayAccountArgs {
  input: ISetScanAndPayAccountInput;
}


export interface IMutationSetScanAndPayEnabledArgs {
  input: ISetScanAndPayEnabledInput;
}


export interface IMutationGiftCardLoadArgs {
  input: IGiftCardLoadInput;
}


export interface IMutationSetGiftCardReloadAccountArgs {
  input: ISetGiftCardReloadAccountInput;
}


export interface IMutationSetOrderingAccountArgs {
  input: ISetOrderingAccountInput;
}


export interface IMutationSaveSmileCookieVolunteerArgs {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  volunteerStartTime: Scalars['String'];
  volunteerEndTime: Scalars['String'];
  storeId: Scalars['String'];
  captcha: Scalars['String'];
}


export interface IMutationAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsArgs {
  token: Scalars['String'];
}


export interface IMutationActivateLoyaltyOfferArgs {
  tokenId: Scalars['String'];
}


export interface IMutationAddVoucherArgs {
  voucherId: Scalars['String'];
}


export interface IMutationClaimLoyaltyRollUpTheRimPrizeArgs {
  email: Scalars['String'];
  giftCardValueCents: Maybe<Scalars['Int']>;
  isMajorPrize: Scalars['Boolean'];
  isTimHortonsGiftCard: Scalars['Boolean'];
  language: Scalars['String'];
  name: Scalars['String'];
  referenceId: Scalars['String'];
}


export interface IMutationDeleteLoyaltyCardArgs {
  existingCardId: Scalars['String'];
}


export interface IMutationMergeLoyaltyCardsArgs {
  cardId: Scalars['String'];
  existingCardId: Scalars['String'];
}


export interface IMutationRevealLoyaltyRollUpTheRimTimelineEventRollArgs {
  referenceId: Scalars['String'];
  developmentPrize: Maybe<Scalars['String']>;
}


export interface IMutationSetLoyaltyDonationUpchargeArgs {
  cardId: Scalars['String'];
  donationUpcharge: Scalars['Boolean'];
}


export interface IMutationSetLoyaltyRewardsTierArgs {
  cardId: Scalars['String'];
  rewardsTier: Scalars['String'];
}


export interface IMutationSetRewardsRedemptionEnabledArgs {
  input: ISetRewardsRedemptionEnabledInput;
}


export interface IMutationSetRewardsRedemptionLevelArgs {
  input: ISetRewardsRedemptionLevelInput;
}


export interface IMutationSetLoyaltyScanAndPayArgs {
  cardId: Scalars['String'];
  defaultPaymentMethodId: Maybe<Scalars['String']>;
  scanAndPay: Scalars['Boolean'];
}


export interface IMutationShareLoyaltyRollUpTheRimTimelineEventRollsArgs {
  quantity: Scalars['Int'];
}


export interface IMutationSetShowThLoyaltyOnboardingArgs {
  setShowThLoyaltyOnboarding: Scalars['Boolean'];
}


export interface IMutationAddGiftOfferByEmailArgs {
  input: IGiftOfferInput;
}


export interface IMutationAddOfferByTokenArgs {
  token: Scalars['String'];
}


export interface IMutationInitiateLinkingArgs {
  partnerId: Scalars['String'];
  source: PartnerLinkSource;
}


export interface IMutationCompleteLinkingArgs {
  partnerId: Scalars['String'];
  source: PartnerLinkSource;
  authCode: Scalars['String'];
  codeVerifier: Scalars['String'];
}


export interface IMutationDelinkPartnerArgs {
  partnerId: Scalars['String'];
}


export interface IMutationCreateLoginForVendorArgs {
  vendor: Scalars['String'];
}


export interface IMutationCreateOtpArgs {
  input: ICreateOtpInput;
}


export interface IMutationCreateLoginOtpArgs {
  input: ICreateOtpInput;
}


export interface IMutationCreateSmsOtpArgs {
  input: ICreateSmsOtpInput;
}


export interface IMutationExchangeOtpCodeForCognitoCredentialsArgs {
  input: IExchangeOtpCodeForCredentialsInput;
}


export interface IMutationResendCurrentLoginOtpArgs {
  input: IResendOtpInput;
}


export interface IMutationResendVerificationEmailArgs {
  input: IResendVerificationEmailInput;
}


export interface IMutationSignInJwtArgs {
  userInfo: ISignInUserInput;
}


export interface IMutationSignUpSmsOtpArgs {
  input: ISignUpSmsOtpInput;
}


export interface IMutationValidateAuthJwtArgs {
  authInput: IValidateAuthJwtInput;
}


export interface IMutationSignUpArgs {
  userInfo: ISignUpUserInput;
}


export interface IMutationSendPhoneVerificationArgs {
  input: IResendPhoneVerificationInput;
}


export interface IMutationVerifyPhoneNumberArgs {
  input: IVerifyPhoneNumberInput;
}


export interface IMutationCreateSupportCaseArgs {
  caseInfo: ISupportCaseInput;
}


export interface IMutationSaveDeliveryAddressArgs {
  input: ISaveDeliveryAddressInput;
}


export interface IMutationRemoveDeliveryAddressArgs {
  input: IRemoveDeliveryAddressInput;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Node
 *
 * Interface that is implemented by an application data node.
 */
export interface INode {
  readonly id?: Maybe<Scalars['ID']>;
}

export interface INutrition {
  readonly __typename?: 'Nutrition';
  readonly calories?: Maybe<Scalars['Float']>;
  readonly fat?: Maybe<Scalars['Float']>;
  readonly saturatedFat?: Maybe<Scalars['Float']>;
  readonly transFat?: Maybe<Scalars['Float']>;
  readonly cholesterol?: Maybe<Scalars['Float']>;
  readonly sodium?: Maybe<Scalars['Float']>;
  readonly carbohydrates?: Maybe<Scalars['Float']>;
  readonly fiber?: Maybe<Scalars['Float']>;
  readonly sugar?: Maybe<Scalars['Float']>;
  readonly proteins?: Maybe<Scalars['Float']>;
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IOfferVariable {
  readonly __typename?: 'OfferVariable';
  /** The key of OfferVariable. */
  readonly key: Scalars['String'];
  /**
   * The type of OfferVariable to be used by FE. Available types:
   * 'currency',
   * 'datetime',
   * 'int',
   * 'number',
   * 'string',
   */
  readonly type: Scalars['String'];
  /** The value of OfferVariable. */
  readonly value: Scalars['String'];
}

/**
 * Operating hours for a restaurant in local time formatted
 * as "YYYY-MM-DD hh:mm:ss" (the date component should be ignored)
 */
export interface IOperatingHours {
  readonly __typename?: 'OperatingHours';
  /** Monday operating hours open */
  readonly monOpen?: Maybe<Scalars['String']>;
  /** Monday operating hours close */
  readonly monClose?: Maybe<Scalars['String']>;
  /** Tuesday operating hours open */
  readonly tueOpen?: Maybe<Scalars['String']>;
  /** Tuesday operating hours close */
  readonly tueClose?: Maybe<Scalars['String']>;
  /** Wednesday operating hours open */
  readonly wedOpen?: Maybe<Scalars['String']>;
  /** Wednesday operating hours close */
  readonly wedClose?: Maybe<Scalars['String']>;
  /** Thursday operating hours open */
  readonly thrOpen?: Maybe<Scalars['String']>;
  /** Thursday operating hours close */
  readonly thrClose?: Maybe<Scalars['String']>;
  /** Friday operating hours open */
  readonly friOpen?: Maybe<Scalars['String']>;
  /** Friday operating hours close */
  readonly friClose?: Maybe<Scalars['String']>;
  /** Saturday operating hours open */
  readonly satOpen?: Maybe<Scalars['String']>;
  /** Saturday operating hours close */
  readonly satClose?: Maybe<Scalars['String']>;
  /** Sunday operating hours open */
  readonly sunOpen?: Maybe<Scalars['String']>;
  /** Sunday operating hours close */
  readonly sunClose?: Maybe<Scalars['String']>;
}

export enum OperationalStatus {
  CLOSED = 'CLOSED',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPEN = 'OPEN',
  PROJECTED = 'PROJECTED'
}

export interface IOption {
  readonly __typename?: 'Option';
  readonly id: Scalars['String'];
  readonly options?: Maybe<ReadonlyArray<IModifier>>;
}

export interface IOrbitalPayment {
  /**
   * Represents a saved funding source. (i.e. orbitalIdentifier or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
   *
   * In the case of the Chase -> Orbital migration, this accountIdentifier is also equivalent
   * to the value of chaseProfileId from the Chase payment record.
   */
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  /**
   * When true, payment details will be saved as a recurring payment method in Adyen
   * Currently unused for the Chase -> Orbital migration
   */
  readonly savePaymentMethod?: Maybe<Scalars['Boolean']>;
  /**
   * Encrypted Payment Payload. If accountIdentifier is not passed this will be used.
   * Currently unused for the Chase -> Orbital migration
   */
  readonly encryptedPayload?: Maybe<IAddOrbitalAccountInput>;
}

export interface IOrder {
  readonly __typename?: 'Order';
  readonly cart: ICart;
  readonly catering?: Maybe<ICatering>;
  readonly createdAt: Scalars['String'];
  readonly channel?: Maybe<Scalars['String']>;
  readonly delivery?: Maybe<IDelivery>;
  readonly earliestPickupTimeInSeconds?: Maybe<Scalars['Int']>;
  readonly fireOrderIn?: Maybe<Scalars['Int']>;
  readonly fulfillmentDetails?: Maybe<IFulfillmentDetails>;
  /** Same value as rbiOrderId, used for Apollo Cache */
  readonly id?: Maybe<Scalars['String']>;
  readonly order?: Maybe<IRbiOrder>;
  readonly orderNumberFormatted?: Maybe<Scalars['String']>;
  readonly pk: Scalars['String'];
  readonly posOrderId?: Maybe<Scalars['String']>;
  readonly posVendor: PosVendor;
  readonly rbiOrderId: Scalars['String'];
  readonly revision: Scalars['Int'];
  readonly sk: Scalars['String'];
  readonly status: RbiOrderStatus;
  readonly updatedAt: Scalars['String'];
  readonly userId?: Maybe<Scalars['String']>;
  readonly userSortKey: Scalars['String'];
  readonly loyaltyTransaction?: Maybe<ILoyaltyTransaction>;
}

export interface IOrderCommitInput {
  /** ID for an order that has been priced */
  readonly orderId: Scalars['ID'];
  /** Store/Restaurant ID */
  readonly restaurantId: Scalars['ID'];
  /** Service mode needed to check for restaurant availability */
  readonly serviceMode: ServiceMode;
  /** Payment details */
  readonly payment: IPaymentInputV2;
  /** Delivery details */
  readonly delivery?: Maybe<ICommitDeliveryInput>;
  /** Delay order commit by specified minutes */
  readonly fireOrderInMinutes?: Maybe<Scalars['Int']>;
  /** Allows multiple orders */
  readonly skipCoolingPeriod?: Maybe<Scalars['Boolean']>;
}

export interface IOrderCommitPayload {
  readonly __typename?: 'OrderCommitPayload';
  readonly order: IOrderV2;
}

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
  TEMPORARY_UNAVAILABLE = 'temporary_unavailable',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable'
}

export interface IOrderLine {
  readonly __typename?: 'OrderLine';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly quantity: Scalars['Int'];
  readonly price?: Maybe<IMoney>;
  readonly orderModifiers: ReadonlyArray<IOrderModifier>;
  readonly available: Scalars['Boolean'];
  readonly rewardApplied: Scalars['Boolean'];
}

export interface IOrderLineInput {
  readonly lineId: Scalars['String'];
  readonly productVariantId: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly selectedModifiers?: Maybe<ReadonlyArray<ISelectedModifierOptionInput>>;
  readonly price: IMoneyInput;
  readonly itemPath: Scalars['String'];
}

export interface IOrderListResponse {
  readonly __typename?: 'OrderListResponse';
  readonly count: Scalars['Int'];
  readonly orders?: Maybe<ReadonlyArray<Maybe<IOrder>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface IOrderModifier {
  readonly __typename?: 'OrderModifier';
  readonly name: Scalars['String'];
  readonly price?: Maybe<IMoney>;
}

export interface IOrderPriceInput {
  readonly menuContext: IMenuContext;
  readonly lines: ReadonlyArray<IOrderLineInput>;
  readonly delivery?: Maybe<IPriceDeliveryInputV2>;
}

export interface IOrderPricePayload {
  readonly __typename?: 'OrderPricePayload';
  readonly order: IOrderV2;
}

export interface IOrderRestaurant {
  readonly __typename?: 'OrderRestaurant';
  readonly address1?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly stateProvince?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Country>;
}

export enum OrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  WAITING_FOR_PREP = 'WAITING_FOR_PREP'
}

export interface IOrderTotals {
  readonly __typename?: 'OrderTotals';
  readonly exceedsMaxSubtotal: Scalars['Boolean'];
  readonly subtotal?: Maybe<IMoney>;
  readonly tax?: Maybe<IMoney>;
  readonly total?: Maybe<IMoney>;
  readonly donations?: Maybe<IMoney>;
  readonly rewardSavings?: Maybe<IMoney>;
  readonly savings?: Maybe<IMoney>;
  readonly deliveryFees?: Maybe<IDeliveryFees>;
  readonly cartFees?: Maybe<ReadonlyArray<ICartFee>>;
}

export interface IOrderUpdateInput {
  /** ID for an order that needs to be triggered immediately */
  readonly orderId: Scalars['ID'];
  /** If true, cancel the order (refund payment). Only valid for Temporal workflow orders in WAITING_FOR_PREP state. */
  readonly cancel?: Maybe<Scalars['Boolean']>;
}

export interface IOrderUpdatePayload {
  readonly __typename?: 'OrderUpdatePayload';
  readonly order: IOrderV2;
}

export interface IOrderV2 {
  readonly __typename?: 'OrderV2';
  readonly id: Scalars['ID'];
  readonly status?: Maybe<OrderStatus>;
  readonly orderRestaurant: IOrderRestaurant;
  readonly serviceMode?: Maybe<ServiceMode>;
  /**
   * The time the order will be ready for pickup. It is null for delivery orders or
   * if the order is already fired for preparation.
   */
  readonly prepStartTime?: Maybe<Scalars['DateTime']>;
  readonly customerName?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
  readonly lines: ReadonlyArray<IOrderLine>;
  readonly totals?: Maybe<IOrderTotals>;
  readonly delivery?: Maybe<IDeliveryV2>;
  readonly createdAt: Scalars['DateTime'];
  readonly updatedAt: Scalars['DateTime'];
}

export interface IOverride {
  readonly __typename?: 'Override';
  readonly key?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly price?: Maybe<Scalars['Int']>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 *
 * Page information to determine if there are more results, and what node,
 * determined by it's cursor, is at the start and end of the page returned.
 */
export interface IPageInfo {
  readonly __typename?: 'PageInfo';
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor?: Maybe<Scalars['String']>;
  readonly endCursor?: Maybe<Scalars['String']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu';
  readonly plu?: Maybe<Scalars['String']>;
  readonly childPlu?: Maybe<Scalars['String']>;
}

export interface IParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>;
  readonly childPlu?: Maybe<Scalars['String']>;
}

/**
 * Entry point that initiated a partnership link. Persisted verbatim on
 * the `PartnerLinks` row per the RFC data model. Extend this list as
 * new entry points need to be distinguishable for product / analytics.
 */
export enum PartnerLinkSource {
  /** Partnership Hub inside the Tim Hortons native app. */
  TH_APP = 'TH_APP',
  /** Partnership Hub on the Tim Hortons web experience. */
  TH_WEB = 'TH_WEB',
  /**
   * Tim Hortons native app entry point, expressed with CT's own channel
   * value so the source is persisted verbatim (no TH_APP -> THIAPP remap).
   */
  THIAPP = 'THIAPP',
  /**
   * Tim Hortons web entry point, expressed with CT's own channel value so
   * the source is persisted verbatim (no TH_WEB -> THIWEB remap).
   */
  THIWEB = 'THIWEB',
  /**
   * Followed a partner marketing / deep-link (email, push, ad) into
   * the linking flow rather than entering via the Partnership Hub.
   */
  DEEP_LINK = 'DEEP_LINK'
}

/**
 * Current link state between a TH user and a loyalty partner.
 *
 * `status` is derived from the latest `PartnerLinks` row for
 * `(thLegacyCognitoId, partner_id)`:
 *
 * - `LINKED`     — latest successful link; user is actively earning with the partner.
 * - `DELINKED`   — latest row is an explicit delink.
 * - `NOT_LINKED` — no history at all, or only pending/expired INITIATED rows.
 */
export interface IPartnerLinkStatus {
  readonly __typename?: 'PartnerLinkStatus';
  /** Partner identifier, e.g. "CT" for Canadian Tire / Triangle Rewards. */
  readonly partnerId: Scalars['String'];
  /** Current link status derived from the latest append-only row. */
  readonly status: LinkStatus;
  /**
   * ISO-8601 timestamp of the row that produced `status`.
   * Null when the user has no history for this partner (`NOT_LINKED`).
   */
  readonly eventTimestamp?: Maybe<Scalars['String']>;
}

export interface IPaycometPayment {
  /** Represents the PSP id for the payment */
  readonly pspReference?: Maybe<Scalars['String']>;
  /** Stored payment method identifier */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>;
}

export interface IPayMarkPayment {
  /** Represents the PSP id for the payment */
  readonly pspReference?: Maybe<Scalars['String']>;
  /** Stored payment method identifier */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Merchant Account */
  readonly merchantAccount?: Maybe<Scalars['String']>;
}

export interface IPayment {
  readonly __typename?: 'Payment';
  readonly approvalNumber?: Maybe<Scalars['String']>;
  readonly cardType?: Maybe<Scalars['String']>;
  readonly ccLast4?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly fdSaleId: Scalars['String'];
  readonly panToken?: Maybe<Scalars['String']>;
  readonly paymentType?: Maybe<CartPaymentType>;
}

export interface IPaymentInput {
  /**
   * Adyen payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly adyenInput?: Maybe<IAdyenPayment>;
  /** Details from Apple Pay for payment. */
  readonly applePayDetails?: Maybe<IApplePay>;
  /** Billing address associated to card */
  readonly billingAddress?: Maybe<IBillingAddressInput>;
  /** Denotes a cash payment */
  readonly cashPayment?: Maybe<Scalars['Boolean']>;
  /** Contains supplemental data for CC transactions */
  readonly ccMetadata?: Maybe<ICreditCardMetadataInput>;
  /** chase id from TH endpoint to trigger direct payment */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  /** First Data payment data */
  readonly firstDataInput?: Maybe<IFirstDataPayment>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  /** Details from Google Pay for payment. */
  readonly googlePayDetails?: Maybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: Maybe<Scalars['String']>;
  /**
   * VR Payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly vrPaymentInput?: Maybe<IVrPayment>;
  /**
   * PayMark Payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly payMarkInput?: Maybe<IPayMarkPayment>;
  /**
   * Firstpay Payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly firstPayInput?: Maybe<IFirstpayPayment>;
  /**
   * Paycomet Payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly paycometInput?: Maybe<IPaycometPayment>;
  /** Orbital Payment data */
  readonly orbitalInput?: Maybe<IOrbitalPayment>;
  /**
   * Worldpay Payment data
   * @deprecated(reason: "This payment provider is not supported by TH")
   */
  readonly worldpayInput?: Maybe<IWorldpayPayment>;
}

export interface IPaymentInputV2 {
  /** Account ID for credit cards or Tim card */
  readonly accountId?: Maybe<Scalars['ID']>;
  /** Apple Pay details */
  readonly applePayDetails?: Maybe<IApplePayDetails>;
  /** Google Pay details */
  readonly googlePayDetails?: Maybe<IGooglePayDetails>;
}

export interface IPaymentMethodData {
  /** Card display name with last 4 digits of the credit card */
  readonly displayName?: Maybe<Scalars['String']>;
  /** Payment type used for digital pay */
  readonly paymentType?: Maybe<Scalars['String']>;
  /** Card type used for digital pay */
  readonly paymentMethodType?: Maybe<Scalars['String']>;
}

export interface IPaymentMethodInput {
  readonly displayName?: Maybe<Scalars['String']>;
  readonly network?: Maybe<Scalars['String']>;
}

/** ***** End of Legacy Typings ***** */
export enum PaymentMethodType {
  SCHEME = 'SCHEME',
  PREPAID = 'PREPAID',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL_FAST = 'PAYPAL_FAST'
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  CHASE = 'CHASE',
  FIRSTDATA = 'FIRSTDATA',
  VRPAYMENT = 'VRPAYMENT',
  ORBITAL = 'ORBITAL',
  PAYMARK = 'PAYMARK',
  FIRSTPAY = 'FIRSTPAY',
  WORLDPAY = 'WORLDPAY'
}

export interface IPayPalFastStoredPaymentMethod extends IStoredPaymentMethod {
  readonly __typename?: 'PayPalFastStoredPaymentMethod';
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Type of payment method */
  readonly type: PaymentMethodType;
  /** Stored payment billing agreement id */
  readonly billingAgreementId: Scalars['String'];
}

export interface IPhysicalAddress {
  readonly __typename?: 'PhysicalAddress';
  readonly address1?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly stateProvince?: Maybe<Scalars['String']>;
  readonly stateProvinceShort?: Maybe<Scalars['String']>;
}

export interface IPlaceCateringOrderInput {
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   */
  readonly billingAddress?: Maybe<IBillingAddressInput>;
  /**
   * Catering Information
   * contains Datetime for the catering
   */
  readonly cateringInfo: ICateringInfoInput;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: Maybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: Maybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: Maybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: Maybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: Maybe<CartPaymentCardType>;
  /** Store email address */
  readonly storeEmail?: Maybe<Scalars['String']>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: Maybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   */
  readonly fdNonce?: Maybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Customer full name */
  readonly fullName?: Maybe<Scalars['String']>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: Maybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: Maybe<Scalars['String']>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: Maybe<IResumeThreeDSaleTransaction>;
}

export enum Platform {
  APP = 'app',
  KIOSK = 'kiosk',
  WEB = 'web'
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IPlu {
  readonly __typename?: 'Plu';
  readonly connector?: Maybe<Scalars['String']>;
  readonly ncr?: Maybe<Scalars['String']>;
  readonly ncrDelivery?: Maybe<Scalars['String']>;
  readonly oheics?: Maybe<Scalars['String']>;
  readonly oheicsDelivery?: Maybe<Scalars['String']>;
  readonly partner?: Maybe<Scalars['String']>;
  readonly partnerDelivery?: Maybe<Scalars['String']>;
  readonly productNumber?: Maybe<Scalars['String']>;
  readonly productNumberDelivery?: Maybe<Scalars['String']>;
  readonly qst?: Maybe<Scalars['String']>;
  readonly qstDelivery?: Maybe<Scalars['String']>;
  readonly sicom?: Maybe<Scalars['String']>;
  readonly sicomDelivery?: Maybe<Scalars['String']>;
  readonly simplyDelivery?: Maybe<Scalars['String']>;
  readonly simplyDeliveryDelivery?: Maybe<Scalars['String']>;
}

export interface IPluInput {
  readonly connector?: Maybe<Scalars['String']>;
  readonly ncr?: Maybe<Scalars['String']>;
  readonly ncrDelivery?: Maybe<Scalars['String']>;
  readonly oheics?: Maybe<Scalars['String']>;
  readonly oheicsDelivery?: Maybe<Scalars['String']>;
  readonly partner?: Maybe<Scalars['String']>;
  readonly partnerDelivery?: Maybe<Scalars['String']>;
  readonly productNumber?: Maybe<Scalars['String']>;
  readonly qst?: Maybe<Scalars['String']>;
  readonly qstDelivery?: Maybe<Scalars['String']>;
  readonly rpos?: Maybe<Scalars['String']>;
  readonly rposDelivery?: Maybe<Scalars['String']>;
  readonly sicom?: Maybe<Scalars['String']>;
  readonly sicomDelivery?: Maybe<Scalars['String']>;
  readonly simplyDelivery?: Maybe<Scalars['String']>;
  readonly simplyDeliveryDelivery?: Maybe<Scalars['String']>;
}

/** PluPrice represents the price of a menu entity. */
export interface IPluPrice {
  readonly __typename?: 'PluPrice';
  /**
   * Price Lookup Unit (PLU) is a vendor-specific menu entry identifier.
   *
   * "Compound" PLUs are individual PLUs joined with the "-" character, and
   * represent the price of entity in the context of another parent entity. For
   * example the compound PLU "123-456" represents the price of menu item "456"
   * in the combo "123".
   */
  readonly plu: Scalars['String'];
  /** PLU price in cents. */
  readonly price: Scalars['Int'];
}

export enum PosDataServiceMode {
  DELIVERY = 'delivery',
  PICKUP = 'pickup'
}

export enum PosVendor {
  BRINK = 'BRINK',
  CARROLS = 'CARROLS',
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  OHEICS = 'OHEICS',
  PARTNER = 'PARTNER',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  QST = 'QST',
  RPOS = 'RPOS',
  SICOM = 'SICOM',
  SIMPLY_DELIVERY = 'SIMPLY_DELIVERY',
  TABLET = 'TABLET',
  XENIAL = 'XENIAL'
}

/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface IPrepaidsMergeInput {
  /** Destination first data gift card Account ID gets balance from source */
  readonly destinationFdAccountId?: Maybe<Scalars['String']>;
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: Scalars['String'];
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: Maybe<Scalars['String']>;
}

/** Reload a prepaid gift card (payment method) */
export interface IPrepaidsReloadInput {
  /** Country of currency to reload card */
  readonly countryCode?: Maybe<CountryCode>;
  /**
   * Vaulted first data Account ID (credit) used to fund gift card. Either this or applePayDetails is required.
   * Only one of fdAccountId or applePayDetails or googlePayDetails should be provided.
   */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /** First Data Account ID of prepaid gift card to be reloaded */
  readonly prepaidFdAccountId: Scalars['String'];
  /** Details from Apple Pay for funding. Only one of fdAccountId or applePayDetails or googlePayDetails should be provided. */
  readonly applePayDetails?: Maybe<IApplePay>;
  /** Details from Goole Pay for funding. Only one of fdAccountId or applePayDetails or googlePayDetails should be provided. */
  readonly googlePayDetails?: Maybe<IGooglePay>;
  /**
   * Unique Kount Session ID 32 characters long Example:
   * faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: Maybe<Scalars['String']>;
  /** Session ID as set by the FE. Note that the "sessionId" field is deprecated and will be ignored. */
  readonly sessionId?: Maybe<Scalars['String']>;
}

export interface IPrepaidStoredPaymentMethod extends IStoredPaymentMethod {
  readonly __typename?: 'PrepaidStoredPaymentMethod';
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Type of payment method */
  readonly type: PaymentMethodType;
  /** Last 4 digits of card number */
  readonly last4: Scalars['String'];
  /** Balance in the smallest currency unit (e.g. USD Cent) */
  readonly balance: Scalars['Int'];
  /** Currency */
  readonly currency: Scalars['String'];
  /** Shuffled card number */
  readonly shuffledCardNumber: Scalars['String'];
}

/** A transaction for a prepaid gift card */
export interface IPrepaidTransaction {
  readonly __typename?: 'PrepaidTransaction';
  /** First Data account ID */
  readonly amount: Scalars['Int'];
  readonly currencyCode: ICurrencyCode;
  readonly info: Scalars['String'];
  readonly transactionTime: Scalars['String'];
}

export interface IPrice {
  readonly __typename?: 'Price';
  readonly default?: Maybe<Scalars['Int']>;
  readonly max?: Maybe<Scalars['Int']>;
  readonly min?: Maybe<Scalars['Int']>;
  readonly overrides?: Maybe<ReadonlyArray<IOverride>>;
}

export interface IPriceCateringInput {
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  readonly includeUtensils: Scalars['Boolean'];
  readonly maskedPhoneNumber?: Maybe<Scalars['String']>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly numberOfGuests: Scalars['Int'];
  readonly organizerName: Scalars['String'];
  readonly pickupEmail: Scalars['String'];
  readonly pickupPhoneNumber: Scalars['String'];
  readonly pickupTime: Scalars['String'];
}

export interface IPriceDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>;
  readonly dropoff: IDeliveryWaypointInput;
  readonly tipCents?: Maybe<Scalars['Int']>;
  readonly quoteId?: Maybe<Scalars['String']>;
}

/**
 * For the new flow we aim to have the quoteId be mandatory.
 * It is unclear when the user can price a delivery order without a quoteId.
 */
export interface IPriceDeliveryInputV2 {
  readonly dropoff: IDeliveryWaypointInputV2;
  readonly quoteId: Scalars['String'];
  readonly tipCents?: Maybe<Scalars['Int']>;
}

export interface IPriceOrderInput {
  /** payment method - for cash orders */
  readonly paymentMethod?: Maybe<CartPaymentCardType>;
  /** Store Address, derived from MDM. */
  readonly storeAddress: IStoreAddressInput;
  /** Store ID, derived from MDM. This value will be validated within First Data. */
  readonly storeId: Scalars['String'];
  /** The internal Store ID. */
  readonly storePosId?: Maybe<Scalars['String']>;
  /** The brand of the store. */
  readonly brand: Brand;
  /** The Platform */
  readonly platform?: Maybe<Platform>;
  /** The POS Vendor */
  readonly posVendor: PosVendor;
  /** The locale of the customer. */
  readonly customerLocale?: Maybe<Scalars['String']>;
  /**
   * The name of the customer. If provided, this will
   * supersede the user's name on this order.
   */
  readonly customerName?: Maybe<Scalars['String']>;
  /** How the order will be executed. */
  readonly serviceMode: ServiceMode;
  /** Requested sale amount in cents (USD) */
  readonly requestedAmountCents: Scalars['Int'];
  /** The order cart entries to be injected into the POS. */
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>;
  /** The cart shape version. */
  readonly cartVersion?: Maybe<Scalars['Int']>;
  /** barcode of user's loyalty card to apply reward/visit */
  readonly loyaltyBarcode?: Maybe<Scalars['String']>;
  /** quoteId associated to */
  readonly quotedId?: Maybe<Scalars['String']>;
  /** flag for reward redemption, if true must provide loyaltyBarcode */
  readonly redeemReward?: Maybe<Scalars['Boolean']>;
  /** Offers applied to cart */
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<IAppliedOffer>>>;
  /** Reward ids being applied to cart */
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<IAppliedReward>>>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /**
   * Cart Item swaps being applied to cart
   * @deprecated(reason: "Not needed anymore since it is included in AppliedOffer")
   */
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ISwapInput>>>;
  /** vat number on the restaurant document for BK UK */
  readonly vatNumber?: Maybe<Scalars['String']>;
}

/**
 * Source of the price for a given SKU.
 * Maps to PriceSource from pricing domain (NX-3008).
 */
export enum PriceSource {
  /** Base price from the region pricing table */
  REGION_BASE = 'REGION_BASE',
  /** Restaurant-level price override */
  RESTAURANT_OVERRIDE = 'RESTAURANT_OVERRIDE',
  /** Promotional price applied */
  PROMOTION = 'PROMOTION'
}

export interface IProduct {
  readonly __typename?: 'Product';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly image: IImage;
  readonly description?: Maybe<Scalars['String']>;
  /** The options for the product, such as 'Size' or 'Brew' */
  readonly options: ReadonlyArray<IProductOption>;
  /**
   * Whether a product has exactly one variant
   * @deprecated This field fulfills an interim purpose - it will be removed in future
   */
  readonly isSingleVariant: Scalars['Boolean'];
  /** The default variant of the product. All products have a default variant */
  readonly defaultVariant: IProductVariant;
  /** All product variants, including the default variant; all Products have at least one variant */
  readonly variants: ReadonlyArray<IProductVariant>;
}

export interface IProductCategory {
  readonly __typename?: 'ProductCategory';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly image: IImage;
  readonly description?: Maybe<Scalars['String']>;
  readonly items: ReadonlyArray<IProductItem>;
}

export interface IProductCategoryInput {
  readonly context: IMenuContext;
  readonly productCategoryId?: Maybe<Scalars['String']>;
}

export interface IProductHierarchyInput {
  readonly L1?: Maybe<Scalars['String']>;
  readonly L2?: Maybe<Scalars['String']>;
  readonly L3?: Maybe<Scalars['String']>;
  readonly L4?: Maybe<Scalars['String']>;
  readonly L5?: Maybe<Scalars['String']>;
}

export interface IProductInput {
  readonly context: IMenuContext;
  readonly productId: Scalars['String'];
}

export type IProductItem = IProduct | IProductCategory;

/** A modifier for a product variant. For example, "Vanilla Syrup". */
export interface IProductModifier {
  readonly __typename?: 'ProductModifier';
  readonly id: Scalars['ID'];
  /** The label for the modifier. For example, "Vanilla Syrup". */
  readonly label: Scalars['String'];
  /** Type of the modifier. */
  readonly modifierType?: Maybe<ModifierGroupType>;
  /**
   * Options for the modifier, e.g. ['1', '2'] for 1 or 2 shots of 'Vanilla Syrup',
   * or ['Regular', 'Extra'] for 'Cheddar Cheese'
   */
  readonly options: ReadonlyArray<IModifierOption>;
  /** The default option for the modifier */
  readonly defaultOption?: Maybe<IModifierOption>;
  /**
   * Whether this modifier should be sent to POS. Modifiers marked as injectDefault
   * are essential components of fulfilling the overall order, for example the
   * bread in a sandwich.
   * @deprecated This field is deprecated and will be removed during cart rearchitecture
   * @deprecated This field is deprecated and will be removed during cart rearchitecture
   */
  readonly injectDefault: Scalars['Boolean'];
}

/** A customizable option for a product, such as 'Size' or 'Brew' */
export interface IProductOption {
  readonly __typename?: 'ProductOption';
  readonly id: Scalars['ID'];
  /** The name of the option, such as 'Size' */
  readonly name: Scalars['String'];
  /** The values for the option, such as 'Small', 'Medium', 'Large' */
  readonly values: ReadonlyArray<IProductOptionValue>;
}

/** A value for a product option */
export interface IProductOptionValue {
  readonly __typename?: 'ProductOptionValue';
  readonly id: Scalars['ID'];
  /** The name of the option value, such as 'Small' or 'Medium' */
  readonly name: Scalars['String'];
}

export interface IProductVariant {
  readonly __typename?: 'ProductVariant';
  readonly id: Scalars['ID'];
  /** Name of the variant, e.g. 'Large Decaf Coffee - Reusable Cup' */
  readonly name: Scalars['String'];
  /** Image for the variant */
  readonly image: IImage;
  /** Price of the variant */
  readonly price?: Maybe<IMoney>;
  /** Parent product that this variant belongs to */
  readonly product?: Maybe<IProduct>;
  /**
   * The calorie overview for this variant. May differ from ProductVariant.nutrition.calories -
   * we may show calories for a Product displayed within its parent ProductCategory, and also may show
   * nutrition at the bottom of a Product page. Depending on marketing decisions, the visibility of
   * these values may be toggled independently by setting them to null in the GraphQL response.
   */
  readonly calories?: Maybe<Scalars['Float']>;
  /** Nutrition for the variant */
  readonly nutrition?: Maybe<INutrition>;
  /** Ingredients list for the item */
  readonly ingredients?: Maybe<Scalars['String']>;
  /** Maps how the ProductVariant fulfills its Product's ProductOptions */
  readonly selectedProductOptions: ReadonlyArray<ISelectedProductOption>;
  /** The modifier groups for the product variant */
  readonly modifierGroups: ReadonlyArray<IModifierGroup>;
  /** Modifier presets, e.g. 'Double Double' indicates 2x cream and 2x sugar */
  readonly modifierPresets: ReadonlyArray<IModifierPreset>;
  /**
   * Vendor configs for the product variant allowing it to be identified by the POS
   * @deprecated Do not use. This field exposes internal vendor configuration and will be removed in a future release.
   */
  readonly vendorConfigsDoNotInspect: Scalars['JSON'];
  /** Legal disclaimer related to this variant */
  readonly legalDisclaimerHtml?: Maybe<Scalars['String']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu';
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IQuery {
  readonly __typename?: 'Query';
  /**
   * Evaluate all couponIds from sanity. All cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   */
  readonly evaluateAllUserOffers: ICouponUserOffersFeedback;
  /**
   * Evaluate user offers: either those in the cart or a set to be evaluated against one.
   * If no cart and no RBI order are specified, then all cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   * Setting the evaluateAllCouponIds flag will ignore couponIds and evaluate all couponIds from sanity.
   */
  readonly evaluateUserOffers: ICouponUserOffersFeedback;
  readonly listUserCouponTokens: ICouponTokenListResponse;
  /** Returns an available delivery restaurant based on vendor quote given provided address and search radius. */
  readonly deliveryRestaurant: IDeliveryRestaurant;
  readonly pypestreamUserId: Scalars['String'];
  /** Get a user favorite */
  readonly userFavorite: IFavorite;
  /** List of user favorites */
  readonly userFavorites: IFavoriteList;
  /** Query an order by order id for the current user. */
  readonly order?: Maybe<IOrder>;
  readonly uniqueStores: IOrderListResponse;
  /**
   * Query all orders for current user.
   *
   * Note that the "userId" field is deprecated and will be ignored.
   */
  readonly userOrders: IOrderListResponse;
  /** Entry point query for giftcard service */
  readonly giftCard?: Maybe<IGiftCardQueries>;
  /** Returns the gift card catalogue */
  readonly getCatalogue: ICatalogue;
  /** getGroup */
  readonly getGroup: IGroup;
  /** getGroupByAdminUserId */
  readonly getGroupByAdminUserId: IGroup;
  /** Returns the PLU-price map for a store. */
  readonly plusV2?: Maybe<ReadonlyArray<IPluPrice>>;
  /** Returns the minimum app version that guests are required to be on for the Tim Hortons app. */
  readonly appMinimumVersion?: Maybe<IAppMinimumVersion>;
  /**
   * Fetches detailed information about a specific product, including its name,
   * description, price, images, and available options.
   */
  readonly product?: Maybe<IProduct>;
  /** Retrieves details about a specific product category, such as its name, description, and associated products. */
  readonly productCategory?: Maybe<IProductCategory>;
  readonly storeMenu?: Maybe<ReadonlyArray<IEntity>>;
  readonly storeMenuWithConnectorHours?: Maybe<ReadonlyArray<IMenuEntityWithHours>>;
  readonly hello: Scalars['String'];
  /**
   * Returns a list of restaurants based on provided filters.
   * @todo: Return result with pagination metadata
   */
  readonly restaurants?: Maybe<IRestaurantsConnection>;
  /** Returns a restaurant entity given store id */
  readonly restaurant: IRestaurant;
  /**
   * Retrieves a list of the most recent items placed by the currently authenticated user.
   * Each order includes detailed information about the selected product variants,
   * such as product name, image, price, quantity, and applied modifiers.
   */
  readonly recentItems: ReadonlyArray<Maybe<ISelectedProductVariant>>;
  /** Retrieves a list of available upsell items */
  readonly upsellItems: IUpsellItemsPayload;
  /**
   * Query availability of all SKUs on a menu at a specific restaurant and time.
   * Returns only available SKUs based on time cards, overrides, and protection rules.
   * This query is designed to support Phase 6 feature flag gating.
   */
  readonly menuAvailability: IMenuAvailabilityResult;
  /**
   * Query pricing for all SKUs on a menu at a specific restaurant and service mode.
   * Returns base prices, final prices (after overrides/promotions), and price sources.
   */
  readonly menuPricing: IMenuPricingResult;
  /**
   * Returns the fully resolved menu for a guest context.
   * Every product includes its availability state and resolved price.
   */
  readonly consumerMenu: IConsumerMenuResponse;
  /** Fetch all accounts for current customer (limit 100) */
  readonly userAccounts?: Maybe<IAccountListResponse>;
  /** Return transaction history for prepaid gift card account from FD */
  readonly prepaidsTransactions?: Maybe<ITransactionListResponse>;
  /** Returns a  list of restaurant that are part of smile cookie volunteer program */
  readonly smileCookieEnabledRestaurants?: Maybe<IGetSmileCookieEnrolledRestaurantsResult>;
  /** Get the loyalty cards for a user. @todo put this on me */
  readonly getLoyaltyCards?: Maybe<ILoyaltyCardsResp>;
  /**
   * Get the loyalty cards for a user with metadata.
   * Also syncs loyaltyTier between THD & CTG
   */
  readonly getLoyaltyCardsWithDetails?: Maybe<ILoyaltyCardsWithDetailsResp>;
  /** Get the details for a user's loyalty card */
  readonly getLoyaltyCardDetails?: Maybe<ILoyaltyCardDetails>;
  /** Get the loyalty details for a user */
  readonly getLoyaltyDetails?: Maybe<ILoyaltyDetails>;
  /** Get the details for a user's loyalty card via barcode *UNAUTHENTICATED* */
  readonly getLoyaltyCardDetailsKiosk?: Maybe<ILoyaltyCardDetailsKiosk>;
  /** Gets a base64 encoded Apple Pass for a loyalty card */
  readonly getLoyaltyCardApplePass?: Maybe<ILoyaltyCardApplePass>;
  /** Gets a jwt for Google Pass for a loyalty card */
  readonly getLoyaltyCardGooglePass?: Maybe<ILoyaltyCardGooglePass>;
  /** Get the transactions for a user's loyalty card */
  readonly getLoyaltyCardTransactions?: Maybe<ILoyaltyCardTransactions>;
  /** Get the list of tokens representing shared rolls from a user's event timeline. */
  readonly getLoyaltyRollUpTheRimTimelineEventSharedRollTokens?: Maybe<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList>;
  /** Get the Roll Up The Rim timeline events for a user */
  readonly getLoyaltyRollUpTheRimTimelineEvents?: Maybe<ILoyaltyRollUpTheRimTimelineEventList>;
  /** Get the Roll Up The Rim timeline events for a user (V2 - returns rolls and prizes separately) */
  readonly getLoyaltyRollUpTheRimTimelineEventsV2?: Maybe<ILoyaltyRollUpTheRimTimelineEventListV2>;
  /** Get the Roll Up The Rim timeline events, summarized for a user */
  readonly getLoyaltyRollUpTheRimTimelineEventSummary?: Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryList>;
  /** Get the Roll Up The Rim prizes stats */
  readonly getLoyaltyRollUpTheRimPrizesStats?: Maybe<ILoyaltyRollUpTheRimPrizesStats>;
  /** Query all gift offers. */
  readonly listGiftOffers?: Maybe<IGiftOfferListResponse>;
  /** Get the loyalty rewards redemption categories. */
  readonly rewardsRedemptionCategories: ReadonlyArray<ILoyaltyRewardsRedemptionCategories>;
  /**
   * Get the current link status for a single partner (e.g. "CT").
   *
   * Returns `LINKED` / `DELINKED` / `NOT_LINKED` derived from the latest
   * `PartnerLinks` row for the authenticated user and the given partner.
   * Used for polling the Partnership Hub on focus.
   */
  readonly partnerLinkStatus: IPartnerLinkStatus;
  /**
   * Get the current link status for every partner the authenticated user
   * has a record for. Supports future multi-partner listings on the
   * Partnership Hub.
   */
  readonly partnerLinks: ReadonlyArray<IPartnerLinkStatus>;
  readonly signUpComplete?: Maybe<Scalars['Boolean']>;
  readonly userGeo: IUserGeo;
  /** Get word game challenge JWT */
  readonly wordGameJwt?: Maybe<Scalars['String']>;
  /** Get user info */
  readonly me: IUser;
}


export interface IQueryEvaluateAllUserOffersArgs {
  locale: Maybe<Locale>;
  platform: Maybe<Platform>;
  redeemedOn: Scalars['String'];
  serviceMode: Maybe<ServiceMode>;
  storeId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
}


export interface IQueryEvaluateUserOffersArgs {
  cart: Maybe<IPriceOrderInput>;
  couponIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  evaluateAllCouponIds: Maybe<Scalars['Boolean']>;
  locale: Maybe<Locale>;
  platform: Maybe<Platform>;
  rbiOrderId: Maybe<Scalars['ID']>;
  redeemedOn: Scalars['String'];
  serviceMode: Maybe<ServiceMode>;
  storeId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
}


export interface IQueryListUserCouponTokensArgs {
  couponId: Maybe<Scalars['ID']>;
  expiresAfter: Maybe<Scalars['String']>;
  expiresBefore: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
  resumeAfter: Maybe<Scalars['String']>;
  sortAscending: Maybe<Scalars['Boolean']>;
  userId: Maybe<Scalars['ID']>;
}


export interface IQueryDeliveryRestaurantArgs {
  dropoff: IDeliveryWaypointInput;
  searchRadius: Scalars['Float'];
  platform: Maybe<Platform>;
}


export interface IQueryUserFavoriteArgs {
  favoriteId: Scalars['String'];
}


export interface IQueryUserFavoritesArgs {
  limit: Maybe<Scalars['Int']>;
  resumeAfter: Maybe<Scalars['String']>;
  serviceModes: Maybe<ReadonlyArray<ServiceMode>>;
  sortAscending: Maybe<Scalars['Boolean']>;
}


export interface IQueryOrderArgs {
  rbiOrderId: Scalars['ID'];
}


export interface IQueryUniqueStoresArgs {
  createdAfter: Maybe<Scalars['String']>;
  createdBefore: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter: Maybe<Scalars['String']>;
  sortAscending: Maybe<Scalars['Boolean']>;
}


export interface IQueryUserOrdersArgs {
  createdAfter: Maybe<Scalars['String']>;
  createdBefore: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter: Maybe<Scalars['String']>;
  serviceModes: Maybe<ReadonlyArray<ServiceMode>>;
  channels: Maybe<ReadonlyArray<Scalars['String']>>;
  sortAscending: Maybe<Scalars['Boolean']>;
  userId: Maybe<Scalars['ID']>;
  shouldFilterByRegion: Maybe<Scalars['Boolean']>;
}


export interface IQueryGetGroupArgs {
  id: Maybe<Scalars['String']>;
}


export interface IQueryGetGroupByAdminUserIdArgs {
  id: Maybe<Scalars['String']>;
}


export interface IQueryPlusV2Args {
  storeId: Scalars['ID'];
  serviceMode?: Maybe<PosDataServiceMode>;
}


export interface IQueryProductArgs {
  input: Maybe<IProductInput>;
}


export interface IQueryProductCategoryArgs {
  input: Maybe<IProductCategoryInput>;
}


export interface IQueryStoreMenuArgs {
  region: Scalars['String'];
  channel: Channel;
  storeId: Scalars['ID'];
  serviceMode?: Maybe<PosDataServiceMode>;
}


export interface IQueryStoreMenuWithConnectorHoursArgs {
  region: Scalars['String'];
  channel: Channel;
  storeId: Scalars['ID'];
  serviceMode?: Maybe<PosDataServiceMode>;
}


export interface IQueryHelloArgs {
  name: Scalars['String'];
}


export interface IQueryRestaurantsArgs {
  input: Maybe<IRestaurantsInput>;
}


export interface IQueryRestaurantArgs {
  storeId: Maybe<Scalars['String']>;
  storeNumber: Maybe<Scalars['String']>;
  localDateTime: Maybe<Scalars['String']>;
}


export interface IQueryRecentItemsArgs {
  restaurantId: Scalars['ID'];
  serviceMode: ServiceMode;
}


export interface IQueryUpsellItemsArgs {
  input: IUpsellItemsInput;
}


export interface IQueryMenuAvailabilityArgs {
  input: IMenuAvailabilityQueryInput;
}


export interface IQueryMenuPricingArgs {
  restaurantId: Scalars['Int'];
  menuId: Scalars['Int'];
  serviceMode: Scalars['String'];
  timestamp: Maybe<Scalars['DateTime']>;
}


export interface IQueryConsumerMenuArgs {
  input: IConsumerMenuInput;
}


export interface IQueryUserAccountsArgs {
  feCountryCode: Maybe<IsoCountryCode>;
  sync: Maybe<Scalars['Boolean']>;
}


export interface IQueryPrepaidsTransactionsArgs {
  fdAccountId: Maybe<Scalars['String']>;
  cardNumber: Maybe<Scalars['String']>;
}


export interface IQuerySmileCookieEnabledRestaurantsArgs {
  coordinates: ICoordinates;
}


export interface IQueryGetLoyaltyCardsArgs {
  status: Maybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyCardsWithDetailsArgs {
  status: Maybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyCardDetailsArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyDetailsArgs {
  includeRewards: Maybe<Scalars['Boolean']>;
  includeOffers: Maybe<Scalars['Boolean']>;
}


export interface IQueryGetLoyaltyCardDetailsKioskArgs {
  barcode: Scalars['String'];
  operator: Scalars['String'];
  restaurantId: Scalars['String'];
  terminal: Scalars['String'];
  transactionId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardApplePassArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardGooglePassArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardTransactionsArgs {
  cardId: Scalars['String'];
  endDate: Maybe<Scalars['String']>;
  page: Maybe<Scalars['String']>;
  pageSize: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventsArgs {
  eventId: Maybe<Scalars['String']>;
  resumeAfter: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['String']>;
  sortAscending: Maybe<Scalars['Boolean']>;
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventsV2Args {
  eventId: Maybe<Scalars['String']>;
  exclusiveStartKey: Maybe<Scalars['String']>;
  pageSize: Maybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventSummaryArgs {
  eventId: Maybe<Scalars['String']>;
  resumeAfter: Maybe<Scalars['String']>;
  sortAscending: Maybe<Scalars['Boolean']>;
}


export interface IQueryGetLoyaltyRollUpTheRimPrizesStatsArgs {
  eventId: Maybe<Scalars['String']>;
}


export interface IQueryPartnerLinkStatusArgs {
  partnerId: Scalars['String'];
}


export interface IQuerySignUpCompleteArgs {
  jwt: Scalars['String'];
}

export interface IRbiOrder {
  readonly __typename?: 'RbiOrder';
  readonly refund?: Maybe<IRefund>;
}

export enum RbiOrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface IRefund {
  readonly __typename?: 'Refund';
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason;
  /** Items that were refunded. Undefined if order was fully refunded. */
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<IRefundedItem>>>;
  /** Optional reason either added by a support agent or an user via the support form */
  readonly secondaryReason?: Maybe<Scalars['String']>;
  readonly subtotal: Scalars['String'];
  readonly tax: Scalars['String'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IRefundedItem {
  readonly __typename?: 'RefundedItem';
  /** Name of item refunded */
  readonly name?: Maybe<Scalars['String']>;
  /** Plu of item refunded */
  readonly plu?: Maybe<Scalars['String']>;
  /** Amount refunded in dollars for item */
  readonly refundAmount?: Maybe<Scalars['String']>;
  /** Quantity of item refunded */
  readonly refundQuantity?: Maybe<Scalars['String']>;
  /** SanityId of item refunded */
  readonly sanityId?: Maybe<Scalars['String']>;
  /** Type of item refunded */
  readonly type?: Maybe<CartEntryType>;
}

export interface IRefundEligibilityResponse {
  readonly __typename?: 'RefundEligibilityResponse';
  readonly eligible: Scalars['Boolean'];
  readonly ineligibilityReason?: Maybe<RefundIneligibilityReason>;
}

export enum RefundIneligibilityReason {
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED = 'DISABLED',
  INVALID_ORDER_STATUS = 'INVALID_ORDER_STATUS',
  INVALID_PAYMENT_TYPE = 'INVALID_PAYMENT_TYPE',
  INVALID_USER_ID = 'INVALID_USER_ID',
  ORDER_BEING_DELIVERED = 'ORDER_BEING_DELIVERED',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  OVER_ALLOWED_REFUND_AMOUNT = 'OVER_ALLOWED_REFUND_AMOUNT',
  REFUNDED_MAX_TIMES = 'REFUNDED_MAX_TIMES'
}

export enum RefundReason {
  CATERING_ORDER_DECLINED = 'CATERING_ORDER_DECLINED',
  CATERING_ORDER_ERROR = 'CATERING_ORDER_ERROR',
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  CUSTOMER_OVERCHARGED = 'CUSTOMER_OVERCHARGED',
  CUSTOMER_REQUESTED_CANCEL_ORDER = 'CUSTOMER_REQUESTED_CANCEL_ORDER',
  FOOD_QUALITY_ISSUE = 'FOOD_QUALITY_ISSUE',
  INCORRECT_CUSTOMIZATION = 'INCORRECT_CUSTOMIZATION',
  ITEMS_OUT_OF_STOCK = 'ITEMS_OUT_OF_STOCK',
  MISSING_OR_INCORRECT_ITEM = 'MISSING_OR_INCORRECT_ITEM',
  MOBILE_ORDERING_TECHNICAL_ISSUE = 'MOBILE_ORDERING_TECHNICAL_ISSUE',
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_COMMIT_ERROR = 'ORDER_COMMIT_ERROR',
  ORDER_NEVER_ARRIVED = 'ORDER_NEVER_ARRIVED',
  ORDER_WAS_DAMAGED = 'ORDER_WAS_DAMAGED',
  OTHER_ADD_COMMENT = 'OTHER_ADD_COMMENT',
  RECEIVED_INCORRECT_ORDER = 'RECEIVED_INCORRECT_ORDER',
  RESTAURANT_CLOSED = 'RESTAURANT_CLOSED',
  RESTAURANT_COULDNT_FIND_ORDER = 'RESTAURANT_COULDNT_FIND_ORDER'
}

export interface IRefundRequestResponse {
  readonly __typename?: 'RefundRequestResponse';
  /** Requested refund amount in cents */
  readonly refundRequestAmountCents: Scalars['Int'];
  /** Date time when refund was requested */
  readonly requestDateTime?: Maybe<Scalars['String']>;
}

/** A Prepaid Reload response (payment method) */
export interface IReload {
  readonly __typename?: 'Reload';
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in dollars */
  readonly currentBalance: Scalars['Int'];
  /** First Data account id of gift card */
  readonly fdAccountId: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
}

export interface IRemoveDeliveryAddressInput {
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly alias?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
}

export interface IResendOtpInput {
  /**
   * User email. Only one of email or phone number should be provided
   * Example foobar@example.com
   */
  readonly email?: Maybe<Scalars['String']>;
  /**
   * User phone number. Only one of email or phone number should be provided
   * Example 4258675309
   */
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
}

export interface IResendPhoneVerificationInput {
  /** user's current platform */
  readonly platform: Platform;
  /** user's current stage */
  readonly stage: Stage;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId?: Maybe<Scalars['ID']>;
}

export interface IResendVerificationEmailInput {
  /** user's current platform */
  readonly platform: Platform;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IRestaurant {
  readonly __typename?: 'Restaurant';
  /**
   * The MDM number identifier. This is the `number` property on the CMS store object
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in the CMS
   */
  readonly available: Scalars['Boolean'];
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in the CMS
   */
  readonly isAvailable: Scalars['Boolean'];
  /**
   * DEPRECATED
   * Last record heartbeat timestamp on this restaurant
   * @deprecated Only for internal use
   */
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['String']>;
  /**
   * Pos Vendor associated with restaurant
   * @deprecated Always PRODUCT_NUMBER
   */
  readonly posVendor?: Maybe<Scalars['String']>;
  /** Catering operating hours */
  readonly cateringHours?: Maybe<IOperatingHours>;
  /** Curbside operating hours */
  readonly curbsideHours?: Maybe<IOperatingHours>;
  /** Delivery operating hours */
  readonly deliveryHours?: Maybe<IOperatingHours>;
  /** Dining room operating hours */
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  /** Drive through operating hours */
  readonly driveThruHours?: Maybe<IOperatingHours>;
  /** The hours that the restaurant is physically open. */
  readonly storeHours?: Maybe<IOperatingHours>;
  /**
   * Restaurant Vat Number for BK UK
   * @deprecated Not used for restaurants
   */
  readonly vatNumber?: Maybe<Scalars['String']>;
  /**
   * Day parts from sanity
   * @deprecated Not used for restaurants
   */
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  /**
   * Contains information about the store service hours for a range of X consecutive days,
   * where X is specified in the rolling window param
   * starting from the day before the request is made.
   * @deprecated Not used for restaurants
   */
  readonly futureServiceHours: ReadonlyArray<IFutureServiceHours>;
  /** The restaurant timezone */
  readonly timezone?: Maybe<Scalars['String']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly number?: Maybe<Scalars['String']>;
  readonly posRestaurantId?: Maybe<Scalars['String']>;
  readonly pos?: Maybe<IRestaurantPos>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly physicalAddress?: Maybe<IPhysicalAddress>;
  readonly restaurantPosData?: Maybe<IRestaurantPosData>;
  readonly status?: Maybe<Scalars['String']>;
  readonly _id?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDineIn?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly restaurantImage?: Maybe<ISanityImage>;
  readonly image?: Maybe<IRestaurantImage>;
  readonly mobileOrderingStatus?: Maybe<OrderingStatus>;
  readonly isAcceptingMobileOrders: Scalars['Boolean'];
  /** Real-time open/closed status computed from hours and timezone. */
  readonly operatingStatus?: Maybe<IRestaurantOperatingStatus>;
  /** Hours by service mode with real-time availability, display-ready. */
  readonly serviceHours?: Maybe<ReadonlyArray<IServiceModeHours>>;
}

export interface IRestaurantEdge extends IEdge {
  readonly __typename?: 'RestaurantEdge';
  readonly cursor: Scalars['String'];
  readonly node: IRestaurantNode;
}

/**
 * Primary image for the restaurant. Shape is compatible with the upstream CMS
 * image pipeline so frontend image builders keep working.
 */
export interface IRestaurantImage {
  readonly __typename?: 'RestaurantImage';
  readonly asset?: Maybe<IRestaurantImageAsset>;
  readonly crop?: Maybe<IRestaurantImageCrop>;
  readonly hotspot?: Maybe<IRestaurantImageHotspot>;
}

export interface IRestaurantImageAsset {
  readonly __typename?: 'RestaurantImageAsset';
  readonly _id?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<IRestaurantImageMetaData>;
}

export interface IRestaurantImageCrop {
  readonly __typename?: 'RestaurantImageCrop';
  readonly top?: Maybe<Scalars['Float']>;
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
}

export interface IRestaurantImageHotspot {
  readonly __typename?: 'RestaurantImageHotspot';
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

export interface IRestaurantImageMetaData {
  readonly __typename?: 'RestaurantImageMetaData';
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<IRestaurantImagePalette>;
}

export interface IRestaurantImagePalette {
  readonly __typename?: 'RestaurantImagePalette';
  readonly dominant?: Maybe<IRestaurantImagePaletteSwatch>;
}

export interface IRestaurantImagePaletteSwatch {
  readonly __typename?: 'RestaurantImagePaletteSwatch';
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
}

export interface IRestaurantInput {
  readonly address1: Scalars['String'];
  readonly address2?: Maybe<Scalars['String']>;
  readonly cateringHours?: Maybe<Scalars['String']>;
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly curbSideHours?: Maybe<Scalars['String']>;
  readonly deliveryHours?: Maybe<Scalars['String']>;
  readonly diningHours?: Maybe<Scalars['String']>;
  readonly driveThruHours?: Maybe<Scalars['String']>;
  readonly driveThruLaneType?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly franchiseGroupID?: Maybe<Scalars['String']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDining?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly hasParking?: Maybe<Scalars['Boolean']>;
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  readonly hasWifi?: Maybe<Scalars['Boolean']>;
  readonly holidayHours?: Maybe<ReadonlyArray<Maybe<IHoliday>>>;
  readonly id: Scalars['String'];
  readonly isLab?: Maybe<Scalars['Boolean']>;
  readonly latitude: Scalars['String'];
  readonly longitude: Scalars['String'];
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly parkingType?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly postalCode: Scalars['String'];
  readonly pricingRegion?: Maybe<Scalars['String']>;
  readonly restaurantPosData?: Maybe<Scalars['String']>;
  readonly stateProvince: Scalars['String'];
  readonly stateProvinceShort: Scalars['String'];
  readonly status?: Maybe<Scalars['String']>;
  readonly timezone?: Maybe<Scalars['String']>;
  readonly menuId?: Maybe<Scalars['String']>;
}

/** Extended restaurant data containing all fields from Sanity + Dynamo */
export interface IRestaurantNode extends INode {
  readonly __typename?: 'RestaurantNode';
  /** Arbitrary unique identifier. */
  readonly id?: Maybe<Scalars['ID']>;
  /** While pagination spec requires an id, Sanity and Frontend use _id */
  readonly _id?: Maybe<Scalars['String']>;
  /**
   * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
   */
  readonly isAvailable: Scalars['Boolean'];
  /**
   * Pos Vendor associated with restaurant
   * @deprecated Always PRODUCT_NUMBER
   */
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly curbsideHours?: Maybe<IOperatingHours>;
  readonly deliveryHours?: Maybe<IOperatingHours>;
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  /** The hours that the restaurant is physically open. */
  readonly storeHours?: Maybe<IOperatingHours>;
  /** @deprecated Not used for restaurants */
  readonly distanceInMiles?: Maybe<Scalars['Int']>;
  /** @deprecated Not used for restaurants */
  readonly drinkStationType?: Maybe<Scalars['String']>;
  readonly driveThruHours?: Maybe<IOperatingHours>;
  readonly driveThruLaneType?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** @deprecated Always null, not included in the CMS projection */
  readonly environment?: Maybe<RestaurantStatus>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  /** @deprecated Not used for restaurants */
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDineIn?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasTableService?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasLateNightMenu?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly hasParking?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasPlayground?: Maybe<Scalars['Boolean']>;
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  readonly hasWifi?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly hasLoyalty?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not used for restaurants */
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>;
  readonly isFavorite: Scalars['Boolean'];
  /** @deprecated Not used for restaurants */
  readonly isHalal?: Maybe<Scalars['Boolean']>;
  readonly isRecent: Scalars['Boolean'];
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<OrderingStatus>;
  readonly name?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
  readonly parkingType?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly physicalAddress?: Maybe<IPhysicalAddress>;
  /** @deprecated Not used for restaurants */
  readonly playgroundType?: Maybe<Scalars['String']>;
  /** @deprecated Always PRODUCT_NUMBER */
  readonly pos?: Maybe<IRestaurantPos>;
  /** @deprecated Not used for restaurants */
  readonly posRestaurantId?: Maybe<Scalars['String']>;
  readonly restaurantImage?: Maybe<ISanityImage>;
  readonly status?: Maybe<Scalars['String']>;
  readonly restaurantPosData?: Maybe<IRestaurantPosData>;
  /** @deprecated Not used for restaurants */
  readonly vatNumber?: Maybe<Scalars['String']>;
  /** The restaurant timezone */
  readonly timezone?: Maybe<Scalars['String']>;
  /** If the restaurant is currently accepting mobile orders. */
  readonly isAcceptingMobileOrders: Scalars['Boolean'];
  readonly cateringHours?: Maybe<IOperatingHours>;
  /** Display-ready distance from the active search reference point to the restaurant. */
  readonly distance?: Maybe<Scalars['String']>;
  readonly image?: Maybe<IRestaurantImage>;
  /** Real-time open/closed status computed from hours and timezone. */
  readonly operatingStatus?: Maybe<IRestaurantOperatingStatus>;
  /** Hours by service mode with real-time availability, display-ready. */
  readonly serviceHours?: Maybe<ReadonlyArray<IServiceModeHours>>;
}

/** Real-time operating status computed from hours and timezone. */
export interface IRestaurantOperatingStatus {
  readonly __typename?: 'RestaurantOperatingStatus';
  /** Whether the restaurant is currently open (any service mode). */
  readonly isOpen: Scalars['Boolean'];
  /** Whether the restaurant closes within 30 minutes. */
  readonly isClosingSoon: Scalars['Boolean'];
  /** Display-ready status label: "Open until 11:00 PM", "Closed • Opens at 6:30 AM (Tuesday)" */
  readonly label: Scalars['String'];
}

export interface IRestaurantPos {
  readonly __typename?: 'RestaurantPos';
  readonly vendor?: Maybe<Scalars['String']>;
}

export interface IRestaurantPosData {
  readonly __typename?: 'RestaurantPosData';
  readonly _id?: Maybe<Scalars['String']>;
}

export interface IRestaurantsConnection extends IConnection {
  readonly __typename?: 'RestaurantsConnection';
  readonly edges: ReadonlyArray<IRestaurantEdge>;
  readonly nodes: ReadonlyArray<IRestaurantNode>;
  readonly totalCount?: Maybe<Scalars['Int']>;
  readonly pageInfo: IPageInfo;
}

export interface IRestaurantsInput {
  /**
   * Return first provided number of edges for pagination query.
   * Used in combination with after field.
   */
  readonly first?: Maybe<Scalars['Int']>;
  /**
   * Return last provided number of edges for pagination query.
   * Used in combination with before field.
   */
  readonly last?: Maybe<Scalars['Int']>;
  /**
   * An opaque cursor for pagination. Return results after provided cursor.
   * Used in combination with first field.
   */
  readonly after?: Maybe<Scalars['String']>;
  /**
   * An opaque cursor for pagination. Return results before provided cursor.
   * Used in combination with last field.
   */
  readonly before?: Maybe<Scalars['String']>;
  /** A coordinates object that sorts results based on location provided. */
  readonly coordinates?: Maybe<ICoordinates>;
  /** A list of store IDs to filter to */
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * Filter to a subset of stores
   * Defaults to NEARBY
   */
  readonly filter?: Maybe<FilterRestaurantType>;
  /**
   * A list of service modes to search for.
   * Filters list to subset of stores that have one of the service modes available.
   */
  readonly serviceModes?: Maybe<ReadonlyArray<ServiceMode>>;
  /**
   * Restaurant operational status.
   * Filters list to subset of stores that have the provided status.
   */
  readonly status?: Maybe<OperationalStatus>;
  /**
   * A flag to enable strict radius checking. When enabled, stores will be filtered
   * based on a circle radius. Any stores outside the radius are not included.
   */
  readonly radiusStrictMode?: Maybe<Scalars['Boolean']>;
}

export enum RestaurantStatus {
  DEV = 'DEV',
  PROD = 'PROD'
}

export interface IRestaurantTimeSlot {
  readonly __typename?: 'RestaurantTimeSlot';
  /** Store close time. */
  readonly closes: Scalars['String'];
  /** Calendar day that this time slot reflects. */
  readonly date: Scalars['String'];
  /** Flag to determine if the store is closed. */
  readonly isClosed?: Maybe<Scalars['Boolean']>;
  /** Store open time. */
  readonly opens: Scalars['String'];
}

/** Resume 3DS sale transaction input */
export interface IResumeThreeDSaleTransaction {
  /** saleId of the transaction */
  readonly saleId: Scalars['String'];
  /** threeDSOptions to resume 3ds flow transaction */
  readonly threeDSOptions: IThreeDsOptions;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImage {
  readonly __typename?: 'SanityImage';
  readonly asset?: Maybe<ISanityImageAsset>;
  readonly crop?: Maybe<ISanityImageCrop>;
  readonly hotspot?: Maybe<ISanityImageHotspot>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImageAsset {
  readonly __typename?: 'SanityImageAsset';
  readonly _id?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<ISanityImageMetaData>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop';
  readonly top?: Maybe<Scalars['Float']>;
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot';
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImageMetaData {
  readonly __typename?: 'SanityImageMetaData';
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<ISanityImagePalette>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette';
  readonly dominant?: Maybe<ISanityImagePaletteSwatch>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch';
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
}

export interface ISaveDeliveryAddressInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly alias?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: Maybe<IsoCountryCode>;
  readonly phoneNumber: Scalars['String'];
  readonly state?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly route?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
}

export interface ISaveSmileCookieVolunteerResult {
  readonly __typename?: 'SaveSmileCookieVolunteerResult';
  readonly success?: Maybe<Scalars['Boolean']>;
}

export interface ISchemeStoredPaymentMethod extends IStoredPaymentMethod {
  readonly __typename?: 'SchemeStoredPaymentMethod';
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Last 4 digits of card number */
  readonly last4: Scalars['String'];
  /** Card pan token */
  readonly panToken?: Maybe<Scalars['String']>;
  /** Type of payment method */
  readonly type: PaymentMethodType;
  /** Card Brand. Ex: Visa */
  readonly brand: CardBrand;
  /** Card expiration year. Ex: 2030 */
  readonly expiryYear: Scalars['String'];
  /** Card expiration month. Ex: 04 */
  readonly expiryMonth: Scalars['String'];
}

/** Selects a specific option for a modifier */
export interface ISelectedModifierOption {
  readonly __typename?: 'SelectedModifierOption';
  /** The modifier affected by this preset; e.g. 'cream', or 'bagel' */
  readonly modifier: IProductModifier;
  /** The option selected for the modifier; e.g. '2' for 'cream', or 'sesame seed' for 'bagel' */
  readonly option: IModifierOption;
}

export interface ISelectedModifierOptionInput {
  readonly modifierId: Scalars['ID'];
  readonly optionId: Scalars['ID'];
  readonly price?: Maybe<IMoneyInput>;
}

/** A ProductOption and a specific corresponding ProductOptionValue */
export interface ISelectedProductOption {
  readonly __typename?: 'SelectedProductOption';
  /** The option that is selected */
  readonly option: IProductOption;
  /** The selected value for the selected option */
  readonly value: IProductOptionValue;
}

export interface ISelectedProductVariant {
  readonly __typename?: 'SelectedProductVariant';
  readonly productVariant: IProductVariant;
  readonly quantity: Scalars['Int'];
  readonly modifiers: ReadonlyArray<ISelectedModifierOption>;
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TAKEOUT = 'TAKEOUT',
  TABLE_SERVICE = 'TABLE_SERVICE'
}

/** Weekly schedule for one service mode with real-time availability. */
export interface IServiceModeHours {
  readonly __typename?: 'ServiceModeHours';
  readonly serviceMode: ServiceMode;
  /** Whether this service mode is currently open. */
  readonly isOpenNow: Scalars['Boolean'];
  /** Whether this service mode closes within 30 minutes. */
  readonly isClosingSoon: Scalars['Boolean'];
  /** Display-ready weekly schedule (7 entries, Monday through Sunday). */
  readonly schedule: ReadonlyArray<IDayHours>;
}

export interface ISetGiftCardReloadAccountInput {
  /** The account ID to set as the default gift card reload account */
  readonly accountId: Scalars['String'];
}

export interface ISetGiftCardReloadAccountPayload {
  readonly __typename?: 'SetGiftCardReloadAccountPayload';
  /** The user entity with the updated gift card reload account */
  readonly user: IUser;
}

export interface ISetOrderingAccountInput {
  /** The account ID to set as the default ordering account */
  readonly accountId: Scalars['String'];
}

export interface ISetOrderingAccountPayload {
  readonly __typename?: 'SetOrderingAccountPayload';
  /** The user entity with the updated ordering account */
  readonly user: IUser;
}

export interface ISetRewardsRedemptionEnabledInput {
  /** The rewards redemption enabled status for the loyalty user card */
  readonly isEnabled: Scalars['Boolean'];
}

export interface ISetRewardsRedemptionEnabledPayload {
  readonly __typename?: 'SetRewardsRedemptionEnabledPayload';
  readonly user: IUser;
}

export interface ISetRewardsRedemptionLevelInput {
  /** The rewards redemption level to set for the loyalty user card */
  readonly rewardsTier: Scalars['String'];
}

export interface ISetRewardsRedemptionLevelPayload {
  readonly __typename?: 'SetRewardsRedemptionLevelPayload';
  readonly user: IUser;
}

export interface ISetScanAndPayAccountInput {
  readonly accountId: Scalars['String'];
}

/** Response payload for setting the scan and pay account */
export interface ISetScanAndPayAccountPayload {
  readonly __typename?: 'SetScanAndPayAccountPayload';
  /** The user entity with updated scan and pay account */
  readonly user: IUser;
}

/** Input type for toggling ScanAndPay enabled status */
export interface ISetScanAndPayEnabledInput {
  /** Whether to enable or disable ScanAndPay */
  readonly isEnabled: Scalars['Boolean'];
}

/** The result of setting the ScanAndPay settings */
export interface ISetScanAndPayEnabledPayload {
  readonly __typename?: 'SetScanAndPayEnabledPayload';
  readonly user: IUser;
}

export interface ISignInUserInput {
  readonly email: Scalars['String'];
  readonly platform: Platform;
  readonly stage: Stage;
}

export interface ISignUpSmsOtpInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  readonly country: IsoCountryCode;
  readonly dob?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  /** The phone number of the user logging in with a One-Time Password. */
  readonly phoneNumber: Scalars['String'];
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
  readonly platform: Platform;
  readonly stage: Stage;
  readonly userName: Scalars['String'];
  readonly wantsPromotionalEmails: Scalars['Boolean'];
  readonly zipcode?: Maybe<Scalars['String']>;
  readonly favoriteStores?: Maybe<ReadonlyArray<IFavoriteStoreInput>>;
}

export interface ISignUpUserInput {
  readonly country: IsoCountryCode;
  readonly dob?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly platform: Platform;
  readonly stage: Stage;
  readonly userName: Scalars['String'];
  readonly wantsPromotionalEmails: Scalars['Boolean'];
  readonly zipcode?: Maybe<Scalars['String']>;
  readonly favoriteStores?: Maybe<ReadonlyArray<IFavoriteStoreInput>>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu';
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

/** Availability status for a single SKU */
export interface ISkuAvailability {
  readonly __typename?: 'SkuAvailability';
  /** The SKU identifier */
  readonly sku: Scalars['String'];
  /** Final availability status */
  readonly isAvailable: Scalars['Boolean'];
  /** The reason for the availability status */
  readonly reason: AvailabilityReason;
  /** Optional details about the decision */
  readonly details?: Maybe<IAvailabilityDetails>;
}

/** Pricing information for a single SKU */
export interface ISkuPricing {
  readonly __typename?: 'SkuPricing';
  /** The SKU identifier */
  readonly sku: Scalars['String'];
  /** Base price in cents before adjustments */
  readonly basePriceCents: Scalars['Int'];
  /** Final computed price in cents after all adjustments */
  readonly finalPriceCents: Scalars['Int'];
  /** Source of the final price */
  readonly priceSource: PriceSource;
  /** ISO 8601 timestamp indicating when this price expires (if applicable) */
  readonly effectiveUntil?: Maybe<Scalars['DateTime']>;
}

export interface ISmileCookieEnrolledRestaurant {
  readonly __typename?: 'SmileCookieEnrolledRestaurant';
  readonly id?: Maybe<Scalars['ID']>;
  readonly storeId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly physicalAddress?: Maybe<IPhysicalAddress>;
  readonly isMorningShift?: Maybe<Scalars['Boolean']>;
  readonly isAfternoonShift?: Maybe<Scalars['Boolean']>;
}

export enum Stage {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LOCALDEV = 'localdev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test'
}

export interface IStoreAddress {
  readonly __typename?: 'StoreAddress';
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
}

export interface IStoreAddressInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
}

export interface IStoreDetails {
  readonly __typename?: 'StoreDetails';
  readonly deliveryHours?: Maybe<IStoreHours>;
  readonly diningRoomHours?: Maybe<IStoreHours>;
  readonly driveThruHours?: Maybe<IStoreHours>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly storeNumber?: Maybe<Scalars['String']>;
  readonly timezone?: Maybe<Scalars['String']>;
}

export interface IStoredPaymentMethod {
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Type of payment method */
  readonly type: PaymentMethodType;
}

export interface IStoreHours {
  readonly __typename?: 'StoreHours';
  readonly monday?: Maybe<IDay>;
  readonly tuesday?: Maybe<IDay>;
  readonly wednesday?: Maybe<IDay>;
  readonly thursday?: Maybe<IDay>;
  readonly friday?: Maybe<IDay>;
  readonly saturday?: Maybe<IDay>;
  readonly sunday?: Maybe<IDay>;
}

export interface ISupportCase {
  readonly __typename?: 'SupportCase';
  /** Identifier for the case. Useful for the user to have */
  readonly caseId?: Maybe<Scalars['String']>;
}

export interface ISupportCaseInput {
  /** Description of the issue the user is having */
  readonly comments: Scalars['String'];
  /** User's email */
  readonly email: Scalars['String'];
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId: Scalars['String'];
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: Maybe<Scalars['String']>;
  /** User's name */
  readonly name: Scalars['String'];
  /** The time and date the order associated with the issue was placed */
  readonly orderDateTime?: Maybe<Scalars['String']>;
  /** The local time the order associated with the issue was placed */
  readonly localStoreOrderTime?: Maybe<Scalars['String']>;
  /** Unique order identifier in RBI */
  readonly rbiOrderId?: Maybe<Scalars['String']>;
  /** Service mode of the order associated with the issue */
  readonly serviceMode?: Maybe<Scalars['String']>;
  /** Address of the store associated with the issue */
  readonly storeAddress?: Maybe<Scalars['String']>;
  /** Store number from MDS */
  readonly storeId?: Maybe<Scalars['String']>;
  /** User's region */
  readonly userRegion?: Maybe<Scalars['String']>;
  /** Region user signed up in (account region) */
  readonly userAccountRegion?: Maybe<Scalars['String']>;
}

export interface ISwapInput {
  readonly from: Scalars['String'];
  readonly to: Scalars['String'];
  readonly cartId: Scalars['String'];
  readonly swapType: Scalars['String'];
}

export interface IThreeDsOptions {
  /** challenge response obtained in challengeCallbackUrl to resume challenge flow */
  readonly challengeResponse?: Maybe<Scalars['String']>;
  /** transactionId to resume method or challenge flow */
  readonly transactionId: Scalars['String'];
}

export interface ITransactionListResponse {
  readonly __typename?: 'TransactionListResponse';
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactions?: Maybe<ReadonlyArray<Maybe<IPrepaidTransaction>>>;
}

export interface IUnavailableCartEntry {
  readonly __typename?: 'UnavailableCartEntry';
  readonly lineId?: Maybe<Scalars['String']>;
  readonly sanityId: Scalars['String'];
}

export interface IUniquePurchasedItemsInput {
  /** The number of unique menu items to return */
  readonly numUniquePurchasedItems?: Maybe<Scalars['Int']>;
}

export interface IUpdateOrderInput {
  /** number of seconds from now to inject order */
  readonly fireOrderIn: Scalars['Int'];
  readonly rbiOrderId: Scalars['ID'];
}

export interface IUpsellItemsInput {
  /**
   * Restaurant and ordering context used to generate specific upsell items.
   * Restaurant ID must be a numeric ID.
   */
  readonly menuContext: IMenuContext;
  /** Product variant IDs currently in the guest's cart. */
  readonly cartItemIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
}

export interface IUpsellItemsPayload {
  readonly __typename?: 'UpsellItemsPayload';
  /** Enriched product variants available for upselling at checkout. */
  readonly items: ReadonlyArray<IProductVariant>;
  /** Unique ID generated per recommendation by the personalization API, used for analytics attribution. */
  readonly recommendationId?: Maybe<Scalars['String']>;
}

export interface IUser {
  readonly __typename?: 'User';
  /** Primary id; holds same value as cognitoId */
  readonly id: Scalars['ID'];
  /**
   * Encrypted Cognito ID for Pypestream chatbot authentication.
   * RSA-encrypted using the Pypestream public key from AWS Parameter Store.
   */
  readonly pypestreamUserId?: Maybe<Scalars['String']>;
  /**
   * The authenticated user's communication preferences.
   *
   * Returns `null` when the entity reference does not belong to the
   * authenticated caller, or when no user record exists for the id.
   */
  readonly communicationPreferences?: Maybe<ICommunicationPreferences>;
  readonly order?: Maybe<IOrderV2>;
  /** These are the unique menu items that the user has purchased */
  readonly uniquePurchasedItems?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly thLegacyCognitoId?: Maybe<Scalars['String']>;
  /** The guest barcode for scanning at POS */
  readonly barcode?: Maybe<IBarcode>;
  /** Whether scan and pay is enabled for this guest */
  readonly scanAndPayEnabled: Scalars['Boolean'];
  /** The payment account selected for scan and pay transactions */
  readonly scanAndPayAccount?: Maybe<IAccount>;
  /** The default amount to load onto a gift card */
  readonly giftCardLoadAmount?: Maybe<Scalars['Int']>;
  /** All payment accounts for the user */
  readonly accounts: ReadonlyArray<Maybe<IAccount>>;
  /**
   * The selected payment account used for Mobile Order & Pay transactions
   * Returns null if the user does not have an account set
   */
  readonly orderingAccount?: Maybe<IAccount>;
  /**
   * The selected payment account used for reloading a user's gift card
   * Returns null if the user does not have an account set
   */
  readonly giftCardReloadAccount?: Maybe<IAccount>;
  readonly rewards: ILoyaltyRewardsInfo;
  readonly cognitoId: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly details: IUserDetails;
  readonly loyaltyId?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['String'];
}


export interface IUserOrderArgs {
  id: Scalars['ID'];
}


export interface IUserUniquePurchasedItemsArgs {
  uniquePurchasedItemsInput: Maybe<IUniquePurchasedItemsInput>;
}


export interface IUserAccountsArgs {
  sync: Maybe<Scalars['Boolean']>;
}

export enum UserCardCardFormat {
  DIGITAL = 'digital',
  PHYSICAL = 'physical'
}

export enum UserCardCardStatus {
  ACTIVE = 'Active',
  INACTIVE = 'InActive'
}

export enum UserCardCardType {
  ACCUMULATEREDEMPTIONS = 'AccumulateRedemptions'
}

export interface IUserDetails {
  readonly __typename?: 'UserDetails';
  /**
   * User Adresses and phone number combinations to be used to alllow users
   * to select from multiple saced addresses
   */
  readonly deliveryAddresses?: Maybe<ReadonlyArray<Maybe<IDeliveryAddress>>>;
  /** Giftcard can be auto reloaded */
  readonly autoReloadEnabled?: Maybe<Scalars['Boolean']>;
  /** Amount in cents that balance must reach for auto reload */
  readonly autoReloadThreshold?: Maybe<Scalars['Int']>;
  /** Array of Communication Preferences */
  readonly communicationPreferences?: Maybe<ReadonlyArray<Maybe<ICommunicationPreference>>>;
  /** Account (Adyen or First-Data) ID of auto reload default payment method */
  readonly defaultAccountIdentifier?: Maybe<Scalars['String']>;
  /**
   * First Data ID of auto reload default payment method
   * @deprecated Use `defaultAccountIdentifier`.
   */
  readonly defaultFdAccountId?: Maybe<Scalars['String']>;
  /** Adyen or First Data ID of default payment method */
  readonly defaultPaymentAccountId?: Maybe<Scalars['String']>;
  /** Default Account Id for Scan & Pay */
  readonly defaultScanAndPayAccountIdentifier?: Maybe<Scalars['String']>;
  /** Reload amount to default to for user's gift cards */
  readonly defaultReloadAmt?: Maybe<Scalars['Int']>;
  /** Date of birth (format TBD) */
  readonly dob?: Maybe<Scalars['String']>;
  readonly dobDeleted?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  /** Whether the user has verified the email */
  readonly emailVerified?: Maybe<Scalars['Boolean']>;
  /** User's saved list of favorite stores */
  readonly favoriteStores?: Maybe<ReadonlyArray<Maybe<IFavoriteStore>>>;
  /** User's saved list of favorite offers */
  readonly favoriteOffers?: Maybe<ReadonlyArray<Maybe<IFavoriteOffer>>>;
  readonly gender?: Maybe<Gender>;
  /** User's ISO Country Code (e.g. USA, CAN) */
  readonly isoCountryCode?: Maybe<IsoCountryCode>;
  /** User's selected loyalty tier */
  readonly loyaltyTier?: Maybe<Scalars['String']>;
  /** User's name */
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** Whether the user has verified the phone number */
  readonly phoneVerified?: Maybe<Scalars['Boolean']>;
  /** Whether the user has opted in to promotional emails */
  readonly promotionalEmails?: Maybe<Scalars['Boolean']>;
  /** Time the user gave consent for RUTR */
  readonly rutrConsentTimestamp?: Maybe<Scalars['String']>;
  /** Last time the user failed the skills tests of RUTR */
  readonly rutrFailedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  /** Last time the user passed the skills tests of RUTR */
  readonly rutrPassedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  /** Whether the user should be shown the onboarding flow */
  readonly showThLoyaltyOnboarding?: Maybe<Scalars['Boolean']>;
  readonly zipcode?: Maybe<Scalars['String']>;
}

/**
 * A business-level error returned from a mutation, surfaced in the
 * `userErrors` array of a mutation payload (e.g. validation failure, missing
 * user record). Distinct from the top-level GraphQL `errors` array, which is
 * reserved for transport, authentication, and authorization failures.
 */
export interface IUserError {
  readonly __typename?: 'UserError';
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly message: Scalars['String'];
}

export interface IUserGeo {
  readonly __typename?: 'UserGeo';
  readonly country?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
}

export interface IUserOrdersInput {
  readonly createdAfter?: Maybe<Scalars['String']>;
  readonly createdBefore?: Maybe<Scalars['String']>;
  readonly limit?: Maybe<Scalars['Int']>;
  readonly orderStatuses?: Maybe<ReadonlyArray<RbiOrderStatus>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<ServiceMode>>;
  readonly sortAscending?: Maybe<Scalars['Boolean']>;
  /** Deprecated. This field will be ignored. */
  readonly userId?: Maybe<Scalars['ID']>;
  readonly shouldFilterByRegion?: Maybe<Scalars['Boolean']>;
}

export interface IUserReportsMissingOrderInput {
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: Maybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: Maybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: Maybe<ReadonlyArray<Maybe<IMissingItem>>>;
  /** Optional user comment as part of the report */
  readonly userComment?: Maybe<Scalars['String']>;
}

export interface IUserRequestsRefundInput {
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: Maybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: Maybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: Maybe<ReadonlyArray<Maybe<IMissingItem>>>;
  /** Optional user comment as part of the report */
  readonly userComment?: Maybe<Scalars['String']>;
}

export interface IValidateAuthJwtInput {
  readonly jwt: Scalars['String'];
}

export interface IValidateCommitOrderInput {
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['String'];
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: Maybe<Scalars['Int']>;
  /** Delivery information */
  readonly delivery?: Maybe<ICommitDeliveryInput>;
  /** Whether to skip cooling period or not */
  readonly skipCoolingPeriod?: Maybe<Scalars['Boolean']>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
}

export interface IValidateSmsOtpCognitoCredentials {
  readonly __typename?: 'ValidateSmsOtpCognitoCredentials';
  readonly sessionId: Scalars['String'];
  readonly challengeCode: Scalars['String'];
}

export interface IVaultCreditAccountInput {
  readonly creditCard: IVaultCreditCardInput;
}

export interface IVaultCreditAccountPayload {
  readonly __typename?: 'VaultCreditAccountPayload';
  readonly id: Scalars['ID'];
}

export interface IVaultCreditCardInput {
  readonly cardNumber: Scalars['String'];
  readonly securityCode?: Maybe<Scalars['String']>;
  readonly expirationMonth: Scalars['String'];
  readonly expirationYear: Scalars['String'];
  readonly cardType: Scalars['String'];
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IVendorConfig {
  readonly __typename?: 'VendorConfig';
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly pluType: Scalars['String'];
  readonly parentChildPlu?: Maybe<IParentChildPlu>;
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly sizeBasedPlu?: Maybe<ISizeBasedPlu>;
}

export interface IVendorConfigInput {
  readonly pluType: Scalars['String'];
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>;
  readonly parentChildPlu?: Maybe<IParentChildPluInput>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>;
  readonly sizeBasedPlu?: Maybe<ISizeBasedPluInput>;
}

/** @deprecated(reason: "Need to remove if this type is unused or should be defined in another subgraph") */
export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs';
  readonly carrols?: Maybe<IVendorConfig>;
  readonly carrolsDelivery?: Maybe<IVendorConfig>;
  readonly ncr?: Maybe<IVendorConfig>;
  readonly ncrDelivery?: Maybe<IVendorConfig>;
  readonly oheics?: Maybe<IVendorConfig>;
  readonly oheicsDelivery?: Maybe<IVendorConfig>;
  readonly partner?: Maybe<IVendorConfig>;
  readonly partnerDelivery?: Maybe<IVendorConfig>;
  readonly productNumber?: Maybe<IVendorConfig>;
  readonly productNumberDelivery?: Maybe<IVendorConfig>;
  readonly qdi?: Maybe<IVendorConfig>;
  readonly qdiDelivery?: Maybe<IVendorConfig>;
  readonly qst?: Maybe<IVendorConfig>;
  readonly qstDelivery?: Maybe<IVendorConfig>;
  readonly rpos?: Maybe<IVendorConfig>;
  readonly rposDelivery?: Maybe<IVendorConfig>;
  readonly sicom?: Maybe<IVendorConfig>;
  readonly sicomDelivery?: Maybe<IVendorConfig>;
  readonly simplyDelivery?: Maybe<IVendorConfig>;
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfig>;
  readonly tablet?: Maybe<IVendorConfig>;
  readonly tabletDelivery?: Maybe<IVendorConfig>;
}

/** Vendor configs */
export interface IVendorConfigsInput {
  readonly brink?: Maybe<IVendorConfigInput>;
  readonly brinkDelivery?: Maybe<IVendorConfigInput>;
  readonly carrols?: Maybe<IVendorConfigInput>;
  readonly carrolsDelivery?: Maybe<IVendorConfigInput>;
  /** HDX is not currently supported */
  readonly hdx?: Maybe<IVendorConfigInput>;
  readonly ncr?: Maybe<IVendorConfigInput>;
  readonly ncrDelivery?: Maybe<IVendorConfigInput>;
  readonly oheics?: Maybe<IVendorConfigInput>;
  readonly oheicsDelivery?: Maybe<IVendorConfigInput>;
  readonly partner?: Maybe<IVendorConfigInput>;
  readonly partnerDelivery?: Maybe<IVendorConfigInput>;
  readonly productNumber?: Maybe<IVendorConfigInput>;
  readonly productNumberDelivery?: Maybe<IVendorConfigInput>;
  readonly qdi?: Maybe<IVendorConfigInput>;
  readonly qdiDelivery?: Maybe<IVendorConfigInput>;
  readonly qst?: Maybe<IVendorConfigInput>;
  readonly qstDelivery?: Maybe<IVendorConfigInput>;
  readonly rpos?: Maybe<IVendorConfigInput>;
  readonly rposDelivery?: Maybe<IVendorConfigInput>;
  readonly sicom?: Maybe<IVendorConfigInput>;
  readonly sicomDelivery?: Maybe<IVendorConfigInput>;
  readonly simplyDelivery?: Maybe<IVendorConfigInput>;
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfigInput>;
  readonly tablet?: Maybe<IVendorConfigInput>;
  readonly tabletDelivery?: Maybe<IVendorConfigInput>;
  readonly xenial?: Maybe<IVendorConfigInput>;
  readonly xenialDelivery?: Maybe<IVendorConfigInput>;
}

export interface IVerifyPhoneNumberInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
  /** user's current platform */
  readonly platform: Platform;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IVrPayment {
  /** Represents the PayPal id for the payment */
  readonly billingAgreementId?: Maybe<Scalars['String']>;
  /** Device token provided by Braintree for paypal payments */
  readonly deviceToken?: Maybe<Scalars['String']>;
  /** Represents the PSP id for the payment */
  readonly pspReference: Scalars['String'];
  /** Stored payment method identifier */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod: Scalars['Boolean'];
  /** Merchant Account */
  readonly merchantAccount: Scalars['String'];
}

export interface IWorldpayPayment {
  /** Represents the PSP id for the payment */
  readonly pspReference?: Maybe<Scalars['String']>;
  /** Stored payment method identifier */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Low Value Token */
  readonly lowValueToken?: Maybe<Scalars['String']>;
}

export type IDayFragment = { readonly __typename?: 'Day', readonly close?: Maybe<string>, readonly open?: Maybe<string> };

export type IStoreHoursFragment = { readonly __typename?: 'StoreHours', readonly monday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly tuesday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly wednesday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly thursday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly friday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly saturday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly sunday?: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )> };

export type IUserOrderFragment = { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly createdAt: string, readonly updatedAt: string, readonly fireOrderIn?: Maybe<number>, readonly status: RbiOrderStatus, readonly orderNumberFormatted?: Maybe<string>, readonly _id: string, readonly catering?: Maybe<{ readonly __typename?: 'Catering', readonly pickupTime: string }>, readonly delivery?: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly tipCents?: Maybe<number>, readonly feeDiscountCents?: Maybe<number>, readonly status: DeliveryStatus, readonly serviceFeeCents?: Maybe<number>, readonly smallCartFeeCents?: Maybe<number>, readonly geographicalFeeCents?: Maybe<number>, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly state?: Maybe<string> } }>, readonly cart: { readonly __typename?: 'Cart', readonly ticketNumber?: Maybe<string>, readonly storeId: string, readonly vatNumber?: Maybe<string>, readonly serviceMode: ServiceMode, readonly posVendor: PosVendor, readonly cartVersion?: Maybe<number>, readonly subTotalCents?: Maybe<number>, readonly taxCents?: Maybe<number>, readonly totalCents?: Maybe<number>, readonly wasLoyaltyEarned?: Maybe<boolean>, readonly discounts?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Discount', readonly name?: Maybe<DiscountTypes>, readonly value?: Maybe<number> }>>>, readonly fees?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Fees', readonly name?: Maybe<string>, readonly priceCents?: Maybe<number>, readonly quantity?: Maybe<number>, readonly totalCents?: Maybe<number> }>>>, readonly donations?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Donation', readonly id?: Maybe<string>, readonly name?: Maybe<string>, readonly totalCents?: Maybe<number> }>>>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2?: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails?: Maybe<{ readonly __typename?: 'StoreDetails', readonly franchiseGroupName?: Maybe<string>, readonly franchiseGroupId?: Maybe<number>, readonly hasCatering?: Maybe<boolean>, readonly hasDelivery?: Maybe<boolean>, readonly hasDriveThru?: Maybe<boolean>, readonly hasMobileOrdering?: Maybe<boolean>, readonly lastActiveDateTime?: Maybe<string>, readonly latitude?: Maybe<number>, readonly longitude?: Maybe<number>, readonly mobileOrderingStatus?: Maybe<string>, readonly phoneNumber?: Maybe<string>, readonly posVendor?: Maybe<string>, readonly status?: Maybe<string>, readonly storeNumber?: Maybe<string>, readonly timezone?: Maybe<string>, readonly deliveryHours?: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )>, readonly diningRoomHours?: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )>, readonly driveThruHours?: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )> }>, readonly cartEntries?: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly reorderCartEntries?: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean>, readonly children?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean>, readonly children?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean>, readonly children?: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean>, readonly children?: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean>, readonly children?: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries', readonly isInMenu?: Maybe<boolean> }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId?: Maybe<string>, readonly sanityId: string }>>> }, readonly fulfillmentDetails?: Maybe<{ readonly __typename?: 'FulfillmentDetails', readonly pickupType?: Maybe<FulfillmentPickupType>, readonly pickupPin?: Maybe<string>, readonly pickupReady?: Maybe<boolean> }>, readonly order?: Maybe<{ readonly __typename?: 'RbiOrder', readonly refund?: Maybe<{ readonly __typename?: 'Refund', readonly primaryReason: RefundReason, readonly secondaryReason?: Maybe<string>, readonly subtotal: string, readonly tax: string, readonly transactionDateTime: string, readonly refundedItems?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RefundedItem', readonly refundAmount?: Maybe<string>, readonly refundQuantity?: Maybe<string>, readonly sanityId?: Maybe<string>, readonly type?: Maybe<CartEntryType>, readonly name?: Maybe<string>, readonly plu?: Maybe<string> }>>> }> }> };

export interface ISingularAttributionInput {
  readonly pcid?: Maybe<Scalars['String']>;
  readonly pcn?: Maybe<Scalars['String']>;
  readonly pscid?: Maybe<Scalars['String']>;
  readonly pscn?: Maybe<Scalars['String']>;
  readonly pcrid?: Maybe<Scalars['String']>;
  readonly pcrn?: Maybe<Scalars['String']>;
  readonly utm_source?: Maybe<Scalars['String']>;
  readonly utm_medium?: Maybe<Scalars['String']>;
  readonly utm_campaign?: Maybe<Scalars['String']>;
  readonly utm_term?: Maybe<Scalars['String']>;
  readonly utm_content?: Maybe<Scalars['String']>;
  readonly passthrough?: Maybe<Scalars['String']>;
  readonly wpsrc?: Maybe<Scalars['String']>;
  readonly th_captured_at?: Maybe<Scalars['Float']>;
  readonly th_destination?: Maybe<Scalars['String']>;
}

export type ICompleteLinkingMutationVariables = Exact<{
  partnerId: Scalars['String'];
  source: PartnerLinkSource;
  authCode: Scalars['String'];
  codeVerifier: Scalars['String'];
  singularAttribution?: Maybe<ISingularAttributionInput>;
}>;


export type ICompleteLinkingMutation = { readonly __typename?: 'Mutation', readonly completeLinking: { readonly __typename?: 'CompleteLinkingResponse', readonly success: boolean } };

export type ICartEntryFragment = { readonly __typename?: 'CartEntries', readonly lineId: string, readonly image?: Maybe<string>, readonly isDonation?: Maybe<boolean>, readonly isExtra?: Maybe<boolean>, readonly name?: Maybe<string>, readonly pickerSelections?: Maybe<string>, readonly price?: Maybe<number>, readonly quantity: number, readonly sanityId: string, readonly type: CartEntryType, readonly url?: Maybe<string>, readonly redeemable?: Maybe<boolean>, readonly _id: string, readonly vendorConfigs?: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly carrols?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly carrolsDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncr?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncrDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheics?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheicsDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly partner?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly partnerDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumber?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumberDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicom?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicomDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdi?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdiDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qst?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qstDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rpos?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rposDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDeliveryDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tablet?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tabletDelivery?: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )> };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType: string, readonly parentSanityId?: Maybe<string>, readonly pullUpLevels?: Maybe<number>, readonly constantPlu?: Maybe<string>, readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity?: Maybe<number>, readonly plu?: Maybe<string>, readonly qualifier?: Maybe<string> }>>>, readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity?: Maybe<number>, readonly plu?: Maybe<string>, readonly qualifier?: Maybe<string> }>>>, readonly parentChildPlu?: Maybe<{ readonly __typename?: 'ParentChildPlu', readonly plu?: Maybe<string>, readonly childPlu?: Maybe<string> }>, readonly sizeBasedPlu?: Maybe<{ readonly __typename?: 'SizeBasedPlu', readonly comboPlu?: Maybe<string>, readonly comboSize?: Maybe<string> }> };

export type IOrderFragment = { readonly __typename?: 'Order', readonly createdAt: string, readonly updatedAt: string, readonly posOrderId?: Maybe<string>, readonly rbiOrderId: string, readonly status: RbiOrderStatus, readonly fireOrderIn?: Maybe<number>, readonly orderNumberFormatted?: Maybe<string>, readonly order?: Maybe<{ readonly __typename?: 'RbiOrder', readonly refund?: Maybe<{ readonly __typename?: 'Refund', readonly primaryReason: RefundReason, readonly secondaryReason?: Maybe<string>, readonly subtotal: string, readonly tax: string, readonly transactionDateTime: string, readonly refundedItems?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RefundedItem', readonly refundAmount?: Maybe<string>, readonly refundQuantity?: Maybe<string>, readonly sanityId?: Maybe<string>, readonly type?: Maybe<CartEntryType>, readonly name?: Maybe<string>, readonly plu?: Maybe<string> }>>> }> }>, readonly loyaltyTransaction?: Maybe<{ readonly __typename?: 'LoyaltyTransaction', readonly id: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsBalance: number, readonly rewardsUsed: number }>, readonly cart: { readonly __typename?: 'Cart', readonly customerName: string, readonly cartVersion?: Maybe<number>, readonly posVendor: PosVendor, readonly serviceMode: ServiceMode, readonly subTotalCents?: Maybe<number>, readonly taxCents?: Maybe<number>, readonly ticketNumber?: Maybe<string>, readonly totalCents?: Maybe<number>, readonly wasLoyaltyEarned?: Maybe<boolean>, readonly vatNumber?: Maybe<string>, readonly cartEntries?: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children?: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly discounts?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Discount', readonly name?: Maybe<DiscountTypes>, readonly value?: Maybe<number> }>>>, readonly donations?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Donation', readonly id?: Maybe<string>, readonly name?: Maybe<string>, readonly totalCents?: Maybe<number> }>>>, readonly fees?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Fees', readonly name?: Maybe<string>, readonly priceCents?: Maybe<number>, readonly quantity?: Maybe<number>, readonly totalCents?: Maybe<number> }>>>, readonly offersFeedback?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CouponUserOffersFeedbackEntry', readonly couponId: string, readonly cartEntry?: Maybe<{ readonly __typename?: 'CartEntries', readonly lineId: string }>, readonly redemptionEligibility: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly isValid: boolean, readonly evaluationFeedback: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly redeemableForSeconds?: Maybe<number>, readonly redeemableInSeconds?: Maybe<number>, readonly ruleSetType: string }>> } }>>>, readonly payment?: Maybe<{ readonly __typename?: 'Payment', readonly cardType?: Maybe<string>, readonly ccLast4?: Maybe<string>, readonly panToken?: Maybe<string>, readonly paymentType?: Maybe<CartPaymentType> }>, readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CartAppliedReward', readonly cartId: string, readonly rewardId: string, readonly timesApplied: number }>>>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2?: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails?: Maybe<{ readonly __typename?: 'StoreDetails', readonly latitude?: Maybe<number>, readonly longitude?: Maybe<number>, readonly storeNumber?: Maybe<string>, readonly timezone?: Maybe<string> }>, readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId?: Maybe<string>, readonly sanityId: string }>>> }, readonly delivery?: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly feeDiscountCents?: Maybe<number>, readonly instructions?: Maybe<string>, readonly status: DeliveryStatus, readonly tipCents?: Maybe<number>, readonly serviceFeeCents?: Maybe<number>, readonly smallCartFeeCents?: Maybe<number>, readonly geographicalFeeCents?: Maybe<number>, readonly quotedFeeCents?: Maybe<number>, readonly baseDeliveryFeeCents?: Maybe<number>, readonly deliverySurchargeFeeCents?: Maybe<number>, readonly pickup: { readonly __typename?: 'DeliveryWaypoint', readonly latitude?: Maybe<number>, readonly longitude?: Maybe<number> }, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly arrivalTime?: Maybe<string>, readonly beforeTime?: Maybe<string>, readonly addressLine1: string, readonly addressLine2?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zip?: Maybe<string>, readonly latitude?: Maybe<number>, readonly longitude?: Maybe<number>, readonly phoneNumber: string }, readonly driver?: Maybe<{ readonly __typename?: 'DeliveryDriver', readonly name?: Maybe<string>, readonly profileImageUrl?: Maybe<string>, readonly phoneNumber?: Maybe<string> }> }>, readonly catering?: Maybe<{ readonly __typename?: 'Catering', readonly declineReason?: Maybe<CateringDeclineReasons>, readonly includeUtensils: boolean, readonly numberOfGuests: number, readonly notes?: Maybe<string>, readonly organizerName: string, readonly pickupEmail: string, readonly pickupTime: string }> };

export type IPricingAndAvailabilityFragment = { readonly __typename?: 'Entity', readonly id: string, readonly isAvailable?: Maybe<boolean>, readonly price?: Maybe<{ readonly __typename?: 'Price', readonly default?: Maybe<number>, readonly max?: Maybe<number>, readonly min?: Maybe<number>, readonly overrides?: Maybe<ReadonlyArray<{ readonly __typename?: 'Override', readonly key?: Maybe<ReadonlyArray<string>>, readonly price?: Maybe<number> }>> }> };

export type ICaloriesFragment = { readonly __typename?: 'Entity', readonly calories?: Maybe<{ readonly __typename?: 'Calories', readonly default?: Maybe<number>, readonly min?: Maybe<number>, readonly max?: Maybe<number> }> };

export type IGetOrderQueryVariables = Exact<{
  rbiOrderId: Scalars['ID'];
}>;


export type IGetOrderQuery = { readonly __typename?: 'Query', readonly order?: Maybe<(
    { readonly __typename?: 'Order' }
    & IOrderFragment
  )> };

export type IGetUserOrdersQueryVariables = Exact<{
  userId: Maybe<Scalars['ID']>;
  limit: Maybe<Scalars['Int']>;
  resumeAfter: Maybe<Scalars['String']>;
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus> | RbiOrderStatus>;
  createdAfter: Maybe<Scalars['String']>;
  shouldFilterByRegion: Maybe<Scalars['Boolean']>;
  serviceModes: Maybe<ReadonlyArray<ServiceMode> | ServiceMode>;
}>;


export type IGetUserOrdersQuery = { readonly __typename?: 'Query', readonly userOrders: { readonly __typename?: 'OrderListResponse', readonly count: number, readonly resumeAfter?: Maybe<string>, readonly orders?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Order' }
      & IUserOrderFragment
    )>>> } };

export type IPriceOrderMutationVariables = Exact<{
  input: IPriceOrderInput;
  delivery: Maybe<IPriceDeliveryInput>;
  catering: Maybe<IPriceCateringInput>;
}>;


export type IPriceOrderMutation = { readonly __typename?: 'Mutation', readonly priceOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type ICommitOrderMutationVariables = Exact<{
  input: ICommitOrderInput;
  delivery: Maybe<ICommitDeliveryInput>;
  skipCoolingPeriod: Maybe<Scalars['Boolean']>;
}>;


export type ICommitOrderMutation = { readonly __typename?: 'Mutation', readonly commitOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type ISetRewardsRedemptionEnabledMutationVariables = Exact<{
  input: ISetRewardsRedemptionEnabledInput;
}>;


export type ISetRewardsRedemptionEnabledMutation = { readonly __typename?: 'Mutation', readonly setRewardsRedemptionEnabled?: Maybe<{ readonly __typename?: 'SetRewardsRedemptionEnabledPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly rewards: { readonly __typename?: 'LoyaltyRewardsInfo', readonly redemption: { readonly __typename?: 'LoyaltyRedemption', readonly isEnabled: boolean } } } }> };

export type IRewardRedemptionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type IRewardRedemptionDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly id: string, readonly rewards: { readonly __typename?: 'LoyaltyRewardsInfo', readonly redemption: { readonly __typename?: 'LoyaltyRedemption', readonly isEnabled: boolean } } } };

export type IStoreMenuQueryVariables = Exact<{
  region: Scalars['String'];
  channel: Channel;
  storeId: Scalars['ID'];
  serviceMode: Maybe<PosDataServiceMode>;
}>;


export type IStoreMenuQuery = { readonly __typename?: 'Query', readonly storeMenu?: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Entity' }
    & IPricingAndAvailabilityFragment
    & ICaloriesFragment
  )>> };

export type IInitiateLinkingMutationVariables = Exact<{
  partnerId: Scalars['String'];
  source: PartnerLinkSource;
  singularAttribution?: Maybe<ISingularAttributionInput>;
}>;


export type IInitiateLinkingMutation = { readonly __typename?: 'Mutation', readonly initiateLinking: { readonly __typename?: 'InitiateLinkingResponse', readonly oidcAuthUrl: string } };

export type IVaultCreditAccountMutationVariables = Exact<{
  input: IVaultCreditAccountInput;
}>;


export type IVaultCreditAccountMutation = { readonly __typename?: 'Mutation', readonly vaultCreditAccount: { readonly __typename?: 'VaultCreditAccountPayload', readonly id: string } };

export type IGiftCardLoadMutationVariables = Exact<{
  input: IGiftCardLoadInput;
}>;


export type IGiftCardLoadMutation = { readonly __typename?: 'Mutation', readonly giftCardLoad: { readonly __typename?: 'GiftCardLoadPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly giftCardLoadAmount?: Maybe<number>, readonly accounts: ReadonlyArray<Maybe<{ readonly __typename?: 'Account', readonly prepaid?: Maybe<{ readonly __typename?: 'GiftCard', readonly currentBalance?: Maybe<number> }> }>> } } };

export type ISetGiftCardReloadAccountMutationVariables = Exact<{
  input: ISetGiftCardReloadAccountInput;
}>;


export type ISetGiftCardReloadAccountMutation = { readonly __typename?: 'Mutation', readonly setGiftCardReloadAccount: { readonly __typename?: 'SetGiftCardReloadAccountPayload', readonly user: { readonly __typename?: 'User', readonly giftCardReloadAccount?: Maybe<{ readonly __typename?: 'Account', readonly id: string }> } } };

export type IGetPrepaidsBalanceMutationVariables = Exact<{
  cardNumber: Scalars['String'];
  feCountryCode: IsoCountryCode;
  pin: Maybe<Scalars['String']>;
}>;


export type IGetPrepaidsBalanceMutation = { readonly __typename?: 'Mutation', readonly prepaidsBalance: { readonly __typename?: 'Balance', readonly currentBalance: number } };

export const DayFragmentDoc = gql`
    fragment DayFragment on Day {
  close
  open
}
    `;
export const StoreHoursFragmentDoc = gql`
    fragment StoreHoursFragment on StoreHours {
  monday {
    ...DayFragment
  }
  tuesday {
    ...DayFragment
  }
  wednesday {
    ...DayFragment
  }
  thursday {
    ...DayFragment
  }
  friday {
    ...DayFragment
  }
  saturday {
    ...DayFragment
  }
  sunday {
    ...DayFragment
  }
}
    ${DayFragmentDoc}`;
export const VendorConfigFragmentDoc = gql`
    fragment VendorConfigFragment on VendorConfig {
  pluType
  parentSanityId
  pullUpLevels
  constantPlu
  quantityBasedPlu {
    quantity
    plu
    qualifier
  }
  multiConstantPlus {
    quantity
    plu
    qualifier
  }
  parentChildPlu {
    plu
    childPlu
  }
  sizeBasedPlu {
    comboPlu
    comboSize
  }
}
    `;
export const VendorConfigsFragmentDoc = gql`
    fragment VendorConfigsFragment on VendorConfigs {
  carrols {
    ...VendorConfigFragment
  }
  carrolsDelivery {
    ...VendorConfigFragment
  }
  ncr {
    ...VendorConfigFragment
  }
  ncrDelivery {
    ...VendorConfigFragment
  }
  oheics {
    ...VendorConfigFragment
  }
  oheicsDelivery {
    ...VendorConfigFragment
  }
  partner {
    ...VendorConfigFragment
  }
  partnerDelivery {
    ...VendorConfigFragment
  }
  productNumber {
    ...VendorConfigFragment
  }
  productNumberDelivery {
    ...VendorConfigFragment
  }
  sicom {
    ...VendorConfigFragment
  }
  sicomDelivery {
    ...VendorConfigFragment
  }
  qdi {
    ...VendorConfigFragment
  }
  qdiDelivery {
    ...VendorConfigFragment
  }
  qst {
    ...VendorConfigFragment
  }
  qstDelivery {
    ...VendorConfigFragment
  }
  rpos {
    ...VendorConfigFragment
  }
  rposDelivery {
    ...VendorConfigFragment
  }
  simplyDelivery {
    ...VendorConfigFragment
  }
  simplyDeliveryDelivery {
    ...VendorConfigFragment
  }
  tablet {
    ...VendorConfigFragment
  }
  tabletDelivery {
    ...VendorConfigFragment
  }
}
    ${VendorConfigFragmentDoc}`;
export const CartEntryFragmentDoc = gql`
    fragment CartEntryFragment on CartEntries {
  _id: lineId
  lineId
  image
  isDonation
  isExtra
  name
  pickerSelections
  price
  quantity
  sanityId
  type
  url
  redeemable
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${VendorConfigsFragmentDoc}`;
export const UserOrderFragmentDoc = gql`
    fragment UserOrderFragment on Order {
  _id: rbiOrderId
  rbiOrderId
  createdAt
  updatedAt
  fireOrderIn
  status
  orderNumberFormatted
  catering {
    pickupTime
  }
  delivery {
    dropoff {
      state
    }
    feeCents
    tipCents
    feeDiscountCents
    status
    serviceFeeCents
    smallCartFeeCents
    geographicalFeeCents
  }
  cart {
    discounts {
      name
      value
    }
    fees {
      name
      priceCents
      quantity
      totalCents
    }
    ticketNumber
    storeId
    vatNumber
    serviceMode
    posVendor
    cartVersion
    donations {
      id
      name
      totalCents
    }
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    storeDetails {
      deliveryHours {
        ...StoreHoursFragment
      }
      diningRoomHours {
        ...StoreHoursFragment
      }
      driveThruHours {
        ...StoreHoursFragment
      }
      franchiseGroupName
      franchiseGroupId
      hasCatering
      hasDelivery
      hasDriveThru
      hasMobileOrdering
      lastActiveDateTime
      latitude
      longitude
      mobileOrderingStatus
      phoneNumber
      posVendor
      status
      storeNumber
      timezone
    }
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    reorderCartEntries {
      ...CartEntryFragment
      isInMenu
      children {
        ...CartEntryFragment
        isInMenu
        children {
          ...CartEntryFragment
          isInMenu
          children {
            ...CartEntryFragment
            isInMenu
            children {
              ...CartEntryFragment
              isInMenu
              children {
                ...CartEntryFragment
                isInMenu
              }
            }
          }
        }
      }
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
  fulfillmentDetails {
    pickupType
    pickupPin
    pickupReady
  }
  order {
    refund {
      primaryReason
      refundedItems {
        refundAmount
        refundQuantity
        sanityId
        type
        name
        plu
      }
      secondaryReason
      subtotal
      tax
      transactionDateTime
    }
  }
}
    ${StoreHoursFragmentDoc}
${CartEntryFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment OrderFragment on Order {
  order {
    refund {
      primaryReason
      refundedItems {
        refundAmount
        refundQuantity
        sanityId
        type
        name
        plu
      }
      secondaryReason
      subtotal
      tax
      transactionDateTime
    }
  }
  loyaltyTransaction {
    id
    pointsEarned
    bonusPointsEarned
    pointsUsed
    pointsBalance
    rewardsUsed
  }
  cart {
    customerName
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    cartVersion
    discounts {
      name
      value
    }
    donations {
      id
      name
      totalCents
    }
    fees {
      name
      priceCents
      quantity
      totalCents
    }
    offersFeedback {
      cartEntry {
        lineId
      }
      couponId
      redemptionEligibility {
        evaluationFeedback {
          code
          condition
          message
          redeemableForSeconds
          redeemableInSeconds
          ruleSetType
        }
        isRedeemable
        isValid
      }
    }
    payment {
      cardType
      ccLast4
      panToken
      paymentType
    }
    posVendor
    rewardsApplied {
      cartId
      rewardId
      timesApplied
    }
    serviceMode
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    storeDetails {
      latitude
      longitude
      storeNumber
      timezone
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
  delivery {
    pickup {
      latitude
      longitude
    }
    dropoff {
      arrivalTime
      beforeTime
      addressLine1
      addressLine2
      city
      state
      zip
      latitude
      longitude
      phoneNumber
    }
    driver {
      name
      profileImageUrl
      phoneNumber
    }
    feeCents
    feeDiscountCents
    instructions
    status
    tipCents
    serviceFeeCents
    smallCartFeeCents
    geographicalFeeCents
    quotedFeeCents
    baseDeliveryFeeCents
    deliverySurchargeFeeCents
  }
  catering {
    declineReason
    includeUtensils
    numberOfGuests
    notes
    organizerName
    pickupEmail
    pickupTime
  }
  createdAt
  updatedAt
  posOrderId
  rbiOrderId
  status
  fireOrderIn
  orderNumberFormatted
}
    ${CartEntryFragmentDoc}`;
export const PricingAndAvailabilityFragmentDoc = gql`
    fragment PricingAndAvailability on Entity {
  id
  isAvailable
  price {
    default
    max
    min
    overrides {
      key
      price
    }
  }
}
    `;
export const CaloriesFragmentDoc = gql`
    fragment Calories on Entity {
  calories {
    default
    min
    max
  }
}
    `;
export const CompleteLinkingDocument = gql`
    mutation CompleteLinking($partnerId: String!, $source: PartnerLinkSource!, $authCode: String!, $codeVerifier: String!, $singularAttribution: SingularAttributionInput) @gateway @authRequired {
  completeLinking(
    partnerId: $partnerId
    source: $source
    authCode: $authCode
    codeVerifier: $codeVerifier
    singularAttribution: $singularAttribution
  ) {
    success
  }
}
    `;
export type ICompleteLinkingMutationFn = ApolloReactCommon.MutationFunction<ICompleteLinkingMutation, ICompleteLinkingMutationVariables>;

/**
 * __useCompleteLinkingMutation__
 *
 * To run a mutation, you first call `useCompleteLinkingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLinkingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLinkingMutation, { data, loading, error }] = useCompleteLinkingMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      source: // value for 'source'
 *      authCode: // value for 'authCode'
 *      codeVerifier: // value for 'codeVerifier'
 *   },
 * });
 */
export function useCompleteLinkingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICompleteLinkingMutation, ICompleteLinkingMutationVariables>) {
        return ApolloReactHooks.useMutation<ICompleteLinkingMutation, ICompleteLinkingMutationVariables>(CompleteLinkingDocument, baseOptions);
      }
export type CompleteLinkingMutationHookResult = ReturnType<typeof useCompleteLinkingMutation>;
export type CompleteLinkingMutationResult = ApolloReactCommon.MutationResult<ICompleteLinkingMutation>;
export type CompleteLinkingMutationOptions = ApolloReactCommon.BaseMutationOptions<ICompleteLinkingMutation, ICompleteLinkingMutationVariables>;
export const GetOrderDocument = gql`
    query GetOrder($rbiOrderId: ID!) @gateway {
  order(rbiOrderId: $rbiOrderId) {
    ...OrderFragment
  }
}
    ${OrderFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      rbiOrderId: // value for 'rbiOrderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<IGetOrderQuery, IGetOrderQueryVariables>;
export const GetUserOrdersDocument = gql`
    query GetUserOrders($userId: ID, $limit: Int, $resumeAfter: String, $orderStatuses: [RbiOrderStatus!], $createdAfter: String, $shouldFilterByRegion: Boolean, $serviceModes: [ServiceMode!]) @authRequired @gateway {
  userOrders(userId: $userId, limit: $limit, resumeAfter: $resumeAfter, orderStatuses: $orderStatuses, createdAfter: $createdAfter, shouldFilterByRegion: $shouldFilterByRegion, serviceModes: $serviceModes) {
    count
    resumeAfter
    orders {
      ...UserOrderFragment
    }
  }
}
    ${UserOrderFragmentDoc}`;

/**
 * __useGetUserOrdersQuery__
 *
 * To run a query within a React component, call `useGetUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *      orderStatuses: // value for 'orderStatuses'
 *      createdAfter: // value for 'createdAfter'
 *      shouldFilterByRegion: // value for 'shouldFilterByRegion'
 *      serviceModes: // value for 'serviceModes'
 *   },
 * });
 */
export function useGetUserOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
      }
export function useGetUserOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
        }
export type GetUserOrdersQueryHookResult = ReturnType<typeof useGetUserOrdersQuery>;
export type GetUserOrdersLazyQueryHookResult = ReturnType<typeof useGetUserOrdersLazyQuery>;
export type GetUserOrdersQueryResult = ApolloReactCommon.QueryResult<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>;
export const PriceOrderDocument = gql`
    mutation PriceOrder($input: PriceOrderInput!, $delivery: PriceDeliveryInput, $catering: PriceCateringInput) @authRequired @gateway {
  priceOrder(input: $input, delivery: $delivery, catering: $catering) {
    rbiOrderId
    status
  }
}
    `;
export type IPriceOrderMutationFn = ApolloReactCommon.MutationFunction<IPriceOrderMutation, IPriceOrderMutationVariables>;

/**
 * __usePriceOrderMutation__
 *
 * To run a mutation, you first call `usePriceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceOrderMutation, { data, loading, error }] = usePriceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *      catering: // value for 'catering'
 *   },
 * });
 */
export function usePriceOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPriceOrderMutation, IPriceOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IPriceOrderMutation, IPriceOrderMutationVariables>(PriceOrderDocument, baseOptions);
      }
export type PriceOrderMutationHookResult = ReturnType<typeof usePriceOrderMutation>;
export type PriceOrderMutationResult = ApolloReactCommon.MutationResult<IPriceOrderMutation>;
export type PriceOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IPriceOrderMutation, IPriceOrderMutationVariables>;
export const CommitOrderDocument = gql`
    mutation CommitOrder($input: CommitOrderInput!, $delivery: CommitDeliveryInput, $skipCoolingPeriod: Boolean) @authRequired @gateway {
  commitOrder(input: $input, delivery: $delivery, skipCoolingPeriod: $skipCoolingPeriod) {
    rbiOrderId
    status
  }
}
    `;
export type ICommitOrderMutationFn = ApolloReactCommon.MutationFunction<ICommitOrderMutation, ICommitOrderMutationVariables>;

/**
 * __useCommitOrderMutation__
 *
 * To run a mutation, you first call `useCommitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitOrderMutation, { data, loading, error }] = useCommitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *      skipCoolingPeriod: // value for 'skipCoolingPeriod'
 *   },
 * });
 */
export function useCommitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICommitOrderMutation, ICommitOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<ICommitOrderMutation, ICommitOrderMutationVariables>(CommitOrderDocument, baseOptions);
      }
export type CommitOrderMutationHookResult = ReturnType<typeof useCommitOrderMutation>;
export type CommitOrderMutationResult = ApolloReactCommon.MutationResult<ICommitOrderMutation>;
export type CommitOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ICommitOrderMutation, ICommitOrderMutationVariables>;
export const SetRewardsRedemptionEnabledDocument = gql`
    mutation SetRewardsRedemptionEnabled($input: SetRewardsRedemptionEnabledInput!) @gateway @authRequired {
  setRewardsRedemptionEnabled(input: $input) {
    user {
      id
      rewards {
        redemption {
          isEnabled
        }
      }
    }
  }
}
    `;
export type ISetRewardsRedemptionEnabledMutationFn = ApolloReactCommon.MutationFunction<ISetRewardsRedemptionEnabledMutation, ISetRewardsRedemptionEnabledMutationVariables>;

/**
 * __useSetRewardsRedemptionEnabledMutation__
 *
 * To run a mutation, you first call `useSetRewardsRedemptionEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRewardsRedemptionEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRewardsRedemptionEnabledMutation, { data, loading, error }] = useSetRewardsRedemptionEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRewardsRedemptionEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetRewardsRedemptionEnabledMutation, ISetRewardsRedemptionEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetRewardsRedemptionEnabledMutation, ISetRewardsRedemptionEnabledMutationVariables>(SetRewardsRedemptionEnabledDocument, baseOptions);
      }
export type SetRewardsRedemptionEnabledMutationHookResult = ReturnType<typeof useSetRewardsRedemptionEnabledMutation>;
export type SetRewardsRedemptionEnabledMutationResult = ApolloReactCommon.MutationResult<ISetRewardsRedemptionEnabledMutation>;
export type SetRewardsRedemptionEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetRewardsRedemptionEnabledMutation, ISetRewardsRedemptionEnabledMutationVariables>;
export const RewardRedemptionDetailsDocument = gql`
    query RewardRedemptionDetails @gateway @authRequired {
  me {
    id
    rewards {
      redemption {
        isEnabled
      }
    }
  }
}
    `;

/**
 * __useRewardRedemptionDetailsQuery__
 *
 * To run a query within a React component, call `useRewardRedemptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRewardRedemptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRewardRedemptionDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRewardRedemptionDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IRewardRedemptionDetailsQuery, IRewardRedemptionDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<IRewardRedemptionDetailsQuery, IRewardRedemptionDetailsQueryVariables>(RewardRedemptionDetailsDocument, baseOptions);
      }
export function useRewardRedemptionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IRewardRedemptionDetailsQuery, IRewardRedemptionDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IRewardRedemptionDetailsQuery, IRewardRedemptionDetailsQueryVariables>(RewardRedemptionDetailsDocument, baseOptions);
        }
export type RewardRedemptionDetailsQueryHookResult = ReturnType<typeof useRewardRedemptionDetailsQuery>;
export type RewardRedemptionDetailsLazyQueryHookResult = ReturnType<typeof useRewardRedemptionDetailsLazyQuery>;
export type RewardRedemptionDetailsQueryResult = ApolloReactCommon.QueryResult<IRewardRedemptionDetailsQuery, IRewardRedemptionDetailsQueryVariables>;
export const StoreMenuDocument = gql`
    query storeMenu($region: String!, $channel: Channel!, $storeId: ID!, $serviceMode: PosDataServiceMode) @gateway @useCache {
  storeMenu(region: $region, channel: $channel, storeId: $storeId, serviceMode: $serviceMode) {
    ...PricingAndAvailability
    ...Calories
  }
}
    ${PricingAndAvailabilityFragmentDoc}
${CaloriesFragmentDoc}`;

/**
 * __useStoreMenuQuery__
 *
 * To run a query within a React component, call `useStoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreMenuQuery({
 *   variables: {
 *      region: // value for 'region'
 *      channel: // value for 'channel'
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *   },
 * });
 */
export function useStoreMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, baseOptions);
      }
export function useStoreMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, baseOptions);
        }
export type StoreMenuQueryHookResult = ReturnType<typeof useStoreMenuQuery>;
export type StoreMenuLazyQueryHookResult = ReturnType<typeof useStoreMenuLazyQuery>;
export type StoreMenuQueryResult = ApolloReactCommon.QueryResult<IStoreMenuQuery, IStoreMenuQueryVariables>;
export const InitiateLinkingDocument = gql`
    mutation InitiateLinking($partnerId: String!, $source: PartnerLinkSource!, $singularAttribution: SingularAttributionInput) @gateway @authRequired {
  initiateLinking(
    partnerId: $partnerId
    source: $source
    singularAttribution: $singularAttribution
  ) {
    oidcAuthUrl
  }
}
    `;
export type IInitiateLinkingMutationFn = ApolloReactCommon.MutationFunction<IInitiateLinkingMutation, IInitiateLinkingMutationVariables>;

/**
 * __useInitiateLinkingMutation__
 *
 * To run a mutation, you first call `useInitiateLinkingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateLinkingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateLinkingMutation, { data, loading, error }] = useInitiateLinkingMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useInitiateLinkingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IInitiateLinkingMutation, IInitiateLinkingMutationVariables>) {
        return ApolloReactHooks.useMutation<IInitiateLinkingMutation, IInitiateLinkingMutationVariables>(InitiateLinkingDocument, baseOptions);
      }
export type InitiateLinkingMutationHookResult = ReturnType<typeof useInitiateLinkingMutation>;
export type InitiateLinkingMutationResult = ApolloReactCommon.MutationResult<IInitiateLinkingMutation>;
export type InitiateLinkingMutationOptions = ApolloReactCommon.BaseMutationOptions<IInitiateLinkingMutation, IInitiateLinkingMutationVariables>;
export const VaultCreditAccountDocument = gql`
    mutation vaultCreditAccount($input: VaultCreditAccountInput!) @gateway @authRequired {
  vaultCreditAccount(input: $input) {
    id
  }
}
    `;
export type IVaultCreditAccountMutationFn = ApolloReactCommon.MutationFunction<IVaultCreditAccountMutation, IVaultCreditAccountMutationVariables>;

/**
 * __useVaultCreditAccountMutation__
 *
 * To run a mutation, you first call `useVaultCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVaultCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vaultCreditAccountMutation, { data, loading, error }] = useVaultCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVaultCreditAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IVaultCreditAccountMutation, IVaultCreditAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<IVaultCreditAccountMutation, IVaultCreditAccountMutationVariables>(VaultCreditAccountDocument, baseOptions);
      }
export type VaultCreditAccountMutationHookResult = ReturnType<typeof useVaultCreditAccountMutation>;
export type VaultCreditAccountMutationResult = ApolloReactCommon.MutationResult<IVaultCreditAccountMutation>;
export type VaultCreditAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<IVaultCreditAccountMutation, IVaultCreditAccountMutationVariables>;
export const GiftCardLoadDocument = gql`
    mutation GiftCardLoad($input: GiftCardLoadInput!) @gateway @authRequired {
  giftCardLoad(input: $input) {
    user {
      id
      giftCardLoadAmount
      accounts {
        prepaid {
          currentBalance
        }
      }
    }
  }
}
    `;
export type IGiftCardLoadMutationFn = ApolloReactCommon.MutationFunction<IGiftCardLoadMutation, IGiftCardLoadMutationVariables>;

/**
 * __useGiftCardLoadMutation__
 *
 * To run a mutation, you first call `useGiftCardLoadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftCardLoadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftCardLoadMutation, { data, loading, error }] = useGiftCardLoadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardLoadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IGiftCardLoadMutation, IGiftCardLoadMutationVariables>) {
        return ApolloReactHooks.useMutation<IGiftCardLoadMutation, IGiftCardLoadMutationVariables>(GiftCardLoadDocument, baseOptions);
      }
export type GiftCardLoadMutationHookResult = ReturnType<typeof useGiftCardLoadMutation>;
export type GiftCardLoadMutationResult = ApolloReactCommon.MutationResult<IGiftCardLoadMutation>;
export type GiftCardLoadMutationOptions = ApolloReactCommon.BaseMutationOptions<IGiftCardLoadMutation, IGiftCardLoadMutationVariables>;
export const SetGiftCardReloadAccountDocument = gql`
    mutation SetGiftCardReloadAccount($input: SetGiftCardReloadAccountInput!) @gateway @authRequired {
  setGiftCardReloadAccount(input: $input) {
    user {
      giftCardReloadAccount {
        id
      }
    }
  }
}
    `;
export type ISetGiftCardReloadAccountMutationFn = ApolloReactCommon.MutationFunction<ISetGiftCardReloadAccountMutation, ISetGiftCardReloadAccountMutationVariables>;

/**
 * __useSetGiftCardReloadAccountMutation__
 *
 * To run a mutation, you first call `useSetGiftCardReloadAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGiftCardReloadAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGiftCardReloadAccountMutation, { data, loading, error }] = useSetGiftCardReloadAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGiftCardReloadAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ISetGiftCardReloadAccountMutation, ISetGiftCardReloadAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<ISetGiftCardReloadAccountMutation, ISetGiftCardReloadAccountMutationVariables>(SetGiftCardReloadAccountDocument, baseOptions);
      }
export type SetGiftCardReloadAccountMutationHookResult = ReturnType<typeof useSetGiftCardReloadAccountMutation>;
export type SetGiftCardReloadAccountMutationResult = ApolloReactCommon.MutationResult<ISetGiftCardReloadAccountMutation>;
export type SetGiftCardReloadAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<ISetGiftCardReloadAccountMutation, ISetGiftCardReloadAccountMutationVariables>;
export const GetPrepaidsBalanceDocument = gql`
    mutation GetPrepaidsBalance($cardNumber: String!, $feCountryCode: IsoCountryCode!, $pin: String) @authRequired @gateway(flag: "enable-gateway-getPrepaidsBalance") {
  prepaidsBalance(cardNumber: $cardNumber, feCountryCode: $feCountryCode, pin: $pin) {
    currentBalance
  }
}
    `;
export type IGetPrepaidsBalanceMutationFn = ApolloReactCommon.MutationFunction<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>;

/**
 * __useGetPrepaidsBalanceMutation__
 *
 * To run a mutation, you first call `useGetPrepaidsBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPrepaidsBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPrepaidsBalanceMutation, { data, loading, error }] = useGetPrepaidsBalanceMutation({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *      feCountryCode: // value for 'feCountryCode'
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useGetPrepaidsBalanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>) {
        return ApolloReactHooks.useMutation<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>(GetPrepaidsBalanceDocument, baseOptions);
      }
export type GetPrepaidsBalanceMutationHookResult = ReturnType<typeof useGetPrepaidsBalanceMutation>;
export type GetPrepaidsBalanceMutationResult = ApolloReactCommon.MutationResult<IGetPrepaidsBalanceMutation>;
export type GetPrepaidsBalanceMutationOptions = ApolloReactCommon.BaseMutationOptions<IGetPrepaidsBalanceMutation, IGetPrepaidsBalanceMutationVariables>;

export type IGetCommunicationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetCommunicationPreferencesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename: 'User', readonly id: string, readonly communicationPreferences?: Maybe<{ readonly __typename: 'CommunicationPreferences', readonly emailOptIn?: Maybe<boolean>, readonly pushOptIn?: Maybe<boolean>, readonly thirdPartyDataSharingOptIn?: Maybe<boolean>, readonly language: CommunicationLanguage }> } };

export type IUpdateCommunicationPreferencesMutationVariables = Exact<{
  input: ICommunicationPreferencesUpdateInput;
}>;


export type IUpdateCommunicationPreferencesMutation = { readonly __typename?: 'Mutation', readonly communicationPreferencesUpdate?: Maybe<{ readonly __typename?: 'CommunicationPreferencesUpdatePayload', readonly user?: Maybe<{ readonly __typename?: 'User', readonly id: string }>, readonly userErrors: ReadonlyArray<{ readonly __typename?: 'UserError', readonly field?: Maybe<ReadonlyArray<string>>, readonly message: string }> }> };

export const GetCommunicationPreferencesDocument = gql`
    query GetCommunicationPreferences @authRequired @gateway {
  me {
    __typename
    id
    communicationPreferences {
      __typename
      emailOptIn
      pushOptIn
      thirdPartyDataSharingOptIn
      language
    }
  }
}
    `;

/**
 * __useGetCommunicationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetCommunicationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunicationPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetCommunicationPreferencesQuery, IGetCommunicationPreferencesQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetCommunicationPreferencesQuery, IGetCommunicationPreferencesQueryVariables>(GetCommunicationPreferencesDocument, baseOptions);
      }
export function useGetCommunicationPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetCommunicationPreferencesQuery, IGetCommunicationPreferencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetCommunicationPreferencesQuery, IGetCommunicationPreferencesQueryVariables>(GetCommunicationPreferencesDocument, baseOptions);
        }
export type GetCommunicationPreferencesQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesQuery>;
export type GetCommunicationPreferencesLazyQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesLazyQuery>;
export type GetCommunicationPreferencesQueryResult = ApolloReactCommon.QueryResult<IGetCommunicationPreferencesQuery, IGetCommunicationPreferencesQueryVariables>;
export const UpdateCommunicationPreferencesDocument = gql`
    mutation UpdateCommunicationPreferences($input: CommunicationPreferencesUpdateInput!) @authRequired @gateway {
  communicationPreferencesUpdate(input: $input) {
    user {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type IUpdateCommunicationPreferencesMutationFn = ApolloReactCommon.MutationFunction<IUpdateCommunicationPreferencesMutation, IUpdateCommunicationPreferencesMutationVariables>;

/**
 * __useUpdateCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunicationPreferencesMutation, { data, loading, error }] = useUpdateCommunicationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunicationPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUpdateCommunicationPreferencesMutation, IUpdateCommunicationPreferencesMutationVariables>) {
        return ApolloReactHooks.useMutation<IUpdateCommunicationPreferencesMutation, IUpdateCommunicationPreferencesMutationVariables>(UpdateCommunicationPreferencesDocument, baseOptions);
      }
export type UpdateCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdateCommunicationPreferencesMutation>;
export type UpdateCommunicationPreferencesMutationResult = ApolloReactCommon.MutationResult<IUpdateCommunicationPreferencesMutation>;
export type UpdateCommunicationPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<IUpdateCommunicationPreferencesMutation, IUpdateCommunicationPreferencesMutationVariables>;